import React, { Component, useState, forwardRef } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  OverlayTrigger,
  Tooltip,
  Table,
  Modal,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import axios from "axios";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Collapsible from "react-collapsible";
import Switch from "react-switch";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Pdf from "../../../assets/img/pdf.svg";
import {
  updateQuote,
  getpagewiseHealthcondition,
  GetAllSuppliers,
  checkMedication,
  get_single_lead_data,
  searchMedicationForOrder,
  searchMedicationUsingBarcodeForOrder,
  getCity,
  getMedicationcategory,
  AddMedication,
  getCountry,
  getMedication,
  getcitywiseMedication,
  get_lead_old_data,
  getOrderById,
  getOrdersbyid,
  getmedicationdatabyid,
  searchlastsubscription,
  EditOrder,
  oDocApiCall,
  DownloadOrder,
  getSalesRepresentative,
  SendQuote,
  getremaincreditforleaduser,
  getallCurrier,
  getallmedicationpackages,
  Get_Settings,
  getAvailableCreditsByLeads,
  updateOrdersRider,
  updatepaymentinfo,
  getPolicyDetailsByPackgeId,
  GetClaimFamilyDetails,
  updateOrderStatus,
  CreateCreditNote,
  updateMedication_old_data,
  getAllUtilData,
  getRemainingCredits,
  allocationValuePopUp,
  submitInsuremeClaimRequest,
  insuremeUploadDocument,
  downloadOrderPdf,
  completeOrderStatus,
  getAllMedication,
  getOrderWiseComment,
  storeOrderComment,
  deleteOrderWiseComment,
  getStatusLogsByOrderId,
  getAllUsersWithOutPagination,
  createAddress,
  checkFirstOrder,
  uploadOrderDocument,
  deleteOrderDocument,
} from "../../../Listfunction";
import DateRangePicker from "react-daterange-picker";
import Datetime from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import LoadingSpinner from "views/Components/loadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import LoadingOrder from "views/Components/loadingOrder";
import "../../../assets/css/qtyFieldiconremove.css";
import LoadingMedication from "views/Components/loadingMedication";
import { Collapse } from "react-collapse";
import TagsInput from "react-tagsinput";
import ScreenLoader from "views/Components/screenLoader";
import "react-tagsinput/react-tagsinput.css";
import CommentSection from "components/CommentSection/CommentSection.jsx";

import originalMoment from "moment";
import { extendMoment } from "moment-range";
import CreditNoteModal from "./creditNoteModal/creditNoteModal";
import { getFileExtensionFromMimeType } from "utils/getFileExtensionFromMimeType";
import OutOfStockModal from "./outOfStockModal";
import CreateAddressModal from "components/AddressModal/createAddressModal";
import DocumentUploadModal from "./addDocumentModal";
const moment = extendMoment(originalMoment);

const ForwardedFormControl = forwardRef((props, ref) => (
  <input {...props} ref={ref} />
));

class editOrder extends Component {
  constructor(props) {
    super(props);
    const today = moment();
    this.state = {
      customAddressError: null,
      customAddress: "",
      is_abusable_url: "",
      showOutOfStock: false,
      name: "",
      coordinates: "",
      subscribername: "",
      selectedSubscriberName: "",
      typing: false,
      typingTimeout: 0,
      selectedmedication: "",
      selectedSubscriber: "",
      selectedFile: [],
      processing: true,
      subscriber_detail: [],
      ordernote: null,
      coupon_title: "",
      coupon_discountamount: "0.00",
      coupon_use_text: "",
      // source : '1',
      // delivery_type : '1',
      country_detail: [],
      newmargin: "",
      avalable_flash_point: "",
      contentLoading: true,
      medication_detail: [],
      addmedicationdetailform: [],
      subscriber: "0",
      subscriberError: null,
      opharmareferance: "",
      mypharmareferance: "",
      sales_rep: "",
      sales_rep_data: [],
      sales_details: [],
      mypharmareferanceError: null,
      opharmareferanceError: null,
      prescription: "",
      priscriptionurl: [],
      priscriptionurlError: null,
      documenturl: [],
      documenturlError: null,
      orderdate: new Date(),
      paymentduedate: new Date(),
      notedisplay: false,
      ordernotedisplay: false,
      prescription_note: "",
      pdfDownloadUrl: "",
      pdfFile: null,
      prescription_text: "",
      source: "1",
      medicationItems: [],
      srno: "",
      description: "",
      unitprice: "",
      quantity: "",
      subtotal: "",
      discount_used: "",
      is_flash_point: "0",
      basketvalue: "0.00",
      deliverytype: "1",
      deliverycharge: "",
      deliverychargeError: null,
      totalcost: "0.00",
      totalcostError: null,
      lastsubscriptionorder: "",
      lastsubscriptionorderError: null,
      loading: false,
      username: "",
      useremail: "",
      userphone: "",
      usermobile: "",
      discountamount: 0,
      name: "",
      nameError: null,
      mobileno: "",
      mobilenoError: null,
      status: "1",
      orderStatusLabel: "",
      statusError: null,
      phoneno: "",
      phonenoError: null,
      email: "",
      emailError: null,
      addressline1: "",
      addressline1Error: null,
      addressline2: "",
      locationCoordinates: "",
      city: "0",
      cityError: null,
      postalcode: "",
      postalcodeError: null,
      locationCoordinatesError: null,
      country: "1",
      countryError: null,
      latiAndLogitError: null,
      addressTypeError: null,
      addressType: "",
      orderdetail: [],
      address_form_data: [],
      order_form_detail: [],
      inputList: [],
      companyname: "",
      discount: 0,
      companynote: "",
      _notificationSystem: null,
      cardHidden: true,
      leadid: "",
      lastsubscription: [],
      showModal: false,
      subscriptiondetail: [],
      medicationdata: [],
      quanitydata: [],
      addressdata: [],
      noRecordFound: false,
      address_id: "",
      addressaccess: "0",
      addressradio: "",
      medicationdataList: [],
      alert: null,
      medicationaddError: null,
      marginmodal: false,
      discountmodal: false,
      isCreditNoteModalOpen: null,
      prescriptionmodal: false,
      margintype: "1",
      discountpercentage: 0,
      marginpercentage: 0,
      marginamount: 0,
      b2borganizationdiscount: 0,
      showmediactonModal: false,
      medicationitemcode: "",
      medicationitemcodeError: null,
      medicationdescription: "",
      medicationdescriptionError: null,
      medicationcategory: "0",
      medicationis_featured: "2",
      medicationcategoryError: null,
      medicationunitprice: "",
      medicationunitpriceError: null,
      medicationaddcommision: "1",
      medicationitemname: "",
      medicationitemnameError: null,
      medicationcity: "0",
      medicationcityError: null,
      medicationprice: 0,
      category_detail: [],
      marginfinalamount: 0,
      dynamicfinalpercentage: 0,
      city_info: [],
      b2baccess: 0,
      displaymarginamount: "",
      displaymarginpercentage: "",
      errormessages: [],
      medicationerrormessage: [],
      addnewaddress: false,
      healthcondition: null,
      healthconditionItems: [],
      healthconditiondetails: [],
      paymentoption: null,
      paymentoptionError: null,
      medicationloading: true,
      rider_id: null,
      currier_id: null,
      is_currier: null,
      tracking_id: null,
      tracking_url: null,
      tracking_note: null,
      occupation: "",
      rider_idError: null,
      rider_details: [],
      rider_data: [],
      currier_data: [],
      deleteditems: [],
      channel: "",
      request_quote_notification: null,
      quotenotification: null,
      used_credit_point: null,
      credit_being_use: null,
      alertquote: null,
      order_status: "",
      not_get_medicine: "",
      referenceNote: "",
      expressDeliveryChargeValue: "",
      standardDeliveryChargeValue: "",
      islandWideDeliveryChargeValue: "",
      quantity: "",
      barcode: "",
      is_flash_medicine: "",
      suppliersData: [],
      supplier: "",
      codeDisabled: "",
      currier_disabled: "yes",
      package_image_data: [],
      packageImageError: null,
      package_image: [],
      packageitemdetails: [],
      packageitem: null,
      packageitemoptiondetails: [],
      primaryimage: "",
      tags: [],
      order_type: "1",
      delivery_from_date: "",
      delivery_to_date: "",
      datarange: moment.range(today.clone(), today.clone().add(7, "days")),
      isdatepickeron: false,
      isLoading: false,
      item_type: "1",
      packageItems: [],
      labpackage: [],
      catalougepackageId: null,
      catalougepackagename: null,
      catPackageDiscount: 0,
      catPackageDiscountAmount: 0,
      packagefeatures: [],
      isDeliveryCharge: false,
      is_LeadB2B: "",
      first_address: "",
      sub_orderType: false,
      po_number: "",
      po_document: [],
      grn_document: [],
      GRNDocUrl: [],
      PNdocUrl: [],
      medicineCheckedValue: [],
      isAllChecked: false,
      log0_1: "",
      deliveryTypeDisabled: false,
      originalFeatureValue: [],
      package_delivery_discount: false,
      policyType: "",
      cataloguePackageId: "",
      ClaimPolicyDetails: "",
      userData: "",
      StoreManager: "",
      store: "",
      sourceOptions: [
        { value: "1", label: "Flash" },
        { value: "2", label: "oPharma" },
        { value: "3", label: "MyPharma" },
        { value: "4", label: "Daraz" },
        { value: "5", label: "Pickme" },
        { value: "6", label: "E-channeling" },
        { value: "7", label: "Uber" },
        { value: "8", label: "Heart 2 Heart" },
        { value: "9", label: "Vida" },
        { value: "10", label: "PetDoc" },
        { value: "11", label: "LankaRemit" },
        { value: "13", label: "LiweCommunities" },
        { value: "15", label: "Delta" },
      ],
      deliveryTypeOptions: [
        { value: "1", label: "Normal" },
        { value: "2", label: "Express" },
        { value: "3", label: "Island Wide" },
        { value: "4", label: "Pick Up" },
        { value: "5", label: "Galle" },
      ],
      deliveryTypeOptionsB2C: [
        { value: "1", label: "Normal" },
        { value: "2", label: "Express" },
        { value: "3", label: "Island Wide" },
        { value: "5", label: "Galle" },
      ],

      isClaimableOrder: "",
      claimableValue: 0,
      availableTotalClaimCredits: 0,
      claimCreditType: 0,
      isOutOfStock: false,
      quantityMissMatchValidationData: [],
      tokenDetails: { token: JSON.parse(localStorage.getItem("user")) },
      isWrongQuantity: false,
      wrongFieldId: "",
      isPolicyDisabled: true,
      isClaimConfirmationModalOpen: false,
      unClaimableMedicineList: [],
      flashreference: "",
      familyDetails: "",
      isPendingOrder: false,
      // refillableOrder:false,
      refillableOrder: false,
      //ispaywarning: false,
      isdaterangepickerOpen: false,
      delivery_from_dates: "",
      created_At: "",
      delivery_to_dates: "",
      isOpenItemPendingModal: false,
      isOpenRiderModal: false,
      showAllocatedValue: false,
      isCurrier: false,
      selectedRider: {},
      selectedRiderError: null,
      currierData: [],
      selectedCurrier: {},
      selectedCurrierError: null,
      currierTrackingId: "",
      currierTrackingUrl: "",
      currierTrackingNote: "",
      isChecked: false,
      viewMedDetails: true,
      submitButtonDisable: false,
      pdfloading: false,
      submitButtonText: "Submit",
      isItemPedingDateRangePickerOpen: false,
      isItemPendingDatePickerOn: false,
      trackIsChangedOrderItemValues: [],
      creditNoteData: null,
      // creditNoteStatus: "", important
      // creditNoteStatusError: null, important
      isPartialOrder: false,
      isPartialOrderItem: false,
      getPartialOrder: false,
      // orderHasCreditNote: false,
      item_description: "",
      selling_price: "",
      unit_price: "",
      getPartialOrder: false,
      leadWalletData: [],
      allocatedData: [],
      remainingCredit: 0,
      isAbusableOrder: false,
      is_printable: false,
      is_order_placed: false,
      itemPendingDaterange: moment.range(
        today.clone(),
        today.clone().add(7, "days"),
      ),
      isOverQuantity: "",
      isPackageHasClaimMedicineAllowed: false,
      isInsureme: false,
      insuremeBannerText: null,
      insuremePolicy:
        '<p><span style="font-size: 16px;"><strong>As mentioned in the restricted medicine details below, these related medicines can\'t be provided to any insureme users.</strong></span></p>\n<ul>\n<li>Vitamins.</li>\n<li>Ayurvedic Treatments related medicines.</li>\n<li>Medicines related to infertility, sub-fertility, sterility.</li>\n<li>Medicines related to self-infliction, recklessness, , insanity, psychological or mental disorder and sleeping disorders.</li>\n<li>Medicines related to narcotic addiction.</li>\n<li>Medicines related to Dental.</li>\n<li>All Kind of Supplements and Milk Powders.</li>\n<li>Medicines related to cosmetic reasons.</li>\n<li>Medicines related to birth control treatments.</li>\n<li>Medicines related to obesity, anti-aging therapy.</li>\n<li>Medicines related to Venereal Disease (VD), Sexually Transmitted Disease (STD).</li>\n<li>Medicines related to Orthopedic Treatments and Rehabilitation &amp; Physiotherapy Treatment.</li>\n<li>All Healthcare Instruments including Scales Stethoscopes , Thermometer , Heart Detector , Blood Sugar Testing Machine ,Blood Pressure Monitor, Body Sculpting equipment etc .</li>\n</ul>',
      insuremeValidation: {
        nameAvailable: false,
        medicationCover: false,
        validityPeriod: false,
        claimHolderName: false,
        doctorSeal: false,
        familyClaim: false,
        signatureAvailable: false,
        dateAvailable: false,
        checkQuantity: false,
        checkPrice: false,
      },
      insuremeValidationErrors: {
        nameAvailableError: null,
        medicationCoverError: null,
        validityPeriodError: null,
        claimHolderNameError: null,
        doctorSealError: null,
        signatureAvailableError: null,
        dateAvailableError: null,
        checkQuantityError: null,
        checkPriceError: null,
      },
      insuremeDetails: [],
      originPackageId: null,
      insuremeClaimableTotal: null,
      insuremeOrderButtonDisabled: false,
      previousPaymentOption: null,
      openOutOfStockModal: false,
      outOfStockMedicineDetails: [],
      disablePaymentOption: false,
      disableRemoveOrderItem: false,
      temporaryInvoices: [],
      medicationListing: [],
      showOutOfStockPop: false,
      medicationOptions: [],
      localMedicationData: [],
      getUnavalibleCost: "",
      paymentOption: "",
      getOrderChannel: "",
      selectedRiderObject: null,
      comments: [],
      newComment: "",
      commentError: null,
      UserListData: [],
      hasCommentId: "",
      isPromotionOrder: false,
      isCreateAddressModalOpen: false,
      billing_address_id: "",
      billing_city_id: "",
      first_billing_address: "",
      addressModalType: "",
      isBillingSame: false,
      getSubOrderTypePr: "",
      pr_id: "",
      getStores: "",
      isFirstOrder: false,
      orderDocument: [],
      isUploadDocumentModalOpen: false,
      selectedDocumentType: "",
      selectedDocument: [],
      documentError: null,
      selectedDocumentTypeError: null,
      choosedDocument: [],
    };
    this.inputRef = React.createRef();
    this.barcodeInputRef = React.createRef();
    this.medSearchCache = {};
    this.medSearchRequestSeq = 0;
    this._loadMedTimer = null;
    this.medIndex = [];
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handledate = this.handledate.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handlebasketandsubtotal = this.handlebasketandsubtotal.bind(this);
    this.subdetail = this.subdetail.bind(this);
    this.lastorderdetail = this.lastorderdetail.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handlePOFileChange = this.handlePOFileChange.bind(this);
    this.handleGRNFileChange = this.handleGRNFileChange.bind(this);
    this.medicationChange = this.medicationChange.bind(this);
    this.medication_item_code_error = React.createRef();
    this.warningChangeAddress = this.warningChangeAddress.bind(this);
    this.warningAddAddress = this.warningAddAddress.bind(this);
    this.message_error = React.createRef();
    this.checkpatient = this.checkpatient.bind(this);
    this.oncheckquote = this.oncheckquote.bind(this);
    this.isFalshMedicine = this.isFalshMedicine.bind(this);
    this.confirmUpdate = this.confirmUpdate.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.handleAddComment = this.handleAddComment.bind(this);
    this.handleDeleteComment = this.handleDeleteComment.bind(this);
    // this.Remaining = this.Remaining(this);
    // this.handledynamic = this.handledynamic.bind(this);
    // this.handleaddinput = this.handleaddinput.bind(this);
  }

  currier_details = [{ value: "1", label: "PromptXP" }];

  isFalshMedicine = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    this.setState({ is_flash_medicine: checked });
  };
  isCurrier = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ currier_disabled: "no" });
    } else {
      this.setState({ currier_disabled: "yes" });
    }
    this.setState({ is_currier: checked });
  };

  handleCommentChange(e) {
    this.setState({ newComment: e.target.value, commentError: null });
  }

  async handleAddComment(comment) {
    try {
      const token = JSON.parse(localStorage.getItem("user")) || {};
      const auth = token && token.token;
      if (!auth) {
        this.setState({ commentError: "Not authenticated" });
        return;
      }
      const orderId = this.props.match.params.id;
      const type = "medicine";
      const payload = {
        order_id: orderId,
        type: type,
        comment: comment && comment.text ? comment.text : "",
        assigned_id: this.state.mentionedUsers
          ? this.state.mentionedUsers.map((u) => u.id)
          : [],
      };
      await storeOrderComment(auth, payload);
      await this.loadOrderComments();
      await this.getStatusLogs();
    } catch (err) {
      console.error("Failed to post comment", err);
      this.setState({ commentError: "Unable to post comment" });
    }
  }

  handleDeleteComment = async (commentId) => {
    try {
      const token = JSON.parse(localStorage.getItem("user")) || {};
      const auth = token && token.token;
      if (!auth) {
        this.setState({ commentError: "Not authenticated" });
        return;
      }

      await deleteOrderWiseComment(auth, commentId);
      this.setState((prevState) => ({
        comments: prevState.comments.filter((c) => c.id !== commentId),
      }));
      await this.loadOrderComments();
      await this.getStatusLogs();
    } catch (err) {
      console.error("Failed to delete comment", err);
      this.setState({ commentError: "Unable to delete comment" });
    }
  };
  checkpatient(e) {
    var checked = e.target.checked;

    this.setState({ quotenotification: checked });
  }
  checkRefillableOrder(e) {
    var checked = e.target.checked;
    this.setState({ refillableOrder: checked });
  }
  handleDateChange = (date) => {
    this.setState({
      orderdate: date,
    });
  };
  handlePaymentDueDate = (date) => {
    this.setState({ paymentduedate: date });
  };
  upload() {
    document.getElementById("selectImage").click();
  }

  medicationChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  serial = 1;
  async getSerial(indx) {
    let serial = indx + 1;
    return serial;
  }

  handleAddMultipleClick = (count) => {
    const inputListLength = this.state.inputList.length;
    const newItems = [];

    for (let i = 0; i < count; i++) {
      newItems.push({
        id: moment().valueOf() + i,
        srno: inputListLength + i + 1,
        description: "",
        unitprice: "",
        newmargin: "",
        item_type: "1",
        margin_discount_percentage: 0,
        margin_discount_sub_type: 2,
        quantity: 1,
        subtotal: 0,
        medicationItems: [],
        selectmedication: "",
        availableQuantity: 0,
        orderItemNumber: 0,
        isChecked: false,
        isUpSeller: false,
        isPartialOrderItem: true,
        item_description: "",
        selling_price: "",
        unit_price: "",
        is_printable: false,
        total_allocated: 0,
        is_order_placed: false,
      });
    }
    const previousLength = this.state.inputList.length;
    this.setState({ inputList: [...this.state.inputList, ...newItems] }, () => {
      const firstNewIndex = previousLength;
      if (
        this.inputRef.current &&
        this.inputRef.current[firstNewIndex] &&
        this.inputRef.current[firstNewIndex].focus
      ) {
        this.inputRef.current[firstNewIndex].focus();
      }
    });
    // this.setState({ inputList: [...this.state.inputList, ...newItems] }, () => {
    //   if (this.barcodeInputRef.current) {
    //     this.barcodeInputRef.current.focus();
    //   }
    // });
  };

  // handleAddClick = async () => {
  //   const disableAddMedicineButton = [3, 4, 8].includes(
  //     Number(this.state.status)
  //   );
  //   if (!!disableAddMedicineButton) {
  //     this.setState({
  //       alert: (
  //         <SweetAlert
  //           className="order_alert"
  //           style={{ display: "block", marginTop: "-100px" }}
  //           onConfirm={() => this.hideAlert()}
  //           onCancel={() => this.hideAlert()}
  //           confirmBtnBsStyle="info"
  //         >
  //           <h4>Please change order status to processing and add medines.</h4>
  //         </SweetAlert>
  //       ),
  //     });
  //   } else {
  //     if (this.state.inputList.length === 0) {
  //       this.serial = 1;
  //     }
  //     let orderItemCount = this.state.inputList.length;
  //     this.setState(
  //       {
  //         inputList: [
  //           ...this.state.inputList,
  //           {
  //             srno: await this.getSerial(orderItemCount),
  //             id: moment().valueOf(),
  //             description: "",
  //             unitprice: "",
  //             newmargin: "",
  //             item_type: "1",
  //             margin_discount_sub_type: 2,
  //             margin_discount_percentage: 0,
  //             OItemdiscountType: "1",
  //             quantity: 1,
  //             subtotal: 0,
  //             is_changed: 0,
  //             // availableQuantity: "",
  //             orderItemNumber: 0,
  //             quantity_type: 0,
  //             quantity_per_box: "",
  //             discount_used: "",
  //             isChecked: false,
  //             isOldMedicine: false,
  //             claimableValue: 0,
  //             medi_itemcode: "",
  //             medi_title: "",
  //             isUpSeller: false,
  //             // isPartialOrder: false,
  //             isPartialOrderItem: true,
  //             item_description: "",
  //             selling_price: "",
  //             unit_price: "",
  //             availableQuantity: 0,
  //             total_allocated: 0,
  //             medicineData: {},
  //             // is_printable:false,

  //             // actualAllocated: 0,
  //           },
  //         ],
  //       },
  //       () => {
  //         if (this.barcodeInputRef.current) {
  //           this.barcodeInputRef.current.focus();
  //         }
  //       }
  //     );
  //   }
  // };
  handledate = (event) => {};
  clearInputList() {
    this.setState({ inputList: [] }); //empty exitsing medictaion list
    this.serial = 1;
    this.setState({
      addressaccess: "1",
      addressline2: "",
      addressline1: "",
      alert: null,
      city: "0",
      postalcode: "",
      country: "0",
      medicationItems: [],
      medication_detail: [],
      cityError: null,
      countryError: null,
      addnewaddress: true,
      latitude: "",
      longitude: "",
      addressType: "",
      latiAndLogitError: null,
    });
  }

  async handleCountryDetailsData() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    await getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });
  }

  async addanother() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    // await this.handleCityDetailsData();
    // await this.handleCountryDetailsData();

    this.setState({
      addressaccess: "1",
      address_id: "0",
      addnewaddress: true,
      addressline2: this.state.addressline2,
      addressline1: this.state.addressline1,
      city: this.state.city,
      postalcode: this.state.postalcode,
      country: this.state.country,
    });
    this.handlebasketandsubtotal();
  }

  onSelect = (datarange, states) => {
    this.setState({
      datarange,
      states,
      isdatepickeron: !this.state.isdatepickeron,
      delivery_from_date: this.state.datarange.start.format("YYYY-MM-DD"),
      delivery_to_date: this.state.datarange.end.format("YYYY-MM-DD"),
    });
  };

  onToggle = () => {
    this.setState({ isdatepickeron: !this.state.isdatepickeron });
  };

  handleAddressSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Address</b> - Created Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Order</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleGetAllMedication = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const store = token.store_id;

    await getAllMedication(obj, store)
      // .then((response) => response.json())
      .then((response) => {
        const mdata = response.data;
        const medicationOptions = mdata.map((medication) => ({
          value: medication.id,
          label: `${medication.title} (${medication.item_code})`,
        }));
        this.setState({ medicationOptions: medicationOptions });
        this.setState({ localMedicationData: mdata }, () => {
          if (
            this.state.localMedicationData &&
            this.state.localMedicationData.length > 0
          ) {
            this.buildMedIndex(this.state.localMedicationData);
          }
        });
      });
  };
  getAllUserList = async () => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    try {
      const res = await getAllUsersWithOutPagination(obj);
      const data = res.data;
      const UserListData =
        data &&
        data.map((user) => {
          return {
            value: user.id,
            label: user.name,
            email: user.email,
            role: user.role,
          };
        });
      this.setState({ UserListData: UserListData });
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  async componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const commentIdParam = searchParams.get("commentId");
    const hasCommentId = !!commentIdParam;

    this.isPendingOrder = false;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      userData: token,
      StoreManager: token.role,
      store: token.store_id,
      hasCommentId: hasCommentId,
    });

    this.claimableTotal = 0;
    await this.handleGetAllMedication();
    await this.handleOrderByIdData();
    await this.handleCityDetailsData();
    await this.handleCountryDetailsData();
    await this.Remaining();
    await this.getAllUserList();

    this.handleb2bdetails();
    await this.handleUtilData();

    // await this.handleHealthConditionData();
    // await this.handleMedicationPackagesData();
    // await this.handleMedicationCategoryData();
    // Get_Settings(obj).then((res) => {
    //   this.setState({ DeliveryChargeValues: res.data.data });
    // });

    this.setState({ isPolicyDisabled: false });
    this.handlebasketandsubtotal();
    this.getUnavailableCost();
    // await this.getavailableClaimCredit();
    await this.handleClaimedValueOnChange();

    await this.loadOrderComments();
    await this.getStatusLogs();

    // If commentId is present, scroll and focus to that comment
    if (hasCommentId && commentIdParam) {
      setTimeout(() => {
        const commentElement = document.getElementById(
          `comment-${commentIdParam}`,
        );
        if (commentElement) {
          commentElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          commentElement.style.backgroundColor = "#fff3cd";
          setTimeout(() => {
            commentElement.style.backgroundColor = "";
          }, 2000);
        }
        // Focus the MentionsInput if ref exists
        if (this.commentSectionComponent.focusMentionsInput) {
          this.commentSectionComponent.focusMentionsInput();
        }
      }, 1000);
    }

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );
    // try {
    //   let res = DownloadOrder(this.props.match.params.id, obj);
    //   res.then((res) => {
    //     this.setState({ pdfDownloadUrl: res.data.data.pdf_url });
    //   });
    // } catch (err) {
    // }

    this.setState({ contentLoading: false });

    // await this.showPolicyDetails();
    // await this.getFamilyDetails();

    const getisChangedValue = this.state.inputList.filter(
      (data) => data.is_changed === 1,
    );
    this.setState({ trackIsChangedOrderItemValues: getisChangedValue });
  }

  async loadOrderComments() {
    try {
      const token = JSON.parse(localStorage.getItem("user")) || {};
      const auth = token && token.token;
      if (!auth) return;
      const orderId = this.props.match.params.id;
      const type = "medicine";
      const res = await getOrderWiseComment(auth, orderId, type);
      const rawComments =
        (res && res.data && res.data.data) || (res && res.data) || [];
      const mapped = (rawComments || []).map((item, idx) => {
        const authorName =
          (item.user && item.user.name) ||
          (item.created_by && item.created_by.name) ||
          item.created_by_name ||
          item.user_name ||
          item.user ||
          "Unknown";

        const messageText =
          typeof item.comment === "string"
            ? item.comment
            : typeof item.text === "string"
              ? item.text
              : typeof item.message === "string"
                ? item.message
                : "";

        return {
          id: item.id || idx,
          author: authorName,
          text: messageText,
          timestamp:
            item.created_at || item.timestamp || new Date().toISOString(),
          avatar:
            item.avatar ||
            (item.user && item.user.profile_picture_url) ||
            "https://flash-prod.s3.ap-south-1.amazonaws.com/adminNewImage/avatar_icon.png",
        };
      });
      this.setState({ comments: mapped });
    } catch (err) {
      console.error("Failed to load comments", err);
      this.setState({ commentError: "Unable to load comments" });
    }
  }
  async getStatusLogs() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const orderId = this.props.match.params.id;
    await getStatusLogsByOrderId(obj, orderId).then((res) => {
      const statusLogs = res.data;
      const arrangeLogs =
        statusLogs &&
        statusLogs.map((log) => {
          return {
            id: log.id,
            author: "System",
            text: `Order status changed to ${log.status} by ${
              (log.user && log.user.name) || log.channel
            }`,
            timestamp: log.created_at,
            avatar: "",
          };
        });
      this.setState({ comments: [...this.state.comments, ...arrangeLogs] });
    });
  }

  getFamilyDetails = async () => {
    if (this.state.isInsureme && this.state.insuremeDetails.length > 0) {
      const getInsuremeDetails =
        this.state.insuremeDetails[0].insureme_family_details;
      let tempFamily = [];
      tempFamily.push(getInsuremeDetails);
      this.setState({ familyDetails: tempFamily });
    }
  };

  async handleSupplierData() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    await GetAllSuppliers(obj).then((res) => {
      this.setState({ suppliersData: res.data.data });
    });
  }

  handleHealthConditionData(healthConditions) {
    this.setState({
      healthconditiondetails: healthConditions,
    });

    let hcItems = [];
    this.state.healthconditiondetails.map((x, i) => {
      hcItems.push({
        value: x.healthconditionname,
        label: x.healthconditionname,
      });
    });
    this.setState({
      healthconditionItems: hcItems,
    });
  }

  async handleUtilData() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    let utils = {
      healthcondition: { country_id: 1 },
      medicationpackages: { package_code: "" },
      medicationCategories: {},
      riders: { district: "" },
      policy: {
        claim_type: this.state.policyType,
        package_id: this.state.cataloguePackageId,
      },
      leadBalance: {
        lead_id: this.state.subscriber,
        credit_type: this.state.claimCreditType,
      },
    };

    await getAllUtilData(utils, obj).then((res) => {
      const data = res.data.data;

      // get health conditions
      this.handleHealthConditionData(data.healthConditions);
      // get package items
      this.handleMedicationPackagesData(data.medicationPackages);
      // get package items
      this.handleMedicationCategoryData(data.medCategories);
      // get settings
      this.setState({ DeliveryChargeValues: data.settings });
      //get riders
      this.handleAllRider(data.riders);
      // get sales reps
      this.handleSalesRepresentatives(data.salesReps);
      //show policies
      if (this.state.isClaimableOrder) {
        // if(this.state.catalougepackagename !== "AIA ECO") {
        if (data.policy.length > 0) {
          const claimPolicyDetails = data.policy.find((data) => data);
          this.setState({ ClaimPolicyDetails: claimPolicyDetails.policy });
        }
        // }
      } else if (this.state.isInsureme) {
        this.setState({ ClaimPolicyDetails: this.state.insuremePolicy });
      }

      if (data.leadBalance) {
        this.setState({
          avalable_flash_point: data.leadBalance.remainingCredit,
          availableTotalClaimCredits: data.leadBalance.remainingCredit,
        });
      }
    });
  }
  handleMedicationCategoryData(medCategories) {
    this.setState({ category_detail: medCategories });
  }

  handleMedicationPackagesData(medicationPackages) {
    this.setState({
      labpackage: medicationPackages,
    });

    let pcItems = [];
    this.state.labpackage.map((x, i) => {
      pcItems.push({
        value: x.id,
        label: `${x.package_name}(${x.package_code})`,
      });
    });
    this.setState({
      packageItems: pcItems,
    });
  }

  handleAllRider(riders) {
    const riderItems = riders.map((x) => ({
      value: x.id,
      label: x.name,
    }));
    const selfPickup = riderItems.find((r) => r.label === "Self Pickup");
    let defaultRider = null;
    if (
      this.state.selectedRiderObject &&
      this.state.selectedRiderObject.value !== null
    ) {
      defaultRider = this.state.selectedRiderObject;
    } else if (
      this.state.store !== 1 &&
      this.state.store !== null &&
      selfPickup
    ) {
      defaultRider = selfPickup;
    } else {
      defaultRider = null;
    }
    this.setState({
      rider_details: riders,
      rider_data: riderItems,
      rider_id: defaultRider,
    });
  }

  handleSalesRepresentatives(salesReps) {
    this.setState({
      sales_details: salesReps,
    });

    let repItems = [];
    this.state.sales_details.map((x, i) => {
      repItems.push({ value: x.id, label: x.name });
    });
    this.setState({
      sales_rep_data: repItems,
    });
  }

  async getavailableClaimCredit() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getAvailableCreditsByLeads(
      this.state.subscriber,
      this.state.claimCreditType,
      obj,
    ).then((res) => {
      this.setState({ availableTotalClaimCredits: res.data.remainingCredit });
    });
  }

  async handleOrderByIdData() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var s_lead_id = 0;
    var address_data = "";
    let billingAddressData = null;

    await getOrderById(this.props.match.params.id, obj).then(async (res) => {
      const data = res.data;
      this.setState({
        getOrderChannel: res.data.channel,
      });
      // this.setState({ is_abusable_url: data.is_abusable_url });

      const date = new Date(data.order_date);
      if (data.delivery_from_date == null && data.delivery_to_date == null) {
        const today = moment();
        var deliveyfromdate = "";
        var deliveytodate = "";
        var daterangeinfo = moment.range(
          today.clone(),
          today.clone().add(7, "days"),
        );
      } else {
        var deliveyfromdate = new Date(data.delivery_from_date);
        var deliveytodate = new Date(data.delivery_to_date);
        var daterangeinfo = moment.range(deliveyfromdate, deliveytodate);
      }

      address_data = data.address;
      billingAddressData = data.billingAddress;
      const lead = data.lead;

      const selectedSource = this.state.sourceOptions.find(
        (source) => Number(source.value) === data.source,
      );
      const selectedDeliveryType = this.state.deliveryTypeOptions.find(
        (item) => Number(item.value) === data.delivery_type,
      );

      var subOrderType = false;
      switch (data.order_sub_type) {
        case 1:
          subOrderType = false;
          break;
        case 2:
          subOrderType = true;
          break;
        case 4:
          subOrderType = 4;
          break;
        default:
          subOrderType = data.order_sub_type;
      }

      if (data.used_credit_points == null) {
        this.setState({ used_credit_point: 0 });
      } else {
        this.setState({ used_credit_point: data.used_credit_points });
      }
      if (data.credit_being_use != null) {
        this.setState({ credit_being_use: data.credit_being_use });
      } else {
        this.setState({ credit_being_use: 0 });
      }

      if (data.creditNote) {
        this.setState({ creditNoteData: data.creditNote });
      }

      var maramount = 0;
      var marpercentage = 0;
      var basketfinalvalue = 0;
      if (data.margin_type == 1) {
        marpercentage = data.margin;
        this.setState({ displaymarginpercentage: data.margin });
        var getamount =
          (parseFloat(data.basket_value) * parseFloat(marpercentage)) / 100;
        basketfinalvalue =
          parseFloat(data.basket_value) + parseFloat(getamount);
      }
      if (data.margin_type == 2) {
        maramount = data.margin;
        this.setState({ displaymarginamount: data.margin });

        basketfinalvalue =
          parseFloat(data.basket_value) + parseFloat(maramount);
      }
      var mtype = "1";
      if (data.margin_type == 1) {
        mtype = "1";
      } else if (data.margin_type == 2) {
        mtype = "2";
      }

      var hc = [];
      var newdata = [];
      hc = data.tags;
      if (hc == null) {
        this.setState({ healthcondition: null });
      } else {
        const splic = hc.split(",");
        splic.map((fd) => {
          newdata.push({ value: fd, label: fd });
        });
        this.setState({ healthcondition: newdata });
      }
      var organization_discount_cost = 0;
      if (data.organization_discount_cost == null) {
        organization_discount_cost = 0;
      } else {
        organization_discount_cost = parseFloat(
          data.organization_discount_cost,
        );
      }

      var organization_discount = "";
      if (data.organization_discount == null) {
        organization_discount = 0;
      } else {
        organization_discount = data.organization_discount;
      }

      this.setState({ sales_rep: data.sales_user_id });
      var pdata = [];
      pdata.push({ value: data.paymentoption, label: data.paymentoption });
      if (data.is_courier_partner == 1) {
        this.setState({ currier_disabled: "no" });
        this.setState({ is_currier: true });
        let cdata = [];
        let currier_data = "";
        if (data.rider_id != null) {
          this.currier_details.map((r) => {
            if (r.value == data.rider_id) {
              currier_data = { value: r.value, label: r.label };
            }
          });
          cdata = currier_data;
        } else if (data.rider_id == null && data.channel == "app") {
          cdata = null;
        } else {
          cdata.push({ value: null, label: null });
        }
        this.setState({ currier_id: cdata });
      } else {
        let rdata = [];
        let ride_data = "";
        if (data.rider_id != null) {
          this.state.rider_details.map((r) => {
            if (r.id == data.rider_id) {
              ride_data = { value: r.id, label: r.name };
            }
          });
          rdata = ride_data;
        } else if (data.rider_id == null && data.channel == "app") {
          // this.setState({ rider_id: null  });
          rdata = null;
        } else {
          rdata.push({ value: null, label: null });
        }
        this.setState({ rider_id: rdata });
      }

      this.setState({
        paymentoption: pdata,
        previousPaymentOption: {
          value: data.paymentoption,
          label: data.paymentoption,
        },
      });
      var opharma_reference = "";
      if (data.opharma_reference == null) {
        opharma_reference = "";
      } else if (data.opharma_reference != null) {
        opharma_reference = data.opharma_reference;
      }
      var mypharma_reference = "";
      if (data.opharma_reference == null) {
        mypharma_reference = "";
      } else if (data.mypharma_reference != null) {
        mypharma_reference = data.mypharma_reference;
      }
      var quote_che = null;
      if (data.request_quote_notification != null) {
        if (data.request_quote_notification == "1") {
          quote_che = true;
        } else {
          quote_che = false;
        }
      } else {
        quote_che = false;
      }
      s_lead_id = data.lead_id;
      var pd_date = new Date(data.payment_due_date);
      var basketfinalvalueNew = basketfinalvalue;
      if (data.coupon_discount_amount === null) {
        this.setState({ coupon_use_text: "Coupon to be used" });
      } else {
        this.setState({ coupon_use_text: "Used coupon" });
        basketfinalvalueNew = basketfinalvalue - data.coupon_discount_amount;
      }

      /*if (data.order_status == '1' && delitype == '2') {
        var tcost = dcharge
      }
      else {
        dcharge = data.delivery_charge;
        var tcost = data.total_cost;
      }*/

      var PO_document = [];
      if (data.po_documents.length > 0) {
        for (let i = 0; i < data.po_documents.length; i++) {
          PO_document.push(data.po_documents[i].po_document_url);
        }
      }

      var GRN_document = [];
      if (data.grn_documents.length > 0) {
        for (let i = 0; i < data.grn_documents.length; i++) {
          GRN_document.push(data.grn_documents[i].grn_document_url);
        }
      }

      const findPartialItemsIncluded = data.orderItems.filter(
        (item) => item.partial_sent,
      );

      const isPromotionOrder =
        data.promotion && data.promotion !== null ? true : false;

      const documents = await Promise.all(
        (data.orderDocument || []).map(async (file, index) => {
          const res = await fetch(file.url);
          const blob = await res.blob();
          const filesFromApi = new File([blob], `document${index + 1}`, {
            type: blob.type,
          });
          filesFromApi.isNewFile = false;
          filesFromApi.documentId = file.id;
          return filesFromApi;
        }),
      );
      this.setState({ selectedDocument: documents });
      console.log("documents", documents);

      this.setState({
        subscriber: data.lead_id,
        flashreference: opharma_reference,
        mypharmareferance: mypharma_reference,
        // priscriptionurl : data.prescription_file_url,
        coupon_discountamount: data.coupon_discount_amount,
        coupon_title: data.coupon.title,
        delivery_from_date: deliveyfromdate,
        delivery_to_date: deliveytodate,
        datarange: daterangeinfo,
        source: selectedSource,
        basketvalue: basketfinalvalueNew,
        paymentduedate: pd_date,
        ordernote: data.order_note,
        prescription_note: data.prescription_note,
        prescription_text: data.prescription_text,
        deliverycharge: data.delivery_charge,
        deliverytype: selectedDeliveryType,
        totalcost: data.total_cost,
        address_id: address_data.id,
        first_address: address_data.id,
        billing_address_id: billingAddressData && billingAddressData.id,
        first_billing_address: billingAddressData && billingAddressData.id,
        discountamount: organization_discount_cost,
        marginfinalamount: data.margin,
        dynamicfinalpercentage: organization_discount,
        quotenotification: quote_che,
        not_get_medicine: data.not_get_medicine,
        created_At: data.created_at,
        isPartialOrder: findPartialItemsIncluded.length > 0 ? true : false,
        isAbusableOrder: data.is_abusable,
        // addressdata : data.address,
        // addressline1 : address_data.address_line1,
        // addressline2 : address_data.address_line2,
        // city : address_data.city,
        // postalcode : address_data.postal_code,
        // country : address_data.country_id,
        name: address_data.name,
        status: data.order_status,
        orderStatusLabel: data.order_status_label,
        email: address_data.email,
        mobileno: address_data.mobile,
        phoneno: address_data.phone,
        //  healthcondition : ["2"],
        leadid: data.lead_id,
        margintype: mtype,
        marginamount: maramount,
        channel: data.channel,
        marginpercentage: marpercentage,
        discountpercentage: organization_discount,
        tracking_id: data.tracking_id,
        tracking_note: data.tracking_note,
        tracking_url: data.tracking_url,
        is_flash_point: data.is_flash_point,
        sub_orderType: subOrderType,
        po_number: data.po_number,
        PNdocUrl: PO_document,
        GRNDocUrl: GRN_document,
        package_delivery_discount: data.package_delivery_discount,
        isClaimableOrder: data.is_claimable === "1" ? true : false,
        policyType: data.order_type === 1 ? "1" : "",
        refillableOrder: data.is_refillable,
        rider_id: { label: data.rider_name, value: data.rider_id },
        selling_price: data.price,
        subscriber_detail: data.lead,
        familyDetails: data.lead.lead_family,
        isInsureme: data.is_insureme,
        // latitude: data.latitude,
        // longitude: data.longitude,
        is_abusable_url: data.is_abusable_url,
        address_type: data.addressType,
        customaddress: data.customAddress,
        is_printable: data.is_printable,
        insuremeDetails: data.insuremeDetails,
        originPackageId: data.origin_package_id,
        temporaryInvoices: data.temporaryInvoice,
        paymentOption: data.paymentoption,
        selectedRiderObject: { label: data.rider_name, value: data.rider_id },
        is_order_placed: data.item_ordered,
        isPromotionOrder: isPromotionOrder,
        getStores: data.store_id,
        pr_id: data.pr_id,
        orderDocument: data.orderDocument,
        // isPartialOrder: data.partial_sent,
      });
      // this.subdetail();
      // this.lastorderdata(data.lead_id)
      const inputList1 = [];
      var medication_detail = [];
      var medicationItems = [];
      var ne_med = [];
      var prescriptiondetails = [];
      var arrayornot = Array.isArray(data.prescriptions);
      // if(data.prescriptions != null)
      // {

      // if(arrayornot == false)
      // {

      if (data.channel == "app") {
        if (data.prescriptions != null) {
          const splic = data.prescriptions;

          splic.map((fd) => {
            prescriptiondetails.push({ prescription_url: fd });
          });
        } else {
          prescriptiondetails = [];
        }
      } else {
        data.prescriptions.map((dp) => {
          prescriptiondetails.push({ prescription_url: dp });
        });
      }

      this.setState({
        priscriptionurl: prescriptiondetails,
        documenturl: data.documents,
      });

      this.setState({
        order_type: data.order_type,
      });

      const findOrderStatus = [1, 9.13].includes(data.order_status);

      data.orderItems.map((x, indx) => {
        medication_detail[indx] = x;
        medicationItems.push({
          value: x.medication_id,
          label: x.medication_title + "(" + x.medication_itemcode + ")",
        });
        ne_med[indx] = medicationItems;
      });

      this.setState({
        medication_detail: medication_detail,
        medicationItems: medicationItems,
      });
      let allocatedQuantityForThisOrder = 0;

      const processedItems = await Promise.all(
        data.orderItems.map(async (x, indx) => {
          let partialSentQuantity = 0;
          await allocationValuePopUp(x.medication_id, obj)
            .then((res) => {
              const data = res.data;
              const ReducePartialOrderQuantity = data.filter((item) => {
                if (item.partial_sent) {
                  partialSentQuantity = partialSentQuantity + item.quantity;
                }
              });
              //  this.setState({ allocatedData: data });
              if (!!data && data.length > 0) {
                const findAllocatedMedicineQuantityForThisOrder = data.find(
                  (item) =>
                    item.order_id === Number(this.props.match.params.id),
                );
                if (
                  !data.partial_sent &&
                  !!findAllocatedMedicineQuantityForThisOrder
                ) {
                  allocatedQuantityForThisOrder =
                    findAllocatedMedicineQuantityForThisOrder.quantity;
                } else {
                  allocatedQuantityForThisOrder = 0;
                }
              }
            })
            .catch((error) => {
              console.error("Error fetching allocated data:", error);
            });
          const sellingPrice =
            x && x.medication
              ? x.medication.selling_price || x.medication.price
              : "";

          // const itemDescriptions = res.data.description;
          var subTvalue =
            (parseFloat((x.unit_price - 0).toFixed(2)) +
              parseFloat((x.margin_discount_price - 0).toFixed(2))) *
            x.quantity;
          let totalAllocatedQuantityValue = 0;
          if (!x.partial_sent && !findOrderStatus) {
            totalAllocatedQuantityValue = Number(
              x.medication &&
                x.medication.total_allocated -
                  (allocatedQuantityForThisOrder + partialSentQuantity),
            );
          } else {
            totalAllocatedQuantityValue =
              x.medication && x.medication.total_allocated;
          }
          if (
            !x.partial_sent &&
            !findOrderStatus &&
            Number(x.available_quantity - totalAllocatedQuantityValue) < 1
          ) {
            this.setState({ isWrongQuantity: true });
          }

          return {
            id: moment().valueOf() + Number(indx),
            srno: await this.getSerial(indx),
            item_type: x.item_type,
            description: x.medication_id,
            medi_title: x.medication_title,
            medi_itemcode: x.medication_itemcode,
            unitprice: parseFloat(x.unit_price - 0).toFixed(2),
            availableQuantity:
              this.state.store === 1 || this.state.store === null
                ? Number(x.available_quantity) > 0
                  ? Number(x.available_quantity)
                  : 0
                : Number(
                    x.medication ? x.medication.quantity : x.available_quantity,
                  ),
            total_allocated:
              this.state.store === 1 || this.state.store === null
                ? Number(totalAllocatedQuantityValue) > 0
                  ? Number(totalAllocatedQuantityValue)
                  : 0
                : 0,
            quantity: x.quantity,
            quantity_type: x.quantity_type,
            quantity_per_box: x.quantity_per_box,
            newmargin: x.margin_discount_price,
            margin_discount_sub_type: 2, // x.md_sub_type,
            margin_discount_percentage: x.margin_discount_percentage,
            OItemdiscountType: x.md_sub_type,
            subtotal: subTvalue.toFixed(2),
            is_changed: x.is_changed,
            discount_used: x.discount_used,
            medicationItems: [],
            selectmedication: {
              value: x.medication_id,
              label: x.medication_title + "(" + x.medication_itemcode + ")",
            },
            orderItemNumber: x.order_item_id,
            isChecked: x.claimable,
            isOldMedicine: true,
            claimableValue: x.claimable ? subTvalue : 0,
            isUpSeller: x.is_recommended_product
              ? x.is_recommended_product
              : false,
            isPartialOrderItem: !x.partial_sent,
            item_description: x.item_description,
            selling_price: sellingPrice,
            unit_price: x.unit_price,
            barcode: x.medication && x.medication.item_code,
            is_printable: x.is_printable,
            medicineData: x.medication,
            location:
              x.medication &&
              x.medication.xcoord &&
              x.medication &&
              x.medication.ycoord
                ? `${x.medication.ycoord}${x.medication.xcoord}`
                : null,
            is_order_placed: x.item_ordered,
            // store: x.store_id,
          };
        }),
        await checkFirstOrder(
          data.lead_id,
          this.props.match.params.id,
          obj,
        ).then((res) => {
          this.setState({ isFirstOrder: res.data.isFirstOrder });
        }),
      );
      await this.addrssselect(
        address_data.id,
        address_data.country_id,
        billingAddressData.id,
        billingAddressData.country_id,
      );

      // this.serial = processedItems.length + 1;
      // this.getPartialSentData(inputList1);
      this.setState({ inputList: processedItems });
      const disableRemoveOrderItemsButton = [3, 8, 4].some(
        (removeStatus) => removeStatus === this.state.status,
      );
      this.setState({
        disableRemoveOrderItem: disableRemoveOrderItemsButton,
      });

      if (data.is_insureme && data.insuremeDetails.length > 0) {
        const statusArray = [3, 4, 8, 11];
        const disablePaymentOption = statusArray.some(
          (stat) => stat === Number(data.order_status),
        );
        this.setState({
          insuremeClaimableTotal: data.insuremeDetails[0].order_total,
          disablePaymentOption: disablePaymentOption,
        });

        if (
          !!data.isInsureme &&
          data.insuremeDetails[0].claim_request_status === "success"
        ) {
          this.setState({
            insuremeBannerText: (
              <div
                style={{
                  backgroundColor: "#E0FBE2 ",
                  // position: "absolute",
                  width: "100%",
                  flex: 1,
                  left: "300px",
                  padding: "10px",
                  zIndex: 1000,
                  borderRadius: "5px",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: 1,
                    gap: "20px",
                  }}
                >
                  <i
                    class="fa fa-check-circle-o"
                    style={{ fontSize: "36px", color: "green" }}
                  ></i>
                  <p style={{ color: "green", marginTop: "7px" }}>
                    InsureMe Claim Verification Success.
                  </p>
                </span>
              </div>
            ),
          });
        }
      }
    });

    // getremaincreditforleaduser(this.state.subscriber, obj).then((res) => {

    // });

    // await get_single_lead_data(s_lead_id, obj).then((res) => {
    //   const data = res.data.data;
    //   this.setState({
    //     subscriber_detail: data,
    //   });
    // });
  }
  async Remaining() {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getRemainingCredits(this.state.subscriber, obj)
      .then((res) => {
        const data = res.data.data;
        this.setState({ remainingCredit: data.remainingCredit });
      })
      .catch((error) => {
        console.error("Error fetching remaining credits:", error);
      });
  }

  async Remaining() {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getRemainingCredits(this.state.subscriber, obj)
      .then((res) => {
        const data = res.data.data;
        this.setState({ remainingCredit: data.remainingCredit });
      })
      .catch((error) => {
        console.error("Error fetching remaining credits:", error);
      });
  }

  setInputRef = (el, index) => {
    if (!this.inputRef.current) {
      this.inputRef.current = {};
    }
    this.inputRef.current[index] = el;
  };

  async handleCityDetailsData() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var country_id = 1;
    await getCity(obj, country_id).then((res) => {
      this.setState({ city_info: res.data });
    });
  }
  async oncheckquote() {
    this.setState({ alertquote: null });
    /*if (
      this.state.totalcost > 5000 &&
      this.state.paymentoption.value == "Cash" &&
      this.state.order_type == 1
    ) {
      this.setState({
        ispaywarning: true,
      });
    } else {*/
    this.setState({ isLoading: true /*, ispaywarning: false*/ });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let orderItemsform = [];
    /* this.state.inputList.map((x, i) => {
      orderItemsform.push({
        id: x.description,
        quantity: x.quantity,
        margin_discount_percentage: x.newmargin,
        item_id: x.orderItemNumber,
      });
    });
*/
    this.state.inputList.map((x, i) => {
      if (x.margin_discount_sub_type == 2) {
        var itemT = parseInt(x.item_type);
        orderItemsform.push({
          id: x.description,
          quantity: x.quantity,
          item_type: itemT,
          margin_discount_sub_type: x.margin_discount_sub_type,
          margin_discount_price: x.newmargin,
          margin_discount_percentage: 0,
          item_id: x.orderItemNumber,
          claimable: x.isChecked,
          unit_price: x.unitprice,
          item_description: x.item_description,
        });
      } else if (x.margin_discount_sub_type == 1) {
        var itemT = parseInt(x.item_type);
        orderItemsform.push({
          id: x.description,
          quantity: x.quantity,
          item_type: itemT,
          margin_discount_price: 0,
          margin_discount_sub_type: x.margin_discount_sub_type,
          margin_discount_percentage: x.margin_discount_percentage,
          item_id: x.orderItemNumber,
          claimable: x.isChecked,
          unit_price: x.unitprice,
          item_description: x.item_description,
        });
      }
    });

    const channel = this.state.channel;
    const created_by = token.id;
    const date = new Date(this.state.orderdate);
    var dd = ("0" + date.getDate()).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    var today = yyyy + "-" + mm + "-" + dd;

    var priscription_data = "";
    var prescription_text = "";
    if (this.state.selectedFile.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();

      this.state.selectedFile.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("presription_file[]", file[i]);
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/prescription";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          priscription_data = res.data.data.prescription_url;
        });
    } else {
      let pdata = [];
      let ptext = "";
      this.state.priscriptionurl.map((p) => {
        if (p.prescription_url.prescription_file.length != 0) {
          pdata.push(p.prescription_url.prescription_file);
        }
      });

      prescription_text = this.state.prescription_text;
      priscription_data = pdata;
    }

    var priscription_data = "";
    var prescription_text = "";
    if (this.state.selectedFile.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();

      this.state.selectedFile.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("presription_file[]", file[i]);
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/prescription";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          priscription_data = res.data.data.prescription_url;
        });
    } else {
      let pdata = [];
      let ptext = "";
      this.state.priscriptionurl.map((p) => {
        if (p.prescription_url.prescription_file.length != 0) {
          pdata.push(p.prescription_url.prescription_file);
        }
      });

      prescription_text = this.state.prescription_text;
      priscription_data = pdata;
    }

    var priscription_data = "";
    var prescription_text = "";
    if (this.state.selectedFile.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();

      this.state.selectedFile.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("presription_file[]", file[i]);
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/prescription";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          priscription_data = res.data.data.prescription_url;
        });
    } else {
      let pdata = [];
      let ptext = "";
      this.state.priscriptionurl.map((p) => {
        if (p.prescription_url.prescription_file.length != 0) {
          pdata.push(p.prescription_url.prescription_file);
        }
      });

      prescription_text = this.state.prescription_text;
      priscription_data = pdata;
    }

    var marginvalue = "";
    if (this.state.margintype == 1) {
      if (this.state.marginfinalamount != null) {
        marginvalue = parseFloat(this.state.marginfinalamount);
      } else {
        marginvalue = 0;
      }
    } else if (this.state.margintype == 2) {
      if (this.state.marginfinalamount != null) {
        marginvalue = parseFloat(this.state.marginfinalamount);
      } else {
        marginvalue = 0;
      }
    }
    var discountper = 0;
    if (this.state.dynamicfinalpercentage != 0) {
      discountper = parseFloat(this.state.dynamicfinalpercentage);
    } else {
      discountper = parseFloat(this.state.discount);
    }
    // }
    // else
    // {
    //   discountper = 0
    // }

    var tag = [];
    if (this.state.healthcondition == null) {
      tag = "";
    } else {
      this.state.healthcondition.map((data) => {
        var array1 = tag;
        var array2 = array1.concat(data.label);
        tag = array2;
      });
    }

    let paymentop = "";
    if (this.state.paymentoption.value != null) {
      paymentop = this.state.paymentoption.value;
    } else {
      this.state.paymentoption.map((po) => {
        paymentop = po.value;
      });
    }

    var riderinfo = "";

    if (this.state.rider_id == null) {
      if (this.state.rider_id != null) {
        riderinfo = this.state.rider_id.value;
      } else {
        riderinfo = "";
      }
    } else {
      // return;
      if (this.state.rider_id != null) {
        // this.state.rider_id.map(ri=>{

        if (this.state.rider_id.value != null) {
          riderinfo = this.state.rider_id.value;
        } else {
          riderinfo = "";
        }
        // })
      }
    }

    var currier_partner_id = "";
    var c_c = 0;
    if (this.state.currier_disabled == "no") {
      c_c = 1;
      currier_partner_id = this.state.currier_id.value;
    } else {
      c_c = 0;
      currier_partner_id = riderinfo;
    }

    var deliveryType = this.state.deliverytype.value;

    if (deliveryType == 1) {
      this.setState({
        delivery_from_date: this.state.datarange.start.format("YYYY-MM-DD"),
        delivery_to_date: this.state.datarange.end.format("YYYY-MM-DD"),
      });
    } else {
      this.setState({ delivery_from_date: "", delivery_to_date: "" });
    }

    var subOrderType = "1";
    var PO_No = this.state.po_number;
    var PNDoc = this.state.PNdocUrl;
    var GRNDoc = this.state.GRNDocUrl;

    if (this.state.sub_orderType == true) {
      subOrderType = "2";
    } else {
      PO_No = "";
      PNDoc = [];
      GRNDoc = [];
    }

    var orderSource = this.state.source.value;
    this.setState({ processing: false }, () => {
      updateQuote(
        this.state.subscriber,
        orderSource,
        this.state.opharmareferance,
        today,
        this.state.prescription,
        this.state.priscriptionurl,
        deliveryType,
        this.state.deliverycharge,
        this.state.lastsubscriptionorder,
        this.state.address_id,
        this.state.addressline1,
        this.state.addressline2,
        this.state.city,
        this.state.postalcode,
        this.state.country,
        channel,
        this.state.isAbusableOrder,
        orderItemsform,
        obj,
        this.state.basketvalue,
        this.state.totalcost,
        this.state.lastsubscriptionorder,
        this.state.email,
        this.state.name,
        this.state.mobileno,
        this.state.phoneno,
        this.state.status,
        priscription_data,
        this.state.margintype,
        marginvalue,
        discountper,
        tag,
        paymentop,
        prescription_text,
        this.state.not_get_medicine,
        this.props.match.params.id,
        this.state.deleteditems,
        riderinfo,
        c_c,
        this.state.tracking_id,
        this.state.tracking_note,
        this.state.tracking_url,
        this.state.delivery_from_date,
        this.state.delivery_to_date,
        subOrderType,
        PO_No,
        PNDoc,
        GRNDoc,
        this.state.sales_rep,
        this.state.latitude,
        this.state.longitude,
        this.state.addressType,
        this.state.customAddress,
      )
        .then((res) => {
          if (res.data.success === false) {
            this.setState({ processing: true });
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.setState({ isLoading: false });
            } else {
              this.handleClick("bl");
              this.setState({ isLoading: false });
            }
          } else if (res.data.success === true) {
            this.setState({ processing: true });
            this.handleSuccess("bl");
            setTimeout(() => {
              this.setState({ isLoading: false });
              this.props.history.push("/admin/order_list");
            }, 3000);
          }
          // this.props.history.push('/admin/order_list');
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          this.handleNetworkError("bl");
        });
    });
    //}
  }

  confirmUpdate = async (type) => {
    var rider_cour = null;
    if (!this.state.isCurrier) {
      rider_cour = this.state.selectedRider.value;
    } else {
      rider_cour = this.state.selectedCurrier.value;
    }
    var paymentoption = "";
    if (this.state.paymentoption.value) {
      paymentoption = this.state.paymentoption.value;
    } else {
      this.state.paymentoption.map((po) => {
        paymentoption = po.value;
      });
    }
    /*if (
        this.state.totalcost > 5000 &&
        paymentoption == "Cash" &&
        this.state.order_type == 1
      ) {
        this.setState({
          ispaywarning: true,
        });
      } else {*/
    if (type === "onSubmitUpdate") {
      this.setState({ isLoading: true /*, ispaywarning: false*/ });
    }
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let orderItemsform = [];
    let isPartialOrder = false;

    this.state.inputList.map((x, i) => {
      if (x.description !== "" && x.quantity !== "" && x.unitprice !== "") {
        let partialSent = !x.isPartialOrderItem;
        let isOrderItemCheck = x.is_order_placed ? true : false;
        // let isAvailable = x.availableQuantity >= x.quantity;
        // kamal
        if (x.margin_discount_sub_type == 2) {
          var itemT = parseInt(x.item_type);
          orderItemsform.push({
            id: x.description,
            quantity: x.quantity,
            item_type: itemT,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_price: x.newmargin,
            margin_discount_percentage: 0,
            item_id: x.orderItemNumber,
            claimable: x.isChecked,
            is_recommended_product: x.isUpSeller,
            partial_sent: partialSent,
            item_description: x.item_description,
            unit_price: x.unitprice,
            is_printable: x.is_printable,
            item_ordered: isOrderItemCheck,
          });
        } else if (x.margin_discount_sub_type == 1) {
          var itemT = parseInt(x.item_type);
          orderItemsform.push({
            id: x.description,
            quantity: x.quantity,
            item_type: itemT,
            margin_discount_price: 0,
            margin_discount_sub_type: x.margin_discount_sub_type,
            margin_discount_percentage: x.margin_discount_percentage,
            item_id: x.orderItemNumber,
            claimable: x.isChecked,
            is_recommended_product: x.isUpSeller,
            partial_sent: partialSent,
            item_description: x.item_description,
            unit_price: x.unitprice,
            is_printable: x.is_printable,
            item_ordered: isOrderItemCheck,
          });
        }
      }
      // if (!isAvailable) {
      //   isPartialOrder = true;
      // }
    });

    // this.setState({ isPartialOrder });
    const channel = this.state.channel;
    const created_by = token.id;
    const date = new Date(this.state.orderdate);
    var dd = ("0" + date.getDate()).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    var today = yyyy + "-" + mm + "-" + dd;

    const paymentdate = new Date(this.state.paymentduedate);
    var pdd = ("0" + paymentdate.getDate()).slice(-2);
    var pmm = ("0" + (paymentdate.getMonth() + 1)).slice(-2);
    var pyyyy = date.getFullYear();
    var ptoday = pyyyy + "-" + pmm + "-" + pdd;

    var priscription_data = "";
    var prescription_text = "";

    if (this.state.selectedFile.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();
      this.state.selectedFile.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("presription_file[]", file[i]);
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/prescription";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          priscription_data = res.data.data.prescription_url;

          // priscription_array_data.push(priscription_data);
        });
    } else {
      let pdata = [];
      this.state.priscriptionurl.map((p) => {
        if (p.prescription_url.prescription_file.length != 0) {
          pdata.push(p.prescription_url.prescription_file);
        }
      });
      prescription_text = this.state.prescription_text;
      priscription_data = pdata;
    }

    var marginvalue = "";
    if (this.state.margintype == 1) {
      if (this.state.marginfinalamount != null) {
        marginvalue = parseFloat(this.state.marginfinalamount);
      } else {
        marginvalue = 0;
      }
    } else if (this.state.margintype == 2) {
      if (this.state.marginfinalamount != null) {
        marginvalue = parseFloat(this.state.marginfinalamount);
      } else {
        marginvalue = 0;
      }
    }
    var discountper = 0;
    if (this.state.dynamicfinalpercentage != 0) {
      discountper = parseFloat(this.state.dynamicfinalpercentage);
    } else {
      discountper = parseFloat(this.state.discount);
    }
    var tag = [];
    if (this.state.healthcondition == null) {
      tag = "";
    } else {
      this.state.healthcondition.map((data) => {
        var array1 = tag;
        var array2 = array1.concat(data.label);
        tag = array2;
      });
    }
    var paymentop = "";
    if (this.state.paymentoption.value != null) {
      paymentop = this.state.paymentoption.value;
    } else {
      this.state.paymentoption.map((po) => {
        paymentop = po.value;
      });
    }
    var riderinfo = "";

    if (this.state.rider_id == null) {
      if (this.state.rider_id != null) {
        riderinfo = this.state.rider_id.value;
      } else {
        riderinfo = "";
      }
    } else {
      // return;
      if (this.state.rider_id != null) {
        // this.state.rider_id.map(ri=>{

        if (this.state.rider_id.value != null) {
          riderinfo = this.state.rider_id.value;
        } else {
          riderinfo = "";
        }
        // })
      }
    }

    // if(this.state.source == "2")
    // {
    //   this.setState({ mypharmareferance  : ''  });
    // }
    // else if(this.state.source == "3")
    // {
    //   this.setState({ opharmareferance : ""  });
    // }
    var status = "";
    status = this.isPendingOrder ? 14 : this.state.status;

    var quotenoti = "";
    if (this.state.quotenotification != null) {
      if (this.state.quotenotification == true) {
        quotenoti = "1";
      } else if (this.state.quotenotification == false) {
        quotenoti = "0";
      }
    }
    var currier_partner_id = "";
    var c_c = 0;
    if (this.state.currier_disabled == "no") {
      c_c = 1;
      currier_partner_id = this.state.currier_id.value;
    } else {
      c_c = 0;
      currier_partner_id = riderinfo;
    }

    var sales_user_id = this.state.sales_rep;

    var deliveryType = this.state.deliverytype.value;

    if (deliveryType == 1) {
      this.setState({
        delivery_from_date: this.state.datarange.start.format("YYYY-MM-DD"),
        delivery_to_date: this.state.datarange.end.format("YYYY-MM-DD"),
      });
    } else {
      this.setState({ delivery_from_date: "", delivery_to_date: "" });
    }

    var subOrderType = "1";
    var PO_No = this.state.po_number;
    var PNDoc = this.state.PNdocUrl;
    var GRNDoc = this.state.GRNDocUrl;

    if (this.state.sub_orderType == true) {
      subOrderType = "2";
    } else if (this.state.sub_orderType == 4) {
      subOrderType = "4";
    } else {
      PO_No = "";
      PNDoc = [];
      GRNDoc = [];
    }

    var orderSource = this.state.source.value ? this.state.source.value : "1";
    const findPartialItemsIncluded = this.state.inputList.filter(
      (item) => !item.isPartialOrderItem,
    );

    this.setState({ processing: false }, () => {
      const storeNullValue = this.state.store === null ? 1 : this.state.store;
      const isStoreOrder = storeNullValue !== 1;
      const addressId =
        this.state.address_id != ""
          ? this.state.address_id
          : isStoreOrder
            ? 0
            : this.state.address_id;

      const addressLine2 =
        this.state.addressline2 != ""
          ? this.state.addressline2
          : isStoreOrder
            ? "ambalangoda"
            : this.state.addressline2;

      const cityId =
        this.state.city != "0"
          ? this.state.city
          : isStoreOrder
            ? 4
            : this.state.city;

      const countryId =
        this.state.country != "0"
          ? this.state.country
          : isStoreOrder
            ? 1
            : this.state.country;

      const totalCostNum = parseFloat(this.state.totalcost) || 0;
      const unavailableCostNum = parseFloat(this.state.getUnavalibleCost) || 0;
      const finalTotalCost = (totalCostNum - unavailableCostNum).toFixed(2);
      EditOrder(
        this.state.subscriber,
        orderSource,
        this.state.opharmareferance,
        today,
        this.state.prescription,
        this.state.priscriptionurl,
        deliveryType,
        this.state.deliverycharge,
        this.state.lastsubscriptionorder,
        addressId,
        this.state.addressline1,
        addressLine2,
        cityId,
        this.state.postalcode,
        countryId,
        channel,
        orderItemsform,
        obj,
        this.state.basketvalue,
        this.state.sub_orderType ? finalTotalCost : totalCostNum,
        this.state.lastsubscriptionorder,
        this.props.match.params.id,
        this.state.name,
        this.state.mobileno,
        this.state.phoneno,
        this.state.email,
        status,
        priscription_data,
        this.state.margintype,
        marginvalue,
        discountper,
        tag,
        paymentop,
        ptoday,
        this.state.ordernote,
        this.state.mypharmareferance,
        currier_partner_id ? currier_partner_id : rider_cour,
        prescription_text,
        quotenoti,
        this.state.not_get_medicine,
        this.state.deleteditems,
        c_c,
        this.state.tracking_id,
        this.state.tracking_note,
        this.state.tracking_url,
        sales_user_id,
        this.state.delivery_from_date,
        this.state.delivery_to_date,
        subOrderType,
        PO_No,
        PNDoc,
        GRNDoc,
        this.state.flashreference,
        this.state.refillableOrder,
        findPartialItemsIncluded.length > 0 ? true : false,
        this.state.isAbusableOrder,
        // this.state.getPartialOrder,
        this.state.item_description,
        this.state.isClaimableOrder ? "1" : "0",
        this.state.latitude,
        this.state.longitude,
        this.state.addressType,
        this.state.customAddress,
        this.state.isInsureme,
        this.state.getStores
          ? this.state.getStores
          : this.state.getStores === null
            ? 1
            : this.state.getStores,
        this.state.sub_orderType
          ? this.state.billing_address_id
          : this.state.address_id,
        this.state.pr_id,
        // this.state.is_printable
      )
        .then((res) => {
          if (res.data.success === false) {
            this.setState({ processing: true });
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.setState({ isLoading: false });
            } else {
              if (type === "onSubmitUpdate") {
                this.handleClick("bl");
              }
              this.setState({ isLoading: false });
            }
          } else if (res.data.success === true) {
            if (type === "onSubmitUpdate") {
              this.handleSuccess("bl");
            }
            this.setState({
              btn_text: "Submit",
              isOpenRiderModal: false,
              selectedRider: {},
              selectedRiderError: null,
              selectedCurrier: {},
              selectedCurrierError: null,
              tracking_id: "",
              tracking_url: "",
              tracking_note: "",
              is_checked: false,
              processing: false,
              submitButtonDisable: true,
              isCurrier: false,
            });
            // }
            // });
            if (type === "onSubmitUpdate") {
              setTimeout(() => {
                this.setState({ isLoading: false });
                this.props.history.push("/admin/order_list");
              }, 3000);
            }
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          this.handleNetworkError("bl");
        });
    });
  };
  confirmUpdateStatusComplete = async () => {
    this.setState({ errormessages: [] });
    let error = false;
    if (this.state.inputList.length == 0) {
      error = true;

      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Medication data!</h4>
          </SweetAlert>
        ),
      });
    }
    // } else {
    //   error = false;
    //   this.state.inputList.map((x, i) => {
    //     if (x.description == "") {
    //       error = true;
    //       this.setState({
    //         alert: (
    //           <SweetAlert
    //             className="order_alert"
    //             style={{ display: "block", marginTop: "-100px" }}
    //             onConfirm={() => this.hideAlert()}
    //             onCancel={() => this.hideAlert()}
    //             confirmBtnBsStyle="info"
    //           >
    //             <h4>Please Enter Proper Medication data!</h4>
    //           </SweetAlert>
    //         ),
    //       });
    //     }
    //   });
    // }
    const shouldCheckOutOfStock =
      this.state.store !== 1 && this.state.store !== null;
    const outOfStockItems = this.state.inputList.filter(
      (item) =>
        item.description !== "" &&
        parseFloat(item.quantity) > parseFloat(item.availableQuantity),
    );
    if (shouldCheckOutOfStock && outOfStockItems.length > 0) {
      this.setState({
        showOutOfStockPop: true,
        medicationListing: outOfStockItems,
      });
      return;
    }
    if (error) return;
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.handleConfirmComplete()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, complete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You Want to Complete This Order
        </SweetAlert>
      ),
    });
  };
  handleConfirmComplete = async () => {
    this.hideAlert();
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const id = this.props.match.params.id;

    try {
      const updateApi = await this.confirmUpdate("onSubmitUpdate");
      await new Promise((resolve) => setTimeout(resolve, 3000));
      window.open(
        `${process.env.REACT_APP_BILL_GENERATE_URL}/bill-generate/${id}`,
        "_blank",
      );
      this.setState({ isLoading: true });
      const completeRes = await completeOrderStatus(obj, this.state.store, id);
      if (!completeRes.data.success) {
        if (completeRes.data.data.length !== 0) {
          this.setState({ isLoading: false });
        } else {
          this.handleClick("bl");
          this.setState({ isLoading: false });
        }
      } else {
        this.handleSuccess("bl");
      }
    } catch (error) {
      this.setState({ isLoading: false });
      this.handleNetworkError("bl");
    }
  };
  onPendingOrder = () => {
    this.isPendingOrder = true;
    this.setState({ isPendingOrder: true });
    this.onSubmit();
  };

  async onSendQuote() {
    let unCheckedMedicines = this.state.inputList.filter(
      (data) => data.isChecked === false,
    );
    this.setState({ unClaimableMedicineList: unCheckedMedicines });

    this.setState({ errormessages: [] });
    let error = false;
    const nonEmptyMedicationList = this.state.inputList.filter(
      (item) =>
        item.description !== "" &&
        item.description !== null &&
        item.description !== undefined,
    );
    this.state.inputList = nonEmptyMedicationList;

    if (this.state.subscriber == "0") {
      error = true;
      this.setState({
        subscriberError: (
          <small className="text-danger">Subscriber is required.</small>
        ),
      });
    } else {
      this.setState({ subscriberError: null });
    }
    if (
      (Number(this.state.address_id) === 0 ||
        Number(this.state.address_id) === 22) &&
      this.state.addressline1.length === 0
    ) {
      error = true;
      this.setState({
        addressline1Error: (
          <small className="text-danger">Address is required.</small>
        ),
      });
      return;
    } else {
      this.setState({ addressline1Error: null });
    }

    if (this.state.paymentoption == null) {
      error = true;
      this.setState({
        paymentoptionError: (
          <small className="text-danger">Payment Option is required.</small>
        ),
      });
    } else {
      this.setState({ paymentoptionError: null });
    }
    if (this.state.inputList.length == 0) {
      error = true;
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Medication data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      error = false;
      this.state.inputList.map((x, i) => {
        if (x.description == "") {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>Please Enter Proper Medication data!</h4>
              </SweetAlert>
            ),
          });
        } else {
          if (error == true) {
            this.setState({ medicationaddError: null });
          } else {
          }
        }
      });
    }
    if (this.state.addnewaddress == true) {
      if (this.state.country == "0") {
        error = true;
        this.setState({
          countryError: (
            <small className="text-danger">Country is required.</small>
          ),
        });
      } else {
        this.setState({ countryError: null });
      }

      if (this.state.city == "0") {
        error = true;
        this.setState({
          cityError: (
            <small className="text-danger">District is required.</small>
          ),
        });
      } else {
        this.setState({ cityError: null });
      }

      if (this.state.latitude == null) {
        error = true;
        this.setState({
          latiAndLogitError: (
            <small className="text-danger">
              Latitude and Longitude are required.
            </small>
          ),
        });
      } else {
        this.setState({ latiAndLogitError: null });
      }
    }

    const findSubTotalZero = this.state.inputList.filter(
      (item) => parseFloat(item.subtotal) === 0,
    );
    if (findSubTotalZero.length > 0) {
      error = true;
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            title="Sorry! You can't send quote this order"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please check your order, some items have selling price 0 </h4>
          </SweetAlert>
        ),
      });
    }

    if (error) {
      this.message_error.current.focus();
    }

    // if (this.state.isClaimableOrder) {
    //   if (unCheckedMedicines.length !== 0) {
    //     error = false;
    //   }
    // }

    //validation
    const validationError = this.state.insuremeValidationErrors;
    const findOrderType = this.state.isClaimableOrder || this.state.isInsureme;

    if (findOrderType) {
      Object.entries(this.state.insuremeValidation).map(([key, value]) => {
        if (key === "familyClaim") return;
        if (!this.state.insuremeValidation[key]) {
          error = true;
          validationError[`${key}Error`] = (
            <small className="text-danger">Field is required.</small>
          );
        }
      });
      this.setState({ insuremeValidationErrors: validationError });
    }

    const findThisInsuremeOrderPartialClaimed = this.state.inputList.filter(
      (item) => !item.isChecked,
    );
    if (
      this.state.isInsureme &&
      findThisInsuremeOrderPartialClaimed.length > 0
    ) {
      error = true;
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            title="Sorry! You can't submit this InsureMe order"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please mark all medicines claimable </h4>
          </SweetAlert>
        ),
      });
    }

    // if (!error && this.state.isClaimableOrder) {
    //   this.setState({ isClaimConfirmationModalOpen: true });
    //   return;
    // }

    if (!error) {
      //if(1)
      if (this.state.quotenotification == false) {
        this.setState({
          alertquote: (
            <SweetAlert
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              onConfirm={() => this.oncheckquote()}
              onCancel={() => this.hideAlertquote()}
              confirmBtnBsStyle="info"
              cancelBtnBsStyle="danger"
              confirmBtnText="Yes!"
              cancelBtnText="Cancel"
              showCancel
            >
              <h4>
                This is a quote less order, are you sure you want to send quote
                ?
              </h4>
            </SweetAlert>
          ),
        });
      } else if (this.state.quotenotification == true) {
        /*if (
          this.state.totalcost > 5000 &&
          this.state.paymentoption.value == "Cash" &&
          this.state.order_type == 1
        ) {
          this.setState({
            ispaywarning: true,
          });
        } else {*/
        this.setState({ isLoading: true /*, ispaywarning: false*/ });
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        let orderItemsform = [];
        this.setState({ alertquote: null });
        this.state.inputList.map((x, i) => {
          if (x.margin_discount_sub_type == 2) {
            var itemT = parseInt(x.item_type);
            orderItemsform.push({
              id: x.description,
              quantity: x.quantity,
              item_type: x.item_type,
              margin_discount_sub_type: x.margin_discount_sub_type,
              margin_discount_price: x.newmargin,
              margin_discount_percentage: 0,
              item_id: x.orderItemNumber,
              claimable: x.isChecked,
              item_description: x.item_description,
              unit_price: x.unitprice,
              is_printable: x.is_printable,
            });
          } else if (x.margin_discount_sub_type == 1) {
            var itemT = parseInt(x.item_type);
            orderItemsform.push({
              id: x.description,
              quantity: x.quantity,
              item_type: itemT,
              margin_discount_price: 0,
              margin_discount_sub_type: x.margin_discount_sub_type,
              margin_discount_percentage: x.margin_discount_percentage,
              item_id: x.orderItemNumber,
              claimable: x.isChecked,
              item_description: x.item_description,
              unit_price: x.unitprice,
              is_printable: x.is_printable,
            });
          }
        });

        const channel = this.state.channel;
        const created_by = token.id;
        const date = new Date(this.state.orderdate);
        var dd = ("0" + date.getDate()).slice(-2);
        var mm = ("0" + (date.getMonth() + 1)).slice(-2);
        var yyyy = date.getFullYear();
        var today = yyyy + "-" + mm + "-" + dd;

        var priscription_data = "";
        var prescription_text = "";
        if (this.state.selectedFile.length != 0) {
          this.setState({ processing: true });

          const fdata = new FormData();

          this.state.selectedFile.map((file) => {
            for (var i = 0; i < file.length; i++) {
              fdata.append("presription_file[]", file[i]);
            }
          });

          let url =
            process.env.REACT_APP_NOT_SECRET_CODE + "/orders/prescription";
          await axios
            .post(url, fdata, {
              headers: {
                Authorization: "Bearer " + obj,
                "X-Country-Code": "BD",
                "X-Client-Name": "WEBSITE",
                "X-Client-Version": "123",
                "Content-Type": "application/json",
                "X-Request-Id": "124",
              },
            })
            .then((res) => {
              priscription_data = res.data.data.prescription_url;
            });
        } else {
          let pdata = [];
          let ptext = "";
          this.state.priscriptionurl.map((p) => {
            if (p.prescription_url.prescription_file.length != 0) {
              pdata.push(p.prescription_url.prescription_file);
            }
          });

          prescription_text = this.state.prescription_text;
          priscription_data = pdata;
        }

        var marginvalue = "";
        if (this.state.margintype == 1) {
          if (this.state.marginfinalamount != null) {
            marginvalue = parseFloat(this.state.marginfinalamount);
          } else {
            marginvalue = 0;
          }
        } else if (this.state.margintype == 2) {
          if (this.state.marginfinalamount != null) {
            marginvalue = parseFloat(this.state.marginfinalamount);
          } else {
            marginvalue = 0;
          }
        }
        var discountper = 0;
        if (this.state.dynamicfinalpercentage != 0) {
          discountper = parseFloat(this.state.dynamicfinalpercentage);
        } else {
          discountper = parseFloat(this.state.discount);
        }
        // }
        // else
        // {
        //   discountper = 0
        // }

        var tag = [];
        if (this.state.healthcondition == null) {
          tag = "";
        } else {
          this.state.healthcondition.map((data) => {
            var array1 = tag;
            var array2 = array1.concat(data.label);
            tag = array2;
          });
        }

        let paymentop = "";
        if (this.state.paymentoption.value != null) {
          paymentop = this.state.paymentoption.value;
        } else {
          this.state.paymentoption.map((po) => {
            paymentop = po.value;
          });
        }

        var riderinfo = "";

        if (this.state.rider_id == null) {
          if (this.state.rider_id != null) {
            riderinfo = this.state.rider_id.value;
          } else {
            riderinfo = "";
          }
        } else {
          // return;
          if (this.state.rider_id != null) {
            // this.state.rider_id.map(ri=>{

            if (this.state.rider_id.value != null) {
              riderinfo = this.state.rider_id.value;
            } else {
              riderinfo = "";
            }
            // })
          }
        }

        var currier_partner_id = "";
        var c_c = 0;
        if (this.state.currier_disabled == "no") {
          c_c = 1;
          currier_partner_id = this.state.currier_id.value;
        } else {
          c_c = 0;
          currier_partner_id = riderinfo;
        }

        var deliveryType = this.state.deliverytype.value;
        if (deliveryType == 1) {
          this.setState({
            delivery_from_date: this.state.datarange.start.format("YYYY-MM-DD"),
            delivery_to_date: this.state.datarange.end.format("YYYY-MM-DD"),
          });
        } else {
          this.setState({ delivery_from_date: "", delivery_to_date: "" });
        }

        var subOrderType = "1";
        var PO_No = this.state.po_number;
        var PNDoc = this.state.PNdocUrl;
        var GRNDoc = this.state.GRNDocUrl;

        if (this.state.sub_orderType == true) {
          subOrderType = "2";
        } else {
          PO_No = "";
          PNDoc = [];
          GRNDoc = [];
        }

        var orderSource = this.state.source.value;

        this.setState({ processing: false }, () => {
          updateQuote(
            this.state.subscriber,
            orderSource,
            this.state.opharmareferance,
            today,
            this.state.prescription,
            this.state.priscriptionurl,
            deliveryType,
            this.state.deliverycharge,
            this.state.lastsubscriptionorder,
            this.state.address_id,
            this.state.addressline1,
            this.state.addressline2,
            this.state.city,
            this.state.postalcode,
            this.state.country,
            channel,
            this.state.isAbusableOrder,
            orderItemsform,
            obj,
            this.state.basketvalue,
            this.state.totalcost,
            this.state.lastsubscriptionorder,
            this.state.email,
            this.state.name,
            this.state.mobileno,
            this.state.phoneno,
            this.state.status,
            priscription_data,
            this.state.margintype,
            marginvalue,
            discountper,
            tag,
            paymentop,
            prescription_text,
            this.state.not_get_medicine,
            this.props.match.params.id,
            this.state.deleteditems,
            this.state.rider_id ? this.state.rider_id.value : "",
            c_c,
            this.state.tracking_id,
            this.state.tracking_note,
            this.state.tracking_url,
            this.state.delivery_from_date,
            this.state.delivery_to_date,
            subOrderType,
            PO_No,
            PNDoc,
            GRNDoc,
            this.state.refillableOrder,
            this.state.item_description,
            this.state.latitude,
            this.state.longitude,
            this.state.addressType,
            this.state.customAddress,
          )
            .then((res) => {
              if (res.data.success === false) {
                this.setState({ processing: true });
                if (res.data.data.length != 0) {
                  var ermessage = [];
                  for (var key of Object.keys(res.data.data)) {
                    var data = res.data.data[key];
                    ermessage.push(data);
                  }
                  this.setState({ errormessages: ermessage });
                  this.setState({ isLoading: false });
                } else {
                  this.handleClick("bl");
                  this.setState({ isLoading: false });
                }
              } else if (res.data.success === true) {
                this.setState({ processing: true });
                this.handleSuccess("bl");
                setTimeout(() => {
                  this.setState({ isLoading: false });
                  this.props.history.push("/admin/order_list");
                }, 3000);
              }
              // this.props.history.push('/admin/order_list');
            })
            .catch((error) => {
              this.setState({ isLoading: false });
              this.handleNetworkError("bl");
            });
        });
        //}
      }
    }
  }

  handleBarcodeNoChange = (event, id, index) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    if (event.target.value[0] === "F") {
      self.setState({
        name: event.target.value.trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentBarcodeNot(self.state.name, index);
        }, 500),
      });
    } else {
      self.setState({
        name: event.target.value.substring(1, 7).trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentBarcode(self.state.name, index);
        }, 500),
      });
    }
    // if(barcode.trim()[0] == "F"){
    //   if (barcode.length == 8) {
    //     if(previousPoId != id){
    //       sendToParentWhenBarcodeScanned(barcode.trim(),id,index);
    //       setpreviousPoId(id)
    //       setpreviousBarcode(barcode)
    //       }
    //       else if(previousBarcode != barcode){
    //         sendToParentWhenBarcodeScanned(barcode.trim(),id,index);
    //       }
    //   }
    // }
    // else{
    //   if (barcode.length == 7) {
    //     if(previousPoId != id){
    //       sendToParentWhenBarcodeScanned(barcode.substring(1,7).trim(),id,index);
    //       setpreviousPoId(id)
    //       setpreviousBarcode(barcode)
    //       }
    //       else if(previousBarcode != barcode){
    //         sendToParentWhenBarcodeScanned(barcode.substring(1,7).trim(),id,index);
    //       }

    //   }

    // }

    // setPoItemValues((prev) =>
    //   prev.map((poItem) => {
    //     if (poItem.id === id) {
    //       return {
    //         ...poItem,
    //         barcode: barcode,
    //       };
    //     }

    //     return poItem;
    //   })
    // );
  };

  openprescriptionmodal(urls) {
    this.setState({ prescriptionmodal: true });
  }
  closeprescriptionmodal() {
    this.setState({ prescriptionmodal: false });
  }

  openmarginmodal() {
    this.setState({ marginmodal: true });
  }
  opendiscountmodal() {
    this.setState({ discountmodal: true });
  }
  viewCreditNote() {
    this.setState({ isCreditNoteModalOpen: true });
  }

  closedynamicdiscount() {
    var dd = "";
    if (
      this.state.discountpercentage == 0 ||
      this.state.discountpercentage == null
    ) {
      this.setState({ discountpercentage: 0 });
    } else {
      this.setState({ discountpercentage: this.state.discountpercentage });
    }
    this.setState({
      discountmodal: false,
      // dynamicfinalpercentage : 0
    });
  }
  closedynamicmargin() {
    var margin = "";
    if (this.state.margintype == 1) {
      if (
        this.state.marginpercentage == null ||
        this.state.marginpercentage == 0
      ) {
        this.setState({ marginpercentage: 0 });
      } else {
        this.setState({ marginpercentage: this.state.marginpercentage });
      }
    } else if (this.state.margintype == 2) {
      if (this.state.marginamount == null || this.state.marginamount == 0) {
        this.setState({ marginamount: 0 });
      } else {
        this.setState({ marginamount: this.state.marginamount });
      }
    }

    this.setState({
      marginmodal: false,
      // marginfinalamount : margin
    });
  }
  pdfGenerateCall = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    try {
      let res = await DownloadOrder(this.props.match.params.id, obj);
      this.setState({ pdfDownloadUrl: res.data.data.pdf_url });
      return res.data.success;
    } catch (err) {
      console.log(err);
    }
  };
  async viewPdfDetails(id) {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ isLoading: true });
    await this.confirmUpdate("temporaryPdfUpdate");
    await this.handleOrderByIdData();
    this.setState({ pdfloading: true });
    await downloadOrderPdf(id, obj)
      .then((res) => {
        this.setState({ pdfloading: false, isLoading: false });
        const pdfUrl = res.data.data.pdf_url;
        if (pdfUrl) {
          window.open(pdfUrl, "_blank");
        } else {
          console.error("PDF URL not available.");
        }
      })
      .catch((error) => {
        this.setState({ pdfloading: false });
        console.error("Error fetching PDF:", error);
      });
  }
  odocFunction = () => {
    if (this.state.opharmareferance) {
      const odocOrdersList = {
        1: "submitted",
        2: "processing",
        3: "dispatched",
        4: "delivered",
        5: "cancelled",
        6: "attempted",
        7: "unreachable",
        8: "created",
        9: "new",
      };

      const odocAdressObjRaw = this.state.addressdata.find(
        (val) => (val.id = this.state.address_id),
      );
      let odocAdressObj;
      if (odocAdressObjRaw) {
        odocAdressObj = {
          address_line1: odocAdressObjRaw.address_line1,
          address_line2: odocAdressObjRaw.address_line2,
          city: this.state.city_info.find(
            (val) => val.id == odocAdressObjRaw.city,
          ).city_name,
          country: this.state.country_detail.find(
            (val) => val.id == odocAdressObjRaw.country_id,
          ).country_name,
        };
      } else {
        odocAdressObj = {
          address_line1: this.state.addressline1,
          address_line2: this.state.addressline2,
          city: this.state.city_info.find((val) => val.id == this.state.city)
            .city_name,
          country: this.state.country_detail.find(
            (val) => val.id == this.state.country,
          ).country_name,
        };
      }

      const odocAdress = Object.values(odocAdressObj).join();
      const odocNote = this.state.ordernote;
      const opharmareferanceRaw = this.state.opharmareferance.split("-");
      const odocID = opharmareferanceRaw[opharmareferanceRaw.length - 1];
      const odocDeliveryType =
        this.state.deliverytype.value == 1 ? "standard" : "express";

      fetch(this.state.pdfDownloadUrl)
        .then(async (response) => {
          const newBlob = await response.blob();
          const blob = new Blob([newBlob], { type: "application/pdf" });
          this.setState({ pdfFile: blob });

          const formData = new FormData();
          formData.append("file", this.state.pdfFile);
          formData.append("data[address]", odocAdress);
          formData.append("data[deliveryMethod]", odocDeliveryType);
          formData.append("data[partnerStatus]", "processing");
          formData.append("data[notes]", odocNote);
          formData.append("data[price]", this.state.totalcost);

          await oDocApiCall(odocID, formData);
        })
        .catch((err) => console.log(err));
    }
  };

  submitdynamicdiscount() {
    this.handlebasketandsubtotal();
    var dd = "";
    if (
      this.state.discountpercentage != null ||
      this.state.discountpercentage != 0
    ) {
      dd = this.state.discountpercentage;
    } else {
      dd = 0;
    }
    this.setState({
      discountmodal: false,
      dynamicfinalpercentage: dd,
    });
  }
  submitdynamicmargin() {
    this.handlebasketandsubtotal();

    var margin = "";
    if (this.state.margintype == 1) {
      if (
        this.state.marginpercentage != null ||
        this.state.marginpercentage != 0
      ) {
        margin = this.state.marginpercentage;
      } else {
        margin = 0;
      }
      this.setState({ displaymarginpercentage: margin });
    } else if (this.state.margintype == 2) {
      if (this.state.marginamount != null || this.state.marginamount != 0) {
        margin = this.state.marginamount;
      } else {
        margin = 0;
      }
      this.setState({ displaymarginamount: margin });
    }

    this.setState({
      marginmodal: false,
      marginfinalamount: margin,
    });
  }

  deliveryTypeLabel(deliveryValue) {
    switch (deliveryValue) {
      case "1":
        return "standard";
      case "2":
        return "express";
      case "3":
        return "island_wide";
      case "4":
        return "pick_up_wide_delivery_charge";
    }
  }

  deliveryTypeLabel3(deliveryValue) {
    switch (deliveryValue) {
      case "1":
        return "standard_delivery_charge";
      case "2":
        return "express_delivery_charge";
      case "3":
        return "island_wide_delivery_charge";
      case "4":
        return "pick_up_wide_delivery_charge";
    }
  }
  handleDeliveryTypeOnChange(value) {
    this.setState({ deliverytype: value });
    if (this.state.store !== 1 && this.state.store !== null) {
      this.setState({
        deliverycharge: 0,
        isDeliveryCharge: true,
      });
      this.handlebasketandsubtotal();
      return;
    }
    if (this.state.sub_orderType === false) {
      const deliveryValue =
        this.state.DeliveryChargeValues &&
        this.state.DeliveryChargeValues.find(
          (deliveryChargeValue) =>
            deliveryChargeValue.setting_key ===
            this.deliveryTypeLabel3(value.value),
        );
      var deliveryCharge = parseFloat(Number(deliveryValue.setting_value));
      this.setState({ deliverycharge: deliveryCharge });
      this.handlebasketandsubtotal();
    } else {
      this.setState({ deliverycharge: 0 });
    }
  }

  handlebasketandsubtotal() {
    var data = 0;
    var final = 0;
    var basketamount = 0;
    this.setState({ loading: true }, () => {
      this.state.inputList &&
        this.state.inputList.map((bas) => {
          data = parseFloat(data) + parseFloat(bas.subtotal);
        });
      basketamount = parseFloat(data);

      var discount = 0;
      if (this.state.dynamicfinalpercentage != 0) {
        discount = parseFloat(this.state.dynamicfinalpercentage);
      } else {
        discount = parseFloat(this.state.discount);
      }

      var discount_amount = 0;
      var amount = parseFloat(data) + parseFloat(this.state.deliverycharge);

      if (discount != 0) {
        discount_amount =
          (parseFloat(basketamount) * parseFloat(discount)) / 100;
      }

      var package_discount = 0;
      var package_discount_amount = 0;
      let promotionDiscount = this.state.isPromotionOrder
        ? this.state.discountamount
        : 0;
      if (
        this.state.is_flash_point == 1 ||
        this.state.is_LeadB2B == 1 ||
        this.state.sub_orderType == true ||
        this.state.isPromotionOrder
      ) {
        var package_discount = parseFloat(0);
      } else {
        var package_discount = parseFloat(this.state.catPackageDiscount);
        if (
          (discount_amount != 0 || discount_amount != "NaN") &&
          !this.state.isPromotionOrder
        ) {
          package_discount_amount =
            (parseFloat(basketamount) * parseFloat(package_discount)) / 100;
        } else {
          package_discount_amount = 0;
        }
      }
      var totalvalue = 0;

      if (this.state.used_credit_point != 0) {
        totalvalue =
          parseFloat(amount).toFixed(2) -
          parseFloat(discount_amount).toFixed(2) -
          parseFloat(package_discount_amount).toFixed(2) -
          parseFloat(promotionDiscount).toFixed(2) -
          parseFloat(this.state.used_credit_point).toFixed(2);
      } else if (this.state.isClaimableOrder) {
        totalvalue =
          parseFloat(amount).toFixed(2) -
          parseFloat(promotionDiscount).toFixed(2) -
          parseFloat(discount_amount).toFixed(2);
      } else {
        totalvalue =
          parseFloat(amount).toFixed(2) -
          parseFloat(promotionDiscount).toFixed(2) -
          // parseFloat(package_discount_amount).toFixed(2) -
          parseFloat(discount_amount).toFixed(2);
      }
      if (this.state.coupon_discountamount != null) {
        //  data = data - this.state.coupon_discountamount;
        totalvalue =
          totalvalue -
          this.state.coupon_discountamount -
          Number(promotionDiscount);
      }
      // alert(data + " =" + this.state.coupon_discountamount);
      data = data.toFixed(2);
      totalvalue = totalvalue.toFixed(2);
      if (this.state.coupon_discountamount != null) {
        //  data = data - this.state.coupon_discountamount;
        //totalvalue = totalvalue - this.state.coupon_discountamount;
      }

      discount_amount = discount_amount.toFixed(2);
      this.setState({
        loading: false,
        basketvalue: data,
        totalcost: totalvalue,
        // discountamount: parseFloat(discount_amount),
        catPackageDiscountAmount: package_discount_amount,
      });
    });
  }

  handleDeliveryChange = (event) => {
    this.setState({ deliverycharge: Number(event.target.value) });
    this.handlebasketandsubtotal();
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    if (name == "margintype") {
      this.setState({ marginfinalamount: 0 });
    }
    this.handlebasketandsubtotal();
    if (name == "country") {
      if (value != 0) {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var country_id = value;
        let billingAddress = this.state.billing_address_id;
        this.addrssselect(0, value, billingAddress, value);
        getCity(obj, country_id).then((res) => {
          this.setState({ city_info: res.data });
        });
      } else if (value == "0") {
        this.setState({ city_info: [] });
      }
    }
    if (name == "deliverytype") {
      if (value == "2") {
        if (this.state.packagefeatures.length > 0) {
          if (this.state.packagefeatures[0].express != "") {
            this.setState({
              deliverycharge: 0,
              isDeliveryCharge: true,
            });
          } else {
            this.setState({
              deliverycharge: this.state.expressdeliverychargevalue,
              isDeliveryCharge: false,
            });
          }
        } else {
          this.setState({
            deliverycharge: this.state.expressdeliverychargevalue,
            isDeliveryCharge: false,
          });
        }
      } else {
        this.setState({
          deliverycharge: 0,
          isDeliveryCharge: false,
        });
      }
    }
    if (name == "source") {
      if (value == "2") {
        this.setState({ mypharmareferance: "" });
      } else if (value == "3") {
        this.setState({ opharmareferance: "" });
      } else if (value == "4") {
        this.setState({ opharmareferance: "" });
        this.setState({ mypharmareferance: "" });
      }
    }
    if (name == "city") {
      if (value != "0") {
        // change as set logic according to country
        // this.addrssselect(0,value)
      }
    }
    if (name == "subscriber") {
      this.handlebasketandsubtotal();
      this.handleb2bdetails();
      this.setState({
        lastsubscription: [],
        name: "",
        email: "",
        phoneno: "",
        mobileno: "",
        addressline1: "",
        addressline2: "",
        city: "0",
        country: "0",
        // deliverycharge : 0,

        postalcode: "",
        // lastsubscription : []
      });
    }
  };
  lastorderdetail(id) {
    this.setState({
      showModal: true,
      quanitydata: [],
      medicationdata: [],
      medicationdataList: [],
    });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getOrdersbyid(id, obj).then((res) => {
      var data = res.data.orderItems;

      // var array1 = this.state.quanitydata;
      // var array2 = array1.concat( data)
      let medi_array = [];
      const newdata = data.map((mydata) =>
        getmedicationdatabyid(mydata.medication_id, obj).then((mdata) => {
          medi_array.push({ medicine: mdata.data, quantity: mydata.quantity });
          this.setState({
            medicationdataList: medi_array,
          });
        }),
      );

      this.setState({
        subscriptiondetail: res.data,
        quanitydata: data,
      });
    });
  }

  async lastorderdata(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let compelte = 1;
    let pg_no = 1;
    while (compelte == 1) {
      this.setState({ noRecordFound: false });
      await searchlastsubscription(id, pg_no, obj).then((res) => {
        var orderdata = res.data;

        if (orderdata.data.length == 0) {
          this.setState({ noRecordFound: true });
        }

        if (orderdata.data.length == 0) {
          compelte = 0;
        } else {
          compelte = 0;
          var array1 = this.state.lastsubscription;
          var array2 = array1.concat(orderdata.data);

          this.setState({
            lastsubscription: array2,
          });
        }
      });
      pg_no++;
    }
  }
  handleShowAllocatedMedicineModal(medicineId) {
    this.setState({ showAllocatedValue: true });
    this.handleAllocatedValuePop(medicineId);
  }
  async handleAllocatedValuePop(id) {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await allocationValuePopUp(id, obj)
      .then((res) => {
        const data = res.data;
        this.setState({ allocatedData: data });
      })
      .catch((error) => {
        console.error("Error fetching allocated data:", error);
      });
  }

  handleb2bdetails() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ loading: true }, () => {
      let detail = this.state.subscriber_detail;
      if (this.state.subscriber == detail.id) {
        if (
          detail.lead_catalogue_package != null &&
          detail.lead_catalogue_package != [] &&
          detail.lead_catalogue_package != ""
        ) {
          const leadCataloguePackageDetailsOld =
            detail.lead_catalogue_package.find((data) => data);
          const leadCataloguePackageDetailsNew =
            detail.lead_catalogue_package.find(
              (data) => data.package_id === this.state.originPackageId,
            );
          let leadCataloguePackageDetails = leadCataloguePackageDetailsNew
            ? leadCataloguePackageDetailsNew
            : leadCataloguePackageDetailsOld;
          this.setState({
            cataloguePackageId: leadCataloguePackageDetails.package_id,
          });
          var packagediscount = 0;
          var features = [];
          var packagefeatues = {
            raya: "",
            express: [],
            mad: "",
          };

          var raya = "";
          var express = "";
          var mad = "";
          let claim = [];

          var packageLength = leadCataloguePackageDetails.length;
          var fetlist =
            leadCataloguePackageDetails.lead_catalogue_package_feature;
          for (let i = 0; i < fetlist.length; i++) {
            if (fetlist[i].feature_title == "raya_flat_discount") {
              var raya = fetlist[i];
            } else if (fetlist[i].feature_title == "lab_discount") {
              var lab = fetlist[i];
            } else if (fetlist[i].feature_title == "medicine_discount") {
              var mad = fetlist[i];
            } else if (fetlist[i].feature_title == "delivery") {
              var express = fetlist[i];
            } else if (
              fetlist[i].feature_title == "claim" &&
              JSON.parse(fetlist[i].feature_value).length !== 0
            ) {
              claim = JSON.parse(fetlist[i].feature_value);
              const findCreditType = claim.find((item) => item);
              this.setState({
                claimCreditType: findCreditType.creditType,
                isPackageHasClaimMedicineAllowed: findCreditType.medicine,
              });
            }
          }

          if (
            raya.feature_value != null &&
            raya.feature_value != 0 &&
            raya.is_active == 1
          ) {
            packagefeatues.raya = raya.feature_value;
          }
          if (express.feature_value != null && express.is_active == 1) {
            packagefeatues.express = JSON.parse(express.feature_value);
            if (this.state.deliverytype.value == 2) {
              this.setState({
                isDeliveryCharge: true,
              });
            }
          }
          if (
            mad.feature_value != null &&
            mad.feature_value != 0 &&
            mad.is_active == 1
          ) {
            packagefeatues.mad = mad.feature_value;
          }

          let originalFeatureValue = [];
          if (
            express.original_feature_value != null &&
            express.is_active == 1
          ) {
            originalFeatureValue.push(
              JSON.parse(express.original_feature_value),
            );
          }

          features.push(packagefeatues);

          if (
            this.state.order_type == 1 &&
            mad.feature_value != null &&
            mad.feature_value != 0
          ) {
            if (mad.is_active == 1) {
              packagediscount = parseInt(mad.feature_value);
            }
          } else if (
            this.state.order_type == 2 &&
            raya.feature_value != null &&
            raya.feature_value != 0
          ) {
            if (raya.is_active == 1) {
              packagediscount = parseInt(raya.feature_value);
            }
          }

          if (leadCataloguePackageDetails.catalogue_package != null) {
            var catpackage = leadCataloguePackageDetails.catalogue_package;
            var packagename = catpackage.title;
            var packageid = catpackage.id;
            const logo =
              packageid === this.state.originPackageId
                ? catpackage.package_logo
                : (detail.b2b && detail.b2b.company_logo) || "";
            this.setState({
              catalougepackageId: packageid,
              catalougepackagename: packagename,
              catPackageDiscount: packagediscount,
              packagefeatures: features,
              originalFeatureValue: originalFeatureValue,
              is_LeadB2B: detail.is_b2b,
              logo_1: logo,
            });
          }
        } else {
          this.setState({
            catalougepackageId: "",
            catalougepackagename: "",
            catPackageDiscount: 0,
            packagefeatures: [],
          });
        }

        if (detail.b2b == null) {
          this.setState({
            loading: false,
            companyname: "",
            // deliverycharge : 0,
            companynote: "",
            discount: 0,
            b2baccess: 0,

            // discountpercentage : 0,

            loading: false,
            name: detail.name,
            email: detail.email,
            phoneno: detail.phone,
            mobileno: detail.mobile_no,
            // earn_points : detail.earn_points,
            addressdata: detail.address,
            username: detail.name,
            useremail: detail.email,
            occupation: `${
              detail.lead_detail ? detail.lead_detail.occupation : ""
            }`,
            userphone: detail.phone,
            usermobile: detail.mobile_no,
          });
        } else {
          var discount = "";
          if (detail.b2b["discount"] == null) {
            discount = 0;
          } else {
            discount = detail.b2b["discount"];
          }
          console.log("detail.address", detail.address);
          this.setState({
            loading: false,
            b2baccess: 1,
            companyname: detail.b2b["company_name"],
            // deliverycharge : detail.delivery_charge,
            b2bdeliverycharge: detail.b2b["delivery_value"],
            companynote: detail.b2b["note"],
            discount: discount,
            addressdata: detail.address,
            addressline1: detail.address["address_line1"],
            addressline2: detail.address["address_line2"],
            city: detail.address["city"],
            // country: detail.address["country_id"],
            postalcode: detail.address["postal_code"],
            companyname: detail.b2b["company_name"],
            companynote: detail.b2b["note"],
            username: detail.name,
            useremail: detail.email,
            occupation: `${
              detail.lead_detail ? detail.lead_detail.occupation : ""
            }`,
            userphone: detail.phone,
            usermobile: detail.mobile_no,
            // latitude: detail.latitude,
            // longitude: detail.longitude,
            // input: `${detail.latitude},${detail.longitude}`,
            // earn_points : detail.earn_points,

            // discountpercentage : 0,
          });
        }
      }
    });
  }
  subdetail() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    get_lead_old_data(this.state.leadid, obj).then((res) => {
      const data = res.data;
      if (data.b2b == null) {
        this.setState({
          companyname: "",
          // deliverycharge : '',
          companynote: "",
          discount: 0,
        });
      } else {
        this.setState({
          companyname: data.b2b["company_name"],
          // discount : data.b2b['discount'],
          companynote: data.b2b["note"],
        });
      }
    });
  }

  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;
    const nonEmptyMedicationList = this.state.inputList.filter(
      (item) =>
        item.description !== "" &&
        item.description !== null &&
        item.description !== undefined,
    );
    this.state.inputList = nonEmptyMedicationList;
    let unCheckedMedicines = this.state.inputList.filter(
      (data) => data.isChecked === false,
    );
    this.setState({ unClaimableMedicineList: unCheckedMedicines });
    if (this.state.subscriber == "0") {
      error = true;
      this.setState({
        subscriberError: (
          <small className="text-danger">Subscriber is required.</small>
        ),
      });
    } else {
      this.setState({ subscriberError: null });
    }

    if (this.state.totalcost.length == 0) {
      error = true;
      this.setState({
        totalcostError: (
          <small className="text-danger">Total Cost is required.</small>
        ),
      });
    } else {
      this.setState({ totalcostError: null });
    }
    if (this.state.paymentoption == null) {
      error = true;
      this.setState({
        paymentoptionError: (
          <small className="text-danger">Payment Option is required.</small>
        ),
      });
    } else {
      this.setState({ paymentoptionError: null });
    }
    if (this.state.store != 1 && this.state.store != null) {
      if (this.state.inputList.length == 0) {
        error = true;
        this.setState({
          alert: (
            <SweetAlert
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              <h4>Please Enter Proper Medication data!</h4>
            </SweetAlert>
          ),
        });
      } else {
        error = false;
        this.state.inputList.map((x, i) => {
          if (x.description == "") {
            error = true;
            this.setState({
              alert: (
                <SweetAlert
                  className="order_alert"
                  style={{ display: "block", marginTop: "-100px" }}
                  onConfirm={() => this.hideAlert()}
                  onCancel={() => this.hideAlert()}
                  confirmBtnBsStyle="info"
                >
                  <h4>Please Enter Proper Medication data!</h4>
                </SweetAlert>
              ),
            });
          } else {
            if (error == true) {
              this.setState({ medicationaddError: null });
            } else {
            }
          }
        });
      }
    }
    if (this.state.addnewaddress == true) {
      if (this.state.country == "0") {
        error = true;
        this.setState({
          countryError: (
            <small className="text-danger">Country is required.</small>
          ),
        });
      } else {
        this.setState({ countryError: null });
      }

      if (this.state.city == "0") {
        error = true;
        this.setState({
          cityError: (
            <small className="text-danger">district is required.</small>
          ),
        });
      } else {
        this.setState({ cityError: null });
      }
      if (this.state.latitude == null) {
        error = true;
        this.setState({
          latiAndLogitError: (
            <small className="text-danger">
              Latitude and Longitude are required.
            </small>
          ),
        });
      } else {
        this.setState({ latiAndLogitError: null });
      }
    }
    if (
      Number(this.state.address_id) === 0 ||
      Number(this.state.address_id) === 22
    ) {
      if (this.state.addressline1.length === 0) {
        error = true;
        this.setState({
          addressline1Error: (
            <small className="text-danger">Address is required.</small>
          ),
        });
      } else {
        this.setState({
          addressline1Error: null,
        });
      }
    } else {
      this.setState({
        addressline1Error: null,
      });
    }

    if (this.state.paymentoption == null) {
      error = true;
      this.setState({
        paymentoptionError: (
          <small className="text-danger">Payment Option is required.</small>
        ),
      });
    } else {
      this.setState({ paymentoptionError: null });
    }
    if (
      this.state.opharmareferance.length == 0 &&
      this.state.source.value == "2"
    ) {
      error = true;
      this.setState({
        opharmareferanceError: (
          <small className="text-danger">oPharma referance is required.</small>
        ),
      });
    } else {
      this.setState({ opharmareferanceError: null });
    }

    if (
      this.state.mypharmareferance.length == 0 &&
      this.state.source.value == "3"
    ) {
      error = true;
      this.setState({
        mypharmareferanceError: (
          <small className="text-danger">MyPharma referance is required.</small>
        ),
      });
    } else {
      this.setState({ mypharmareferanceError: null });
    }
    //validation
    // if (this.state.isClaimableOrder) {
    //   if (unCheckedMedicines.length !== 0) {
    //     error = false;
    //   }
    // }

    const validationError = this.state.insuremeValidationErrors;
    const findOrderType = this.state.isClaimableOrder || this.state.isInsureme;

    if (findOrderType) {
      Object.entries(this.state.insuremeValidation).map(([key, value]) => {
        if (key === "familyClaim") return;
        if (!this.state.insuremeValidation[key]) {
          error = true;

          validationError[`${key}Error`] = (
            <small className="text-danger">Field is required.</small>
          );
        }
      });
      this.setState({ insuremeValidationErrors: validationError });
    }

    if (
      !error &&
      this.state.isClaimableOrder &&
      unCheckedMedicines.length > 0
    ) {
      this.setState({ isClaimConfirmationModalOpen: true });
      return;
    }

    const findThisInsuremeOrderPartialClaimed = this.state.inputList.filter(
      (item) => !item.isChecked,
    );
    if (
      this.state.isInsureme &&
      findThisInsuremeOrderPartialClaimed.length > 0
    ) {
      error = true;
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            title="Sorry! You can't submit this InsureMe order"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please mark all medicines claimable </h4>
          </SweetAlert>
        ),
      });
    }
    const shouldCheckOutOfStock =
      this.state.store !== 1 && this.state.store !== null;
    const outOfStockItems = this.state.inputList.filter(
      (item) => parseFloat(item.quantity) > parseFloat(item.availableQuantity),
    );
    if (shouldCheckOutOfStock && outOfStockItems.length > 0) {
      this.setState({
        showOutOfStockPop: true,
        medicationListing: outOfStockItems,
      });
      return;
    }

    const findSubTotalZero = this.state.inputList.filter(
      (item) => parseFloat(item.subtotal) === 0,
    );
    if (findSubTotalZero.length > 0) {
      error = true;
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            title="Sorry! You can't update this order"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please check your order, some items have selling price 0 </h4>
          </SweetAlert>
        ),
      });
    }
    if (error) {
      this.message_error.current.focus();
    }
    if (!error) {
      if (this.isPendingOrder) {
        this.setState({
          alert: (
            <SweetAlert
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              onConfirm={() => this.confirmUpdate("onSubmitUpdate")}
              onCancel={() => this.hideAlert()}
              confirmBtnText="Yes"
              cancelBtnText="No"
              confirmBtnBsStyle="info"
              cancelBtnBsStyle="danger"
              showCancel
            >
              <h4>
                Are you sure you want to update this order As Pending Item
                Status
              </h4>
            </SweetAlert>
          ),
        });
      } else {
        this.setState({
          alert: (
            <SweetAlert
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              onConfirm={() => this.confirmUpdate("onSubmitUpdate")}
              onCancel={() => this.hideAlert()}
              confirmBtnText="Yes"
              cancelBtnText="No"
              confirmBtnBsStyle="info"
              cancelBtnBsStyle="danger"
              showCancel
            >
              <h4>Are you sure you want to update this order.</h4>
            </SweetAlert>
          ),
        });
      }
    }
  }

  unCheckValidationComplete() {
    this.setState({ isClaimConfirmationModalOpen: false });
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.confirmUpdate("onSubmitUpdate")}
          onCancel={() => this.hideAlert()}
          confirmBtnText="Yes"
          cancelBtnText="No"
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          showCancel
        >
          <h4>Are you sure you want to update this order.</h4>
        </SweetAlert>
      ),
    });
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  Add_New_Medication() {
    this.setState({
      showmediactonModal: true,
      medicationerrormessage: [],
      medicationitemcodeError: null,
      medicationitemnameError: null,
      medicationunitpriceError: null,
      medicationcategoryError: null,
      medicationcityError: null,
      medicationaddcommision: "1",
      medicationdescription: "",
      medicationunitprice: 0,
      medicationitemcode: "",
      medicationitemname: "",
      medicationcategory: "",
      medicationcity: "0",
      quantity: "",
      barcode: "",
      is_flash_medicine: "",
      supplier: "",
      codeDisabled: "",
      item_description: "",
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
      itemname: "",
    });
  }
  confirmSubmit = () => {
    let error = false;
    if (this.state.medicationitemname.length == 0) {
      error = true;
      this.setState({
        medicationitemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else {
      this.setState({ medicationitemnameError: null });
    }
    if (this.state.medicationcategory == "0") {
      error = true;
      this.setState({
        medicationcategoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ medicationcategoryError: null });
    }
    if (this.state.medicationunitprice.length == 0) {
      error = true;
      this.setState({
        medicationunitpriceError: (
          <small className="text-danger">Unit Price is required.</small>
        ),
      });
    } else {
      this.setState({ medicationunitpriceError: null });
    }
    if (this.state.is_flash_medicine === 0) {
      if (this.state.medicationitemcode.length == 0) {
        error = true;
        this.setState({
          medicationitemcodeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ medicationitemcodeError: null });
      }
    } else {
      this.setState({ medicationitemcodeError: null });
    }
    if (this.state.medicationcity == "0") {
      error = true;
      this.setState({
        medicationcityError: (
          <small className="text-danger">Distrcit is required.</small>
        ),
      });
    } else {
      this.setState({ medicationcityError: null });
    }

    if (!error) {
      var packageimages = this.state.package_image_data;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var medicationaddcommision = "";
      if (this.state.medicationaddcommision == "1") {
        medicationaddcommision = "1";
      } else if (this.state.medicationaddcommision == "2") {
        medicationaddcommision = "0";
      }
      var medicationis_featured = "";
      if (this.state.medicationis_featured == "1") {
        medicationis_featured = "1";
      } else if (this.state.medicationis_featured == "2") {
        medicationis_featured = "0";
      }
      var itemCode = "";
      if (this.state.is_flash_medicine) {
        itemCode = "";
      } else {
        itemCode = this.state.item_code;
      }
      AddMedication(
        this.state.medicationitemname,
        this.state.medicationcategory,
        this.state.medicationitemcode,
        medicationaddcommision,
        this.state.medicationunitprice,
        this.state.medicationcity,
        this.state.medicationdescription,
        medicationis_featured,
        this.state.is_flash_medicine,
        this.state.barcode,
        this.state.quantity,
        this.state.display_discount,
        this.state.supplier,
        this.state.primaryimage,
        packageimages,
        this.state.tags,
        obj,
        this.state.item_description,
      )
        .then((res) => {
          if (res.data.success == false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ medicationerrormessage: ermessage });
              this.medication_item_code_error.current.focus();
              this.setState({
                medicationitemcodeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success == true) {
            var nmdata = "";
            nmdata = res.data.data;

            if (this.state.city_id == nmdata.country_id) {
              var medicationItems = [];
              if (nmdata != undefined) {
                var data = {
                  value: nmdata.id,
                  label: nmdata.title + "(" + nmdata.item_code + ")",
                };

                var array1 = this.state.medicationItems;
                var array2 = array1.concat(data);

                var array1md = this.state.medication_detail;
                var array2md = array1md.concat(res.data.data);
                /* this.setState({  medication_detail : array2md,
            medicationItems : array2,  });*/
              }
            } else {
              // this.setState({medication_detail :  this.state.medication_detail ,
              //  medicationItems : this.state.medicationItems});
            }

            this.setState({
              showmediactonModal: false,
              medicationaddcommision: "1",
              medicationdescription: "",
              medicationunitprice: 0,
              medicationitemcode: "",
              medicationis_featured: "2",
              // medicationprice : 0,
              medicationitemname: "",

              medicationcategory: "",
              medicationcity: "0",
            });
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
    }
  };
  add_new_medication_category = async () => {
    let error = false;
    if (this.state.medicationitemname.length == 0) {
      error = true;
      this.setState({
        medicationitemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else {
      this.setState({ medicationitemnameError: null });
    }
    if (this.state.medicationcategory == "0") {
      error = true;
      this.setState({
        medicationcategoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ medicationcategoryError: null });
    }
    if (this.state.medicationunitprice.length == 0) {
      error = true;
      this.setState({
        medicationunitpriceError: (
          <small className="text-danger">Unit Price is required.</small>
        ),
      });
    } else {
      this.setState({ medicationunitpriceError: null });
    }
    if (this.state.is_flash_medicine === 0) {
      if (this.state.medicationitemcode.length == 0) {
        error = true;
        this.setState({
          medicationitemcodeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ medicationitemcodeError: null });
      }
    } else {
      this.setState({ medicationitemcodeError: null });
    }
    if (this.state.medicationcity == "0") {
      error = true;
      this.setState({
        medicationcityError: (
          <small className="text-danger">District is required.</small>
        ),
      });
    } else {
      this.setState({ medicationcityError: null });
    }
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var id = "";
    await checkMedication(this.state.medicationitemname, id, obj).then(
      (res) => {
        if (res.data.success === false) {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => this.confirmSubmit(id)}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="danger"
                confirmBtnText="Yes, add it!"
                cancelBtnText="Cancel"
                showCancel
              >
                <h4>
                  This medication name already exist. Are you sure you want to
                  add it!
                </h4>
              </SweetAlert>
            ),
          });
        }
      },
    );
    if (!error) {
      var packageimages = this.state.package_image_data;
      var medicationaddcommision = "";
      if (this.state.medicationaddcommision == "1") {
        medicationaddcommision = "1";
      } else if (this.state.medicationaddcommision == "2") {
        medicationaddcommision = "0";
      }
      var medicationis_featured = "";
      if (this.state.medicationis_featured == "1") {
        medicationis_featured = "1";
      } else if (this.state.medicationis_featured == "2") {
        medicationis_featured = "0";
      }
      var itemCode = "";
      if (this.state.is_flash_medicine) {
        itemCode = "";
      } else {
        itemCode = this.state.item_code;
      }
      AddMedication(
        this.state.medicationitemname,
        this.state.medicationcategory,
        this.state.medicationitemcode,
        medicationaddcommision,
        this.state.medicationunitprice,
        this.state.medicationcity,
        this.state.medicationdescription,
        medicationis_featured,
        this.state.is_flash_medicine,
        this.state.barcode,
        this.state.quantity,
        this.state.display_discount,
        this.state.supplier,
        this.state.primaryimage,
        packageimages,
        this.state.tags,
        obj,
        this.state.item_description,
      )
        .then((res) => {
          if (res.data.success == false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ medicationerrormessage: ermessage });
              this.medication_item_code_error.current.focus();
              this.setState({
                medicationitemcodeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success == true) {
            var nmdata = "";
            nmdata = res.data.data;
            if (this.state.city_id == nmdata.country_id) {
              var medicationItems = [];
              if (nmdata != undefined) {
                var data = {
                  value: nmdata.id,
                  label: nmdata.title + "(" + nmdata.item_code + ")",
                };

                var array1 = this.state.medicationItems;
                var array2 = array1.concat(data);

                var array1md = this.state.medication_detail;
                var array2md = array1md.concat(res.data.data);
                this.setState({
                  medication_detail: array2md,
                  medicationItems: array2,
                });
              }
            } else {
              // this.setState({medication_detail :  this.state.medication_detail ,
              //  medicationItems : this.state.medicationItems});
            }

            this.setState({
              showmediactonModal: false,
              medicationaddcommision: "1",
              medicationdescription: "",
              medicationunitprice: 0,
              medicationitemcode: "",
              // medicationprice : 0,

              medicationcategory: "",
              medicationcity: 0,
            });
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
        });
    }
  };

  // Soundex algorithm for simple phonetic matching (returns 4-char code)
  soundex(str) {
    if (!str) return "";
    const s = str.toUpperCase().replace(/[^A-Z]/g, "");
    if (s.length === 0) return "";
    const first = s[0];
    const mapping = {
      B: "1",
      F: "1",
      P: "1",
      V: "1",
      C: "2",
      G: "2",
      J: "2",
      K: "2",
      Q: "2",
      S: "2",
      X: "2",
      Z: "2",
      D: "3",
      T: "3",
      L: "4",
      M: "5",
      N: "5",
      R: "6",
    };
    let prev = mapping[first] || "";
    let out = first;
    for (let i = 1; i < s.length && out.length < 4; i++) {
      const ch = s[i];
      const code = mapping[ch] || "0";
      if (code === prev) continue;
      if (code !== "0") {
        out += code;
      }
      prev = code;
    }
    // pad with zeros
    return out.padEnd(4, "0").slice(0, 4);
  }

  buildMedIndex = (medArray) => {
    try {
      this.medIndex = medArray.map((m) => {
        const label = `${m.title} (${m.item_code})`;
        const labelLower = (label || "").toLowerCase();
        let sdx = "";
        try {
          sdx = this.soundex(labelLower);
        } catch (e) {
          sdx = "";
        }
        return { value: m.id, label, labelLower, soundex: sdx };
      });
      this.medIndex.sort((a, b) => (a.labelLower > b.labelLower ? 1 : -1));
    } catch (e) {
      this.medIndex = [];
    }
  };

  loadMedicationOptions = (inputValue) => {
    if (!inputValue || inputValue.trim().length < 2) return Promise.resolve([]);
    const q = inputValue.trim();
    if (this.medSearchCache[q]) return Promise.resolve(this.medSearchCache[q]);

    if (
      (!this.medIndex || this.medIndex.length === 0) &&
      this.state.localMedicationData &&
      this.state.localMedicationData.length > 0
    ) {
      this.buildMedIndex(this.state.localMedicationData);
    }

    return new Promise((resolve) => {
      if (this._loadMedTimer) clearTimeout(this._loadMedTimer);
      this._loadMedTimer = setTimeout(() => {
        if (this.medIndex && this.medIndex.length > 0) {
          const lower = q.toLowerCase();
          const results = [];
          const LIMIT = 50;
          for (
            let i = 0;
            i < this.medIndex.length && results.length < LIMIT;
            i++
          ) {
            const m = this.medIndex[i];
            if (m.labelLower.startsWith(lower)) results.push(m);
          }
          if (results.length < LIMIT) {
            for (
              let i = 0;
              i < this.medIndex.length && results.length < LIMIT;
              i++
            ) {
              const m = this.medIndex[i];
              if (results.indexOf(m) !== -1) continue;
              if (m.labelLower.includes(lower)) results.push(m);
            }
          }
          if (results.length === 0 && lower.length >= 3) {
            const qSound = this.soundex(lower);
            for (
              let i = 0;
              i < this.medIndex.length && results.length < LIMIT;
              i++
            ) {
              const m = this.medIndex[i];
              if (m.soundex && m.soundex === qSound) results.push(m);
            }
          }
          const options = results.map((m) => ({
            value: m.value,
            label: m.label,
          }));
          try {
            const keys = Object.keys(this.medSearchCache);
            if (keys.length > 200) delete this.medSearchCache[keys[0]];
            this.medSearchCache[q] = options;
          } catch (e) {}
          return resolve(options);
        }

        this.medSearchRequestSeq++;
        const reqSeq = this.medSearchRequestSeq;
        try {
          const token = JSON.parse(localStorage.getItem("user"));
          const obj = token ? token.token : null;
          const city_id = this.state.city_id || 1;
          searchMedicationForOrder(q, city_id, 1, obj, this.state.store)
            .then((res) => {
              if (reqSeq !== this.medSearchRequestSeq) return resolve([]);
              const data = (res.data && res.data.data) || [];
              const options = data.map((medication) => ({
                value: medication.id,
                label: `${medication.title} (${medication.item_code})`,
              }));
              try {
                const keys = Object.keys(this.medSearchCache);
                if (keys.length > 200) delete this.medSearchCache[keys[0]];
                this.medSearchCache[q] = options;
              } catch (e) {}
              resolve(options);
            })
            .catch(() => resolve([]));
        } catch (e) {
          resolve([]);
        }
      }, 200);
    });
  };

  handleMedicineSelectChange = async (selectedOption, index) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const list = [...this.state.inputList];
    const isEligibleToShowAllocated = [1, 9, 13].includes(
      Number(this.state.status),
    );
    const findSelectedMedicine = this.state.localMedicationData.find(
      (med) => med.id === selectedOption.value,
    );
    if (findSelectedMedicine) {
      let partialSentQuantity = 0;
      try {
        const res = await allocationValuePopUp(findSelectedMedicine.id, obj);
        const data = res.data;
        data.forEach((item) => {
          if (item.partial_sent) {
            partialSentQuantity += Number(item.quantity) || 0;
          }
        });
      } catch (error) {
        console.error("Error fetching allocated data:", error);
      }

      list[index]["description"] = selectedOption.value;
      list[index]["selectmedication"] = selectedOption;
      list[index]["unitprice"] = parseFloat(
        findSelectedMedicine.price - 0,
      ).toFixed(2);

      list[index]["medicineData"] = findSelectedMedicine;
      list[index]["medi_title"] = selectedOption.label
        .split(/\(\w+-\d+\) - \d+/)[0]
        .trim();
      const match = selectedOption.label.match(/\(([^)]+)\)/);
      list[index]["medi_itemcode"] = match ? match[1] : "";
      list[index]["selling_price"] = findSelectedMedicine.price;
      list[index]["barcode"] = findSelectedMedicine.barcode;
      const actualAllocatedQuantity = Number(
        findSelectedMedicine.total_allocated,
      );
      list[index]["total_allocated"] = actualAllocatedQuantity;
      // -
      // Number(partialSentQuantity);
      const actualAvailableQuantity = Number(
        findSelectedMedicine.total_quantity,
      );
      //  - actualAllocatedQuantity;
      list[index]["availableQuantity"] = actualAvailableQuantity;
      if (!!isEligibleToShowAllocated) {
        list[index]["availableQuantity"] = actualAvailableQuantity;
      } else {
        list[index]["availableQuantity"] =
          actualAvailableQuantity > 0 ? actualAvailableQuantity : 0;
      }
      list[index]["location"] =
        findSelectedMedicine.xcoord && findSelectedMedicine.ycoord
          ? `${findSelectedMedicine.ycoord}${findSelectedMedicine.xcoord}`
          : null;

      list[index]["subtotal"] =
        list[index]["unitprice"] * list[index]["quantity"];
      const availableQuantity = parseFloat(list[index]["availableQuantity"]);
      if (
        list[index]["isPartialOrderItem"] &&
        availableQuantity < 1 &&
        !isEligibleToShowAllocated
      ) {
        this.setState({ isWrongQuantity: true });
        this.setState({ wrongFieldId: index });
      } else {
        this.setState({ isWrongQuantity: false });
        this.setState({ wrongFieldId: "" });
      }

      if (
        list[index]["isPartialOrderItem"] &&
        (Number(list[index]["quantity"]) > availableQuantity ||
          0 === availableQuantity)
      ) {
        this.setState({ isOverQuantity: index });
      } else {
        this.setState({ isOverQuantity: "" });
      }

      this.handlebasketandsubtotal();
      // this.setState({ inputList: list });
      this.setState({ inputList: list }, () => {
        const nextIndex = index + 1;
        if (
          this.inputRef.current &&
          this.inputRef.current[nextIndex] &&
          this.inputRef.current[nextIndex].focus
        ) {
          this.inputRef.current[nextIndex].focus(); // FOCUS NEXT FIELD
        }
      });
    }
    // this.handleSelectChange(index, selectedOption);
  };

  // handleSelectChange = async (index, value) => {
  //   let name = "description";
  //   const list = [...this.state.inputList];
  //   list[index][name] = value.value;
  //   var temp_arr = [];
  //   const isEligibleToShowAllocated = [1, 9, 13].includes(
  //     Number(this.state.status)
  //   );
  //   var token = JSON.parse(localStorage.getItem("user"));
  //   const obj = token.token;
  //   if (list[index]["item_type"] == "1") {
  //     await Promise.all(
  //       this.state.medication_detail.map((pac) => {
  //         if (list[index]["description"] == pac.id) {
  //           list[index]["unitprice"] = parseFloat(pac.price - 0).toFixed(2);
  //         }
  //       })
  //     );

  //     list[index]["medicationItems"] = temp_arr;
  //     list[index]["selectmedication"] = value;

  //     await Promise.all(
  //       this.state.medication_detail[index].map(async (medi) => {
  //         if (list[index]["description"] == medi.id) {
  //           let partialSentQuantity = 0;
  //           await allocationValuePopUp(medi.id, obj)
  //             .then((res) => {
  //               const data = res.data;
  //               const ReducePartialOrderQuantity = data.filter((item) => {
  //                 if (item.partial_sent) {
  //                   partialSentQuantity = partialSentQuantity + item.quantity;
  //                 }
  //               });
  //             })
  //             .catch((error) => {
  //               console.error("Error fetching allocated data:", error);
  //             });
  //           // const matchingItem = this.state.inputList.filter(
  //           //   (item) => item.description === medi.id
  //           // );

  //           // // let matchingItemQuantity = 0;
  //           // // matchingItem.forEach((matchingItm) => {
  //           // //   matchingItemQuantity =
  //           // //     Number(matchingItm.quantity) + matchingItemQuantity;
  //           // // });

  //           // if (matchingItem.length > 1) {
  //           //   const currentTotalQuantity =
  //           //     medi.total_quantity - matchingItem[0].quantity;

  //           //   list[index]["unitprice"] = parseFloat(medi.price - 0).toFixed(2);
  //           //   list[index]["selling_price"] = medi.price;
  //           //   list[index]["total_quantity"] = currentTotalQuantity;
  //           //   list[index]["availableQuantity"] = currentTotalQuantity;
  //           //   list[index]["barcode"] = medi.barcode;

  //           //   if (currentTotalQuantity >= list[index]["quantity"]) {
  //           //     list[index]["isPartialOrderItem"] = true;
  //           //   } else {
  //           //     list[index]["isPartialOrderItem"] = false;
  //           //   }
  //           // } else {
  //           list[index]["unitprice"] = parseFloat(medi.price - 0).toFixed(2);
  //           const actualAllocatedQuantity =
  //             Number(medi.total_allocated) - Number(partialSentQuantity);
  //           const actualAvailableQuantity =
  //             Number(medi.total_quantity) - actualAllocatedQuantity;
  //           if (!!isEligibleToShowAllocated) {
  //             list[index]["availableQuantity"] = Number(medi.total_quantity);
  //           } else {
  //             list[index]["availableQuantity"] =
  //               actualAvailableQuantity > 0 ? actualAvailableQuantity : 0;
  //           }
  //           list[index]["total_allocated"] = medi.total_allocated;
  //           list[index]["medicineData"] = medi;
  //           list[index]["medi_title"] = value.label
  //             .split(/\(\w+-\d+\) - \d+/)[0]
  //             .trim();
  //           list[index]["medi_itemcode"] = value.label.match(/\(([^)]+)\)/)[1];
  //           //list[index]['orderItemNumber'] = medi.order_item_id
  //           list[index]["selling_price"] = medi.price;
  //           list[index]["barcode"] = medi.barcode;

  //           // if (Number(medi.total_quantity) === 0) {
  //           //   // list[index]["quantity"] = medi.total_quantity;
  //           //   this.setState({ isWrongQuantity: true });
  //           // }

  //           // list[index]["item_description"] = medi.description;
  //           // if (medi.total_quantity >= list[index]["quantity"]) {
  //           //   list[index]["isPartialOrderItem"] = true;
  //           // } else {
  //           //   list[index]["isPartialOrderItem"] = false;
  //           // }
  //           // }
  //         }
  //       })
  //     );

  //     list[index]["subtotal"] =
  //       list[index]["unitprice"] * list[index]["quantity"];
  //     const availableQuantity = parseFloat(list[index]["availableQuantity"]);
  //     if (
  //       list[index]["isPartialOrderItem"] &&
  //       availableQuantity < 1 &&
  //       !isEligibleToShowAllocated
  //     ) {
  //       this.setState({ isWrongQuantity: true });
  //       this.setState({ wrongFieldId: index });
  //     } else {
  //       this.setState({ isWrongQuantity: false });
  //       this.setState({ wrongFieldId: "" });
  //     }

  //     if (
  //       list[index]["isPartialOrderItem"] &&
  //       (Number(list[index]["quantity"]) > availableQuantity ||
  //         0 === availableQuantity)
  //     ) {
  //       this.setState({ isOverQuantity: index });
  //     } else {
  //       this.setState({ isOverQuantity: "" });
  //     }
  //     this.setState({
  //       inputList: list,
  //       // totalcost : '',
  //       // discountamount : 0 ,
  //     });
  //     this.handlebasketandsubtotal();
  //   } else if (list[index]["item_type"] == "2") {
  //     this.state.labpackage.map((repo) => {
  //       if (list[index]["description"] == repo.id) {
  //         list[index]["unitprice"] = parseFloat(repo.price - 0).toFixed(2);
  //       }
  //     });

  //     list[index]["medicationItems"] = temp_arr;
  //     list[index]["selectmedication"] = value;
  //     const data = this.state.labpackage.map((medi) => {
  //       if (list[index]["description"] == medi.id) {
  //         list[index]["unitprice"] = parseFloat(medi.price - 0).toFixed(2);
  //         list[index]["total_quantity"] = medi.total_quantity;
  //         list[index]["availableQuantity"] = medi.quantity;
  //         list[index]["selling_price"] = medi.price;
  //         // list[index]["item_description"] = medi.description;
  //         // if (medi.total_quantity >= list[index]["quantity"]) {
  //         //   list[index]["isPartialOrderItem"] = true;
  //         // } else {
  //         //   list[index]["isPartialOrderItem"] = false;
  //         // }
  //       }
  //     });

  //     list[index]["subtotal"] =
  //       list[index]["unitprice"] * list[index]["quantity"];
  //     list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

  //     this.setState({ inputList: list, totalcost: "", discountamount: 0 });

  //     this.handlebasketandsubtotal();
  //     var new_array = this.state.medicationItems;
  //     new_array[index] = [];
  //     this.setState({ medicationItems: new_array });
  //   }

  //   // this.handletotalcost(this.state.deliverycharge);
  // };

  handleInputChange = (e, index, type) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];
    const editableStatus = [1, 9, 13];
    const isQuantityEditable = editableStatus.includes(
      Number(this.state.status),
    );

    const numericValue = parseFloat(value);
    const availableQuantity = parseFloat(list[index]["availableQuantity"]);

    if (
      type === "quantity" &&
      list[index]["isPartialOrderItem"] &&
      (value < 1 || availableQuantity < 1) &&
      !isQuantityEditable
    ) {
      this.setState({ isWrongQuantity: true });
      this.setState({ wrongFieldId: index });
    } else {
      this.setState({ isWrongQuantity: false });
      this.setState({ wrongFieldId: "" });
    }

    if (
      type === "quantity" &&
      list[index]["isPartialOrderItem"] &&
      (value > availableQuantity || 0 === availableQuantity)
    ) {
      this.setState({ isOverQuantity: index });
    } else {
      this.setState({ isOverQuantity: "" });
    }

    // if(type === "quantity") {
    //   list[index]["actualAllocated"] = Number(list[index]["total_allocated"]) + Number(value);
    // }

    // if (type === "quantity" && numericValue > availableQuantity) {
    //   list[index]["isPartialOrderItem"] = false;
    // } else {
    //   list[index]["isPartialOrderItem"] = true;
    // }

    if (name == "item_type") {
      if (list[index][name] != value) {
        list[index]["description"] = "";
        list[index]["unitprice"] = "";
        list[index]["newmargin"] = "";
        list[index]["item_type"] = value;
        list[index]["margin_discount_percentage"] = 0;
        list[index]["margin_discount_sub_type"] = 2;
        list[index]["quantity"] = 1;
        list[index]["subtotal"] = 0;
        list[index]["medicationItems"] = [];
        list[index]["selectmedication"] = "";
        list[index]["availableQuantity"] = "";
        list[index]["orderItemNumber"] = 0;
        list[index]["item_description"] = "";
        list[index]["selling_price"] = "";

        this.setState({ inputList: list });
        this.handlebasketandsubtotal();
      }
    } else {
      if (list[index]["unitprice"] == "" || list[index]["unitprice"] == null) {
        list[index][name] = value;
        if (
          type === "quantity" &&
          list[index]["isPartialOrderItem"] &&
          value > availableQuantity &&
          !isQuantityEditable
        ) {
          list[index]["quantity"] = availableQuantity;
        }
        this.setState({
          inputList: list,
        });
      } else {
        list[index][name] = value;
        if (
          type === "quantity" &&
          list[index]["isPartialOrderItem"] &&
          value > availableQuantity &&
          !isQuantityEditable
        ) {
          list[index]["quantity"] = availableQuantity;
        }
        var subtotal = list[index]["unitprice"] * list[index]["quantity"];
        var addmargin = 0;
        if (list[index]["margin_discount_sub_type"] == 2) {
          if (
            list[index]["newmargin"] != "" &&
            list[index]["newmargin"] != 0 &&
            list[index]["newmargin"] != null &&
            !isNaN(parseFloat(list[index]["newmargin"]))
          ) {
            addmargin = list[index]["newmargin"];
          } else {
            addmargin = 0;
          }
        } else {
          if (
            list[index]["margin_discount_percentage"] != "" &&
            list[index]["margin_discount_percentage"] != 0 &&
            list[index]["margin_discount_percentage"] != null &&
            !isNaN(parseFloat(list[index]["margin_discount_percentage"]))
          ) {
            addmargin =
              (subtotal * list[index]["margin_discount_percentage"]) / 100;
          }
        }

        list[index]["subtotal"] =
          (parseFloat(list[index]["unitprice"]) + parseFloat(addmargin)) *
          list[index]["quantity"];
        list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);
        list[index]["claimableValue"] = JSON.parse(list[index]["subtotal"]);
        if (
          list[index]["isChecked"] &&
          this.claimableTotal +
            list[index]["subtotal"] +
            Number(this.state.deliverycharge) >
            this.state.availableTotalClaimCredits
        ) {
          list[index]["isChecked"] = false;
        }
        this.setState({
          inputList: list,
        });
        this.handlebasketandsubtotal();
      }
    }

    if (this.state.isInsureme) {
      if (
        Number(this.handleClaimedValueOnChange()) !==
        Number(this.state.insuremeClaimableTotal)
      ) {
        this.setState({ insuremeOrderButtonDisabled: true });
      } else {
        this.setState({ insuremeOrderButtonDisabled: false });
      }
    }
  };

  handleInputDescriptionChange = (e, index, type) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];

    if (name == "item_type") {
      if (list[index][name] != value) {
        list[index]["description"] = "";
        list[index]["unitprice"] = "";
        list[index]["newmargin"] = "";
        list[index]["item_type"] = value;
        list[index]["margin_discount_percentage"] = 0;
        list[index]["margin_discount_sub_type"] = 2;
        list[index]["quantity"] = 1;
        list[index]["subtotal"] = 0;
        list[index]["medicationItems"] = [];
        list[index]["selectmedication"] = "";
        list[index]["availableQuantity"] = "";
        list[index]["orderItemNumber"] = 0;
        list[index]["item_description"] = "";
        list[index]["selling_price"] = "";

        this.setState({ inputList: list });
        this.handlebasketandsubtotal();
      }
    } else {
      if (list[index]["unitprice"] == "" || list[index]["unitprice"] == null) {
        list[index][name] = value;
        this.setState({
          inputList: list,
        });
      } else {
        list[index][name] = value;
        var subtotal = list[index]["unitprice"] * list[index]["quantity"];
        var addmargin = 0;
        if (list[index]["margin_discount_sub_type"] == 2) {
          if (
            list[index]["newmargin"] != "" &&
            list[index]["newmargin"] != 0 &&
            list[index]["newmargin"] != null &&
            !isNaN(parseFloat(list[index]["newmargin"]))
          ) {
            addmargin = list[index]["newmargin"];
          } else {
            addmargin = 0;
          }
        } else {
          if (
            list[index]["margin_discount_percentage"] != "" &&
            list[index]["margin_discount_percentage"] != 0 &&
            list[index]["margin_discount_percentage"] != null &&
            !isNaN(parseFloat(list[index]["margin_discount_percentage"]))
          ) {
            addmargin =
              (subtotal * list[index]["margin_discount_percentage"]) / 100;
          }
        }

        list[index]["subtotal"] =
          (parseFloat(list[index]["unitprice"]) + parseFloat(addmargin)) *
          list[index]["quantity"];
        list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);
        list[index]["claimableValue"] = JSON.parse(list[index]["subtotal"]);
        if (
          list[index]["isChecked"] &&
          this.claimableTotal +
            list[index]["subtotal"] +
            Number(this.state.deliverycharge) >
            this.state.availableTotalClaimCredits
        ) {
          list[index]["isChecked"] = false;
        }
        this.setState({
          inputList: list,
        });
        this.handlebasketandsubtotal();
      }
    }
  };

  // handleInputCreditNoteChange = (e, index, type) => { //important
  //   const { name, value } = e.target;
  //   const list = [...this.state.inputList];

  //   if (type === "quantity" && value < 1) {
  //     this.setState({ isWrongQuantity: true });
  //     this.setState({ wrongFieldId: index });
  //   } else {
  //     this.setState({ isWrongQuantity: false });
  //     this.setState({ wrongFieldId: "" });
  //   }

  //   if (name == "item_type") {
  //     if (list[index][name] != value) {
  //       list[index]["description"] = "";
  //       list[index]["unitprice"] = "";
  //       list[index]["newmargin"] = "";
  //       list[index]["item_type"] = value;
  //       list[index]["margin_discount_percentage"] = 0;
  //       list[index]["margin_discount_sub_type"] = 2;
  //       list[index]["quantity"] = 1;
  //       list[index]["subtotal"] = 0;
  //       list[index]["medicationItems"] = [];
  //       list[index]["selectmedication"] = "";
  //       list[index]["availableQuantity"] = "";
  //       list[index]["orderItemNumber"] = 0;

  //       this.setState({ inputList: list });
  //       this.handlebasketandsubtotal();
  //     }
  //   } else {
  //     if (list[index]["unitprice"] == "" || list[index]["unitprice"] == null) {
  //       list[index][name] = value;
  //       this.setState({
  //         inputList: list,
  //       });
  //     } else {
  //       list[index][name] = value;
  //       var subtotal = list[index]["unitprice"] * list[index]["quantity"];
  //       var addmargin = 0;
  //       if (list[index]["margin_discount_sub_type"] == 2) {
  //         if (
  //           list[index]["newmargin"] != "" &&
  //           list[index]["newmargin"] != 0 &&
  //           list[index]["newmargin"] != null &&
  //           !isNaN(parseFloat(list[index]["newmargin"]))
  //         ) {
  //           addmargin = list[index]["newmargin"];
  //         } else {
  //           addmargin = 0;
  //         }
  //       } else {
  //         if (
  //           list[index]["margin_discount_percentage"] != "" &&
  //           list[index]["margin_discount_percentage"] != 0 &&
  //           list[index]["margin_discount_percentage"] != null &&
  //           !isNaN(parseFloat(list[index]["margin_discount_percentage"]))
  //         ) {
  //           addmargin =
  //             (subtotal * list[index]["margin_discount_percentage"]) / 100;
  //         }
  //       }

  //       list[index]["subtotal"] =
  //         (parseFloat(list[index]["unitprice"]) + parseFloat(addmargin)) *
  //         list[index]["quantity"];
  //       list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);
  //       list[index]["claimableValue"] = JSON.parse(list[index]["subtotal"]);
  //       if (
  //         list[index]["isChecked"] &&
  //         this.claimableTotal +
  //         list[index]["subtotal"] +
  //         Number(this.state.deliverycharge) >
  //         this.state.availableTotalClaimCredits
  //       ) {
  //         list[index]["isChecked"] = false;
  //       }
  //       this.setState({
  //         inputList: list,
  //       });
  //       this.handlebasketandsubtotal();
  //     }
  //   }
  // };

  // handle click event of the Remove button
  handleRemoveClick = (index, oItemNumber) => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({ inputList: list });

    const list1 = list;

    let count_x = 1;
    list1.map((medi, ind) => {
      list1[ind]["srno"] = count_x;
      count_x++;
    });
    this.serial = count_x;

    const enableSubmitButton = list.some((data) => Number(data.quantity) === 0);
    if (!enableSubmitButton && !this.state.isWrongQuantity) {
      this.setState({ isWrongQuantity: false });
    } else {
      this.setState({ isWrongQuantity: true });
    }

    this.setState({ inputList: list1, isOverQuantity: "" });
    this.setState({ deleteditems: [...this.state.deleteditems, oItemNumber] });
    this.handlebasketandsubtotal();
  };
  warningAddAddress(id, city_id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.addanother()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
        >
          If you change address it will reset all medication. Are you sure want
          to reset?
        </SweetAlert>
      ),
    });
  }
  warningChangeAddress(id, city_id, billing_id, billing_country_id, type) {
    this.addrssselect(id, city_id, billing_id, billing_country_id, type);
    // alert('hi');
    /* this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.addrssselect(id,city_id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
        >
          If you change address it will reset all medication. Are you sure want to reset?
        </SweetAlert>
      )
    });  */
  }
  async addrssselect(id, city_id, billing_id, billing_country_id, type) {
    // this.setState({ inputList: [] }); //empty exitsing medictaion list
    if (type == "delivery") {
      this.setState({
        address_id: id,
        city_id: city_id,
        alert: null,
        medicationItems: [],
        medication_detail: [],
        //  addressaccess : '0',
        cityError: null,
        countryError: null,
        latiAndLogitError: null,
      });
      if (this.state.isBillingSame) {
        this.setState({
          billing_address_id: id,
          first_billing_address: id,
          billing_city_id: city_id,
        });
      }
    } else {
      this.setState({
        billing_address_id: billing_id,
        billing_city_id: billing_country_id,
        alert: null,
        medicationItems: [],
        medication_detail: [],
        //  addressaccess : '0',
        cityError: null,
        countryError: null,
        latiAndLogitError: null,
      });
    }

    if (id != "" && id != 0) {
      this.setState({ addnewaddress: false, addressaccess: "0" });
    } else {
      this.setState({ addnewaddress: true, addressaccess: "1" });
    }
    this.setState({ medicationloading: false });

    this.serial = this.state.inputList.length + 1;

    if (this.state.inputList.length == 0) {
      this.handlebasketandsubtotal();
    }
  }

  handleFileChange(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ selectedFile: data });
  }

  uploadPODoc() {
    document.getElementById("select_podoc").click();
  }

  handlePOFileChange(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ po_document: data });
  }

  uploadGRNDoc() {
    document.getElementById("select_grndoc").click();
  }

  uploadPOFinal = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (this.state.po_document.length > 0) {
      var PO_data = "";
      if (this.state.po_document.length != 0) {
        this.setState({ processing: true });
        const fdata = new FormData();
        fdata.append("document_type", "po");
        this.state.po_document.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("document_file[]", file[i]);
          }
        });

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/document";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            PO_data = res.data.data.document_url;
            this.setState({
              PNdocUrl: PO_data,
            });
          });
      }
    }
  };

  uploadGRNFinal = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (this.state.grn_document.length > 0) {
      var GRN_data = "";
      if (this.state.grn_document.length != 0) {
        this.setState({ processing: true });
        const fdata = new FormData();

        fdata.append("document_type", "grn");

        this.state.grn_document.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("document_file[]", file[i]);
          }
        });

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/orders/document";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            GRN_data = res.data.data.document_url;
            this.setState({
              GRNDocUrl: GRN_data,
            });
          });
      }
    }
  };

  grndeleteDoc = (idx) => {
    var doc = this.state.GRNDocUrl;
    doc.splice(idx, 1);
    this.setState({
      GRNDocUrl: doc,
      alert: null,
    });
  };

  grnFinaldeleteDoc = (idx) => {
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.grndeleteDoc(idx)}
          onCancel={() => this.hideAlert()}
          confirmBtnText="Yes"
          cancelBtnText="No"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          showCancel
        >
          <h4>Are you sure you want to remove this document</h4>
        </SweetAlert>
      ),
    });
  };

  podeleteDoc = (idx) => {
    var doc = this.state.PNdocUrl;
    doc.splice(idx, 1);
    this.setState({
      PNdocUrl: doc,
      alert: null,
    });
  };

  poFinaldeleteDoc = (idx) => {
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.podeleteDoc(idx)}
          onCancel={() => this.hideAlert()}
          confirmBtnText="Yes"
          cancelBtnText="No"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          showCancel
        >
          <h4>Are you sure you want to remove this document</h4>
        </SweetAlert>
      ),
    });
  };

  handleGRNFileChange(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ grn_document: data });
  }

  hideAlertquote() {
    this.setState({
      alertquote: null,
    });
  }
  sendToParent = async (name, i) => {
    if (this.state.name.length !== 0) {
      const list = [...this.state.inputList];
      var madpackageItem = [];

      if (list[i]["item_type"] == "1") {
        let compelte = 1;
        let pg_no = 1;
        const token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var city_id = this.state.city_id;
        await searchMedicationForOrder(
          this.state.name,
          city_id,
          pg_no,
          obj,
          this.state.store,
        ).then(async (res) => {
          const list = [...this.state.inputList];

          var mdata = res.data.data;

          var medicationItems = [];

          //alert("in else")
          this.setState({ medication_detail: [] });
          res.data.data.map((x, i) => {
            medicationItems.push({
              value: x.id,
              label: x.title + "(" + x.item_code + ")",
            });
          });
          // for (let x of mdata) {
          //   // Call updateMedication_old_data API for each medication
          //   const res = await updateMedication_old_data(x.id, obj);
          //   const sellingPrice = res.data.price;
          //   const itemDes = res.data.description;

          //   medicationItems.push({
          //     value: x.id,
          //     label: `${x.title}(${x.item_code}) - ${x.barcode}`,
          //     // selling_price: sellingPrice, // Add sellingPrice to each medication item
          //   });
          //   this.setState({
          //     selling_price: sellingPrice,
          //     item_description: itemDes,
          //   });
          // }
          list[i]["medicationItems"] = medicationItems;
          this.setState({ inputList: list });

          var mew_arr = this.state.medicationItems;
          mew_arr[i] = medicationItems;
          var array1md = this.state.medication_detail;
          var array2md = array1md.concat(res.data.data);
          var medi_array = [];
          medi_array[i] = array2md;

          this.setState({
            medication_detail: medi_array,
            medicationItems: mew_arr,
          });

          // Check if there is only one medication item and select it
          if (medicationItems.length === 1) {
            // this.handleSelectChange(i, medicationItems[0]); // Automatically select the only result
          }
        });
      } else if (list[i]["item_type"] == "2") {
        this.state.packageItems.map((x, i) => {
          madpackageItem.push({
            value: x.value,
            label: x.label,
          });
        });
        list[i]["medicationItems"] = madpackageItem;
      }
      this.setState({ inputList: list });
    } else {
      const list = [...this.state.inputList];
      list[i]["medicationItems"] = [];
      this.setState({ inputList: list });
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };
  sendToParentBarcode = async (name, i) => {
    if (this.state.name.length !== 0) {
      const list = [...this.state.inputList];
      var madpackageItem = [];

      if (list[i]["item_type"] == "1") {
        let compelte = 1;
        let pg_no = 1;
        const token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var city_id = this.state.city_id;
        await searchMedicationForOrder(
          this.state.name,
          city_id,
          pg_no,
          obj,
          this.state.store,
        ).then(async (res) => {
          const list = [...this.state.inputList];

          var mdata = res.data.data;

          var medicationItems = [];

          //alert("in else")
          this.setState({ medication_detail: [] });
          res.data.data.map((x, i) => {
            medicationItems.push({
              value: x.id,
              label: x.title + "(" + x.item_code + ")",
            });
          });
          // for (let x of mdata) {
          //   // Call updateMedication_old_data API for each medication
          //   const res = await updateMedication_old_data(x.id, obj);
          //   const sellingPrice = res.data.price;
          //   const itemDes = res.data.description;

          //   medicationItems.push({
          //     value: x.id,
          //     label: `${x.title}(${x.item_code}) - ${x.barcode}`,
          //     // selling_price: sellingPrice, // Add sellingPrice to each medication item
          //   });
          //   this.setState({
          //     selling_price: sellingPrice,
          //     item_description: itemDes,
          //   });
          // }
          list[i]["medicationItems"] = medicationItems;
          this.setState({ inputList: list });

          var mew_arr = this.state.medicationItems;
          mew_arr[i] = medicationItems;
          var array1md = this.state.medication_detail;
          var array2md = array1md.concat(res.data.data);
          var medi_array = [];
          medi_array[i] = array2md;

          this.setState({
            medication_detail: medi_array,
            medicationItems: mew_arr,
          });

          if (medicationItems.length === 1) {
            // Automatically select the only result
            //
            // this.handleSelectChange(i, medicationItems[0]);
          } else if (medicationItems.length > 1) {
            // Focus on the Select component when there are more than one items
            if (this.inputRef.current && this.inputRef.current[i]) {
              this.inputRef.current[i].focus();
              this.inputRef.current[i].onMenuOpen();
            }
          }
        });
      } else if (list[i]["item_type"] == "2") {
        this.state.packageItems.map((x, i) => {
          madpackageItem.push({
            value: x.value,
            label: x.label,
          });
        });
        list[i]["medicationItems"] = madpackageItem;
      }
      this.setState({ inputList: list });
      if (list[i]["barcode"]) {
        const removeFirstDigit = list[i]["barcode"].slice(1);
        if (name === removeFirstDigit) {
          this.handleAddMultipleClick();
        }
      }
    } else {
      const list = [...this.state.inputList];
      list[i]["medicationItems"] = [];
      this.setState({ inputList: list });
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };
  sendToParentBarcodeNot = async (name, i) => {
    if (this.state.name.length !== 0) {
      const list = [...this.state.inputList];
      var madpackageItem = [];

      if (list[i]["item_type"] == "1") {
        let compelte = 1;
        let pg_no = 1;
        const token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var city_id = this.state.city_id;
        await searchMedicationUsingBarcodeForOrder(
          this.state.name,
          city_id,
          pg_no,
          obj,
        ).then(async (res) => {
          const list = [...this.state.inputList];

          var mdata = res.data.data;

          var medicationItems = [];

          //alert("in else")
          this.setState({ medication_detail: [] });

          res.data.data.map(async (x, i) => {
            medicationItems.push({
              value: x.id,
              label: x.title + "(" + x.item_code + ")",
              // +
              // (x.barcode != null ? " - " + x.barcode : "")
            });
          });
          // for (let x of mdata) {
          //   // Call updateMedication_old_data API for each medication
          //   const res = await updateMedication_old_data(x.id, obj);
          //   const sellingPrice = res.data.price;
          //   const itemDes = res.data.description;

          //   medicationItems.push({
          //     value: x.id,
          //     label: `${x.title}(${x.item_code}) - ${x.barcode}`,
          //     // selling_price: sellingPrice, // Add sellingPrice to each medication item
          //   });
          //   this.setState({
          //     selling_price: sellingPrice,
          //     item_description: itemDes,
          //   });
          // }
          list[i]["medicationItems"] = medicationItems;
          this.setState({ inputList: list });

          var mew_arr = this.state.medicationItems;
          mew_arr[i] = medicationItems;
          var array1md = this.state.medication_detail;
          var array2md = array1md.concat(res.data.data);
          var medi_array = [];
          medi_array[i] = array2md;

          this.setState({
            medication_detail: medi_array,
            medicationItems: mew_arr,
          });
          if (medicationItems.length === 1) {
            // Automatically select the only result
            // this.handleSelectChange(i, medicationItems[0]);
          } else if (medicationItems.length > 1) {
            // Focus on the Select component when there are more than one items
            if (this.inputRef.current && this.inputRef.current[i]) {
              this.inputRef.current[i].focus();
              this.inputRef.current[i].onMenuOpen();
            }
          }
        });
      } else if (list[i]["item_type"] == "2") {
        this.state.packageItems.map((x, i) => {
          madpackageItem.push({
            value: x.value,
            label: x.label,
          });
        });
        list[i]["medicationItems"] = madpackageItem;
      }
      this.setState({ inputList: list });
      if (name === list[i]["barcode"]) {
        this.handleAddMultipleClick();
      }
    } else {
      const list = [...this.state.inputList];
      list[i]["medicationItems"] = [];
      this.setState({ inputList: list });
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };
  displayNoteb() {
    var note = !this.state.notedisplay;
    this.setState({ notedisplay: note });
    if (Number(this.state.status) === 1) {
      this.sendProcess("processing", { stayOnPage: true });
    }
  }
  displayorderNote() {
    var ordernote = !this.state.ordernotedisplay;
    this.setState({ ordernotedisplay: ordernote });
    if (Number(this.state.status) === 1) {
      this.sendProcess("processing", { stayOnPage: true });
    }
  }
  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name, i);
      }, 500),
    });
  };
  downshiftOnChange = (selectedItem, i) => {
    var index = i;

    var d = selectedItem.id;

    this.setState({ selectedmedication: d });

    let name = "description";
    const list = [...this.state.inputList];
    list[index][name] = selectedItem.id;
    list[index]["medi_title"] = selectedItem.title;
    list[index]["medi_itemcode"] = selectedItem.item_code;
    list[index]["unitprice"] = parseFloat(selectedItem.price - 0).toFixed(2);

    list[index]["subtotal"] =
      list[index]["unitprice"] * list[index]["quantity"];
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

    this.setState({ inputList: list, totalcost: "", discountamount: 0 });
    this.handlebasketandsubtotal();
    //alert(`your  Selected Medication  ${selectedItem.id}`)
  };
  prescriptionDisplay(opt) {
    document.getElementById(opt).click();
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  handleFileChanges = async (event) => {
    let data = [];

    data.push(event.target.files);

    this.setState({ package_image: data });
    this.setState({ selectedFile: data });

    var packageimages = "";
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (data.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();

      data.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("image_file[]", file[i]);
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/image";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          packageimages = res.data.data.image_url;
          this.setState({ package_image_data: packageimages });
          // priscription_array_data.push(priscription_data);
        });
    }
  };
  upload() {
    document.getElementById("selectImage").click();
  }
  handleChange(tags) {
    this.setState({ tags });
  }

  changeordertypehandle = () => {
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.confirmChangeOT()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="info"
          confirmBtnText="Yes"
          cancelBtnText="No"
          showCancel
        >
          <h4>Are you sure you want to change order type?</h4>
        </SweetAlert>
      ),
    });
  };

  confirmChangeOT = () => {
    this.setState({
      sub_orderType: !this.state.sub_orderType,
      alert: null,
    });
    if (this.state.subscriber != 0) {
      setTimeout(this.handlebasketandsubtotal, 500);
    }
  };

  handleAllChecked = (e) => {
    if (e.target.checked) {
      this.setState({ isAllChecked: true });
      this.state.inputList.forEach((data) => {
        data.isChecked = true;
        data.claimableValue = JSON.parse(data.subtotal);
      });
    } else {
      this.setState({ isAllChecked: false });
      this.state.inputList.forEach((data) => {
        data.isChecked = false;
        data.claimableValue = 0;
      });
    }
  };

  handleCheckboxChange = (checked, id) => {
    let arr = [...this.state.medicineCheckedValue];
    let itemSubTotal = 0;
    if (this.state.isClaimableOrder) {
      if (checked) {
        this.state.inputList.forEach((data) => {
          if (data.id == id) {
            if (
              Number(this.state.availableTotalClaimCredits) >=
              Number(this.claimableTotal) +
                Number(data.subtotal) +
                Number(this.state.deliverycharge)
            ) {
              data.isChecked = true;
              data.claimableValue = JSON.parse(data.subtotal);
              itemSubTotal = JSON.parse(data.subtotal);
            } else {
              this.setState({
                alert: (
                  <SweetAlert
                    className="order_alert"
                    style={{ display: "block", marginTop: "-100px" }}
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                  >
                    <h4>Sorry! You can't make as claimable medicine </h4>
                  </SweetAlert>
                ),
              });
            }
          }
        });
        this.claimableTotal = this.claimableTotal + itemSubTotal;
        this.setState({ medicineCheckedValue: arr });
      } else {
        this.setState({ isAllChecked: false });
        this.state.inputList.forEach((data) => {
          if (data.id == id) {
            data.isChecked = false;
            data.claimableValue = 0;
          }
        });
        const unCheckedValue = this.state.medicineCheckedValue.filter(
          (data) => data !== id,
        );
        this.setState({ medicineCheckedValue: unCheckedValue });
      }
    } else {
      const xxx = this.state.inputList.map((data) => {
        if (data.id == id) {
          itemSubTotal = JSON.parse(data.subtotal);
          return {
            ...data,
            isChecked: checked,
            claimableValue: checked ? JSON.parse(data.subtotal) : 0,
          };
        }
        return data;
      });
      this.claimableTotal = this.claimableTotal + itemSubTotal;
      this.setState({ inputList: xxx });
      if (this.state.isInsureme) {
        if (this.claimableTotal !== Number(this.state.insuremeClaimableTotal)) {
          this.setState({ insuremeOrderButtonDisabled: true });
        } else {
          this.setState({ insuremeOrderButtonDisabled: false });
        }
      }
    }
  };

  handleClaimedValueOnChange() {
    let claimabaleTotalValue = 0;
    // if (this.state.isInsureme) {

    // }
    this.state.inputList.map((item) => {
      if (item.isChecked) {
        claimabaleTotalValue = claimabaleTotalValue + item.claimableValue;
      }
    });
    this.claimableTotal = claimabaleTotalValue;
    return claimabaleTotalValue.toFixed(2);
  }

  showPolicyDetails() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getPolicyDetailsByPackgeId(
      obj,
      this.state.cataloguePackageId,
      this.state.policyType,
    ).then((res) => {
      if (res.data.length > 0) {
        const claimPolicyDetails = res.data.find((data) => data);
        this.setState({ ClaimPolicyDetails: claimPolicyDetails.policy });
      }
    });
  }

  isCheckedTracking = (selectedIndex) => {
    const updatedState = this.state.inputList.map((item, index) => {
      if (index === selectedIndex) {
        return {
          ...item,
          isRowSelected: !item.isRowSelected,
        };
      }
      return item;
    });
    this.setState({ inputList: updatedState });
  };

  handleUpsellerCheckboxChange(e) {
    const checkMedicineUpseller = this.state.inputList.map((data) => {
      if (data.id === Number(e.target.value)) {
        return {
          ...data,
          isUpSeller: e.target.checked,
        };
      }
      return data;
    });
    this.setState({ inputList: checkMedicineUpseller });
  }
  handlePartialOrderCheckboxChange(e) {
    const checkMedicinePartialOrder = this.state.inputList.map((data) => {
      if (data.id === Number(e.target.value)) {
        return {
          ...data,
          isPartialOrderItem: e.target.checked,
        };
      }
      return data;
    });
    const findPartialItemsIncluded = checkMedicinePartialOrder.filter(
      (item) => !item.isPartialOrderItem,
    );
    this.setState(
      {
        inputList: checkMedicinePartialOrder,
        isPartialOrder: findPartialItemsIncluded.length > 0 ? true : false,
      },
      () => {
        this.getUnavailableCost();
      },
    );
    if (!e.target.checked) {
      this.setState({ isWrongQuantity: false });
    }
    // this.getPartialSentData(checkMedicinePartialOrder);
  }
  handleItemOrderedCheckboxChange = (e) => {
    const medicineId = Number(e.target.value);
    const checkMedicineOrderedItem = this.state.inputList.map((item) => {
      if (item.id === medicineId) {
        return {
          ...item,
          is_order_placed: e.target.checked,
        };
      }
      return item;
    });
    this.setState({ inputList: checkMedicineOrderedItem });
  };

  handlePartialOrderOnChange = (e) => {
    this.setState({ isPartialOrder: e.target.checked });
    // this
    // const getThePartialValue = checkMedicinePartialOrder.filter(
    //   (item) => item.isPartialOrder
    // );
    // if (getThePartialValue.length > 0) {
    //   this.setState({ isPartialOrder: true });
    // } else {
    //   this.setState({ isPartialOrder: false });
    // }
  };
  handleAbusableOrderOnChange = (e) => {
    this.setState({ isAbusableOrder: e.target.checked });
  };
  handleis_printableOnChange(e) {
    const checkMedicinePrintable = this.state.inputList.map((data) => {
      if (data.id === Number(e.target.value)) {
        return {
          ...data,
          is_printable: e.target.checked,
        };
      }
      return data;
    });
    this.setState({ inputList: checkMedicinePrintable });
  }

  openItemPendingModal() {
    const findMedicineEntered = this.state.inputList.filter(
      (data) => data.description !== "",
    );
    const current = new Date();
    const end = new Date();
    const strtdate = `${current.getFullYear()}-${
      current.getMonth() + 1
    }-${current.getDate()}`;
    const enddate = `${end.getFullYear()}-${end.getMonth() + 1}-${
      end.getDate() + 7
    }`;

    if (findMedicineEntered.length === 0) {
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Medication data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      this.setState({
        isOpenItemPendingModal: true,
        delivery_from_dates: strtdate,
        delivery_to_dates: enddate,
      });
    }
  }

  sendProcess = async (type, options = {}) => {
    const { stayOnPage = false } = options;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let sts_arr = [];
    const filterOutOfStockMedicine = this.state.inputList.filter((data) => {
      if (
        !data.description ||
        data.description === null ||
        data.description === undefined
      ) {
        return false;
      }

      return (
        Number(data.availableQuantity) < Number(data.quantity) &&
        data.isPartialOrderItem
      );
    });
    if (type === "contacted") {
      sts_arr.push({ id: this.props.match.params.id, status: 10 });
    } else if (type === "itemPending") {
      sts_arr.push({
        id: this.props.match.params.id,
        delivery_from_date: this.state.delivery_from_dates,
        delivery_to_date: this.state.delivery_to_dates,
        status: 14,
      });
    } else if (type === "processing") {
      //validation
      let error = false;

      const validationError = this.state.insuremeValidationErrors;
      const findOrderType =
        this.state.isClaimableOrder || this.state.isInsureme;

      if (findOrderType) {
        Object.entries(this.state.insuremeValidation).map(([key, value]) => {
          if (key === "familyClaim") return;
          if (!this.state.insuremeValidation[key]) {
            error = true;

            validationError[`${key}Error`] = (
              <small className="text-danger">Field is required.</small>
            );
          }
        });
        this.setState({ insuremeValidationErrors: validationError });

        //  if (!error && this.state.isClaimableOrder) {
        // this.setState({ isClaimConfirmationModalOpen: true });
        // return;
      }
      sts_arr.push({ id: this.props.match.params.id, status: 2 });
    } else if (type === "ready") {
      sts_arr.push({ id: this.props.match.params.id, status: 12 });
    }
    if (filterOutOfStockMedicine.length > 0) {
      this.setState({
        openOutOfStockModal: true,
        outOfStockMedicineDetails: filterOutOfStockMedicine,
      });
    } else {
      await updateOrderStatus(sts_arr, "", "", obj)
        .then(() => {
          if (stayOnPage) {
            if (type === "processing") {
              this.setState({ status: 2 });
            }
          } else {
            this.onSubmit();
          }
        })
        .catch(() => {
          this.setState({
            isLoading: false,
          });
        });
    }
  };
  onToggleItemPending = () => {
    this.setState({
      isItemPedingDateRangePickerOpen:
        !this.state.isItemPedingDateRangePickerOpen,
      isItemPendingDatePickerOn: !this.state.isItemPendingDatePickerOn,
    });
  };
  onSelectnew = (itemPendingDaterange, states) => {
    this.setState({
      itemPendingDaterange,
      states,
      isItemPendingDatePickerOn: !this.state.isItemPendingDatePickerOn,
      delivery_from_dates: itemPendingDaterange.start.format("YYYY-MM-DD"),
      delivery_to_dates: itemPendingDaterange.end.format("YYYY-MM-DD"),
    });
  };
  submitItemPendingModal = () => {
    this.setState({ isOpenItemPendingModal: false });
    this.sendProcess("itemPending");
  };
  openPackedModal = async () => {
    const findMedicineEntered = this.state.inputList.filter(
      (data) => data.description !== "",
    );
    const findUnCheckedClaimableCheckbox = this.state.inputList.filter(
      (item) => !item.isChecked,
    );

    if (findMedicineEntered.length === 0) {
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Medication data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      if (
        !!this.state.isInsureme &&
        findUnCheckedClaimableCheckbox.length > 0
      ) {
        this.setState({
          alert: (
            <SweetAlert
              className="order_alert"
              title="Sorry! You can't submit this InsureMe order"
              style={{ display: "block", marginTop: "-100px" }}
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              <h4>Please mark all medicines claimable </h4>
            </SweetAlert>
          ),
        });
      } else {
        const hasOutOfStockItem = this.state.inputList.filter((item) => {
          if (
            !item.description ||
            item.description === null ||
            item.description === undefined
          ) {
            return false;
          }

          return (
            Number(item.quantity) > Number(item.availableQuantity) &&
            !!item.isPartialOrderItem
          );
        });

        if (hasOutOfStockItem.length > 0) {
          //gompasiya
          this.setState({
            openOutOfStockModal: true,
            outOfStockMedicineDetails: hasOutOfStockItem,
          });
        } else {
          this.setState({
            openOutOfStockModal: false,
          });
          var token = JSON.parse(localStorage.getItem("user"));
          const obj = token.token;
          if (!!this.state.isInsureme) {
            this.setState({ isLoading: true });
            await submitInsuremeClaimRequest(
              this.props.match.params.id,
              this.handleClaimedValueOnChange(),
              this.state.subscriber,
              obj,
            ).then((res) => {
              if (res.data.status === 200) {
                this.setState({
                  insuremeBannerText: (
                    <div
                      style={{
                        backgroundColor: "#E0FBE2 ",
                        // position: "absolute",
                        width: "100%",
                        flex: 1,
                        left: "300px",
                        padding: "10px",
                        zIndex: 1000,
                        borderRadius: "5px",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flex: 1,
                          gap: "20px",
                        }}
                      >
                        <i
                          class="fa fa-check-circle-o"
                          style={{ fontSize: "36px", color: "green" }}
                        ></i>
                        <p style={{ color: "green", marginTop: "7px" }}>
                          Insureme Claim Verification Success.
                        </p>
                      </span>
                    </div>
                  ),
                });
                // this.setState({ viewMedDetails: false });
                this.setState({ isOpenRiderModal: true });
              } else {
                this.setState({
                  alert: (
                    <SweetAlert
                      lassName="order_alert"
                      style={{
                        display: "block",
                        marginTop: "-100px",
                      }}
                      error
                      title={res.data.error.message}
                      onConfirm={() => this.hideAlert()}
                      onCancel={() => this.hideAlert()}
                    >
                      <h4>&nbsp;</h4>
                    </SweetAlert>
                  ),
                  insuremeBannerText: (
                    <div
                      style={{
                        backgroundColor: "#FFBBBF ",
                        // position: "absolute",
                        width: "100%",
                        flex: 1,
                        left: "300px",
                        padding: "10px",
                        zIndex: 1000,
                        borderRadius: "5px",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flex: 1,
                          gap: "20px",
                        }}
                      >
                        <i
                          class="	fa fa-close"
                          style={{ fontSize: "36px", color: "red" }}
                        ></i>
                        <p style={{ color: "red", marginTop: "7px" }}>
                          {res.data.error.message}
                        </p>
                      </span>
                    </div>
                  ),
                });
              }
            });
            this.setState({ isLoading: false }, () => {});
          } else {
            /** get order details */
            this.setState({
              insuremeBannerText: null,
            });
            this.setState({ isOpenRiderModal: true });
          }
          // this.setState({ isOpenRiderModal: true });
          getallCurrier(10, obj).then((res) => {
            const data = res.data;
            const currierOptions = data.map((item) => {
              return {
                value: item.id,
                label: item.name,
              };
            });
            this.setState({
              currierData: currierOptions,
            });
          });
        }
      }
    }
  };

  handleIsCurrierCheckbox(e) {
    let checked = e.target.checked;
    this.setState({
      isCurrier: checked,
      selectedRider: null,
      selectedCurrier: null,
    });
  }
  onChangeCourrierTrackingDetails = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  submitUpdatePackedStatusModal() {
    let error = false;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var rider_cour = null;
    var is_courier_partner = 0;
    let order_id = [];
    let status = "11";
    order_id.push(this.props.match.params.id);
    this.setState({ btn_disabled: true });
    this.setState({ submitButtonText: "Processing" });
    this.hideAlert();

    if (!this.state.isCurrier) {
      is_courier_partner = 0;
      if (!this.state.selectedRider || !this.state.selectedRider.value) {
        error = true;

        this.setState({
          selectedRiderError: (
            <small className="text-danger">Rider is required.</small>
          ),
        });
      } else {
        rider_cour = this.state.selectedRider.value;

        this.setState({ selectedRiderError: null });
      }
    } else {
      is_courier_partner = 1;
      if (!this.state.selectedCurrier || !this.state.selectedCurrier.value) {
        error = true;
        this.setState({
          selectedCurrierError: (
            <small className="text-danger">Currier is required.</small>
          ),
        });
      } else {
        this.setState({ selectedCurrierError: null });
      }
    }
    if (!error) {
      if (!this.state.isCurrier) {
        rider_cour = this.state.selectedRider.value;
      } else {
        rider_cour = this.state.selectedCurrier.value;
      }

      updateOrdersRider(
        order_id,
        rider_cour,
        status,
        is_courier_partner,
        this.state.tracking_id,
        this.state.tracking_url,
        this.state.tracking_note,
        obj,
      ).then((res) => {
        this.setState({ isOpenRiderModal: false });
        if (res.data.success == true) {
          this.confirmUpdate("onSubmitUpdate");
        } else {
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>{res.data.data.error.message}</h4>
              </SweetAlert>
            ),
          });
        }
        // this.onSubmit();
      });
    }
  }

  viewContactedButton() {
    return (
      <Button
        style={{
          marginLeft: "3px",
          backgroundColor: "#793FDF",
          border: "none",
        }}
        onClick={() => {
          this.sendProcess("contacted");
          this.setState({ status: 10 });
        }}
        className="btn btn-fill"
        fill
      >
        contacted
      </Button>
    );
  }
  viewReadyButton() {
    return (
      <Button
        className="btn btn-fill fl_text_purple"
        style={{ marginLeft: "3px", border: "none" }}
        onClick={() => {
          this.sendProcess("ready");
          this.setState({ status: 12 });
        }}
        fill
      >
        Ready
      </Button>
    );
  }
  viewProcceingButton() {
    return (
      <Button
        style={{ marginLeft: "3px", background: "#A91079", border: "none" }}
        onClick={() => {
          this.sendProcess("processing");
          // this.setState({ status: 2 });
        }}
        className="btn btn-fill "
        fill
      >
        Processing
      </Button>
    );
  }
  viewItemPendingButton() {
    return (
      <Button
        style={{ marginLeft: "3px" }}
        onClick={() => {
          this.openItemPendingModal();
          this.setState({ status: 14 });
        }}
        className="btn btn-fill fl_text_blue"
        fill
      >
        Item Pending
      </Button>
    );
  }
  viewPackedButton() {
    return (
      <Button
        style={{
          marginLeft: "3px",
          backgroundColor: "#5C3D2E",
          border: "none",
        }}
        onClick={() => {
          this.openPackedModal();
          // this.setState({ status: 11 });
        }}
        className="btn btn-fill"
        fill
      >
        Packed
      </Button>
    );
  }
  handleMarkedAsClaimOrderOnChange = (e) => {
    if (!e.target.checked) {
      const removeClaimableFlag = this.state.inputList.map((item) => {
        return {
          ...item,
          isChecked: false,
        };
      });
      this.setState({ inputList: removeClaimableFlag });
    }
    this.setState({ isClaimableOrder: e.target.checked });
  };

  insuremeRequestClaim = () => {
    if (this.state.inputList.length == 0) {
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Medication data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      const findThisInsuremeOrderPartialClaimed = this.state.inputList.filter(
        (item) => !item.isChecked,
      );
      if (
        this.state.isInsureme &&
        findThisInsuremeOrderPartialClaimed.length > 0
      ) {
        this.setState({
          alert: (
            <SweetAlert
              className="order_alert"
              title="Sorry! You can't submit this InsureMe order"
              style={{ display: "block", marginTop: "-100px" }}
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              <h4>Please mark all medicines claimable </h4>
            </SweetAlert>
          ),
        });
      } else {
        this.setState({
          alert: (
            <SweetAlert
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              // title="You want to verify InsureMe claim value for this order"
              onConfirm={() => this.submitClaimRequest()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              cancelBtnBsStyle="danger"
              cancelBtnText="Cancel"
              showCancel
            >
              <h4>You want to verify InsureMe claim value for this order</h4>
              {/* <br /> */}
            </SweetAlert>
          ),
        });
      }
    }
  };

  submitClaimRequest = async () => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const orderId = this.props.match.params.id;
    await submitInsuremeClaimRequest(
      orderId,
      this.handleClaimedValueOnChange(),
      this.state.subscriber,
      obj,
    ).then((res) => {
      if (res.data.status === 200) {
        this.hideAlert();
        this.setState({
          alert: (
            <SweetAlert
              lassName="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              success
              title="Request Accepted"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
            >
              <h4>{res.data.message}</h4>
            </SweetAlert>
          ),
          insuremeBannerText: (
            <div
              style={{
                backgroundColor: "#E0FBE2 ",
                // position: "absolute",
                width: "100%",
                flex: 1,
                left: "300px",
                padding: "10px",
                zIndex: 1000,
                borderRadius: "5px",
              }}
            >
              <span
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                  gap: "20px",
                }}
              >
                <i
                  class="fa fa-check-circle-o"
                  style={{ fontSize: "36px", color: "green" }}
                ></i>
                <p style={{ color: "green", marginTop: "7px" }}>
                  InsureMe Claim Verification Success.
                </p>
              </span>
            </div>
          ),
          insuremeClaimableTotal: this.handleClaimedValueOnChange(),
        });
        if (this.claimableTotal !== Number(this.state.insuremeClaimableTotal)) {
          this.setState({ insuremeOrderButtonDisabled: true });
        } else {
          this.setState({ insuremeOrderButtonDisabled: false });
        }
      } else {
        this.hideAlert();
        this.setState({
          alert: (
            <SweetAlert
              lassName="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              error
              title={res.data.error.message}
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
            >
              <h4>&nbsp;</h4>
            </SweetAlert>
          ),
          insuremeBannerText: (
            <div
              style={{
                backgroundColor: "#FFBBBF ",
                // position: "absolute",
                width: "100%",
                flex: 1,
                left: "300px",
                padding: "10px",
                zIndex: 1000,
                borderRadius: "5px",
              }}
            >
              <span
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                  gap: "20px",
                }}
              >
                <i
                  class="	fa fa-close"
                  style={{ fontSize: "36px", color: "red" }}
                ></i>
                <p style={{ color: "red", marginTop: "7px" }}>
                  {res.data.error.message}
                </p>
              </span>
            </div>
          ),
        });
      }
    });
    // } else {
    //   this.setState({
    //     alert: (
    //       <SweetAlert
    //         lassName="order_alert"
    //         style={{ display: "block", marginTop: "-100px" }}
    //         onConfirm={() => this.hideAlert()}
    //         onCancel={() => this.hideAlert()}
    //       >
    //         <h4>Please upload the Prescription</h4>
    //       </SweetAlert>
    //     ),
    //   });
    // }
  };
  // sendCreditNotevalue = () => {//important
  //   const token = JSON.parse(localStorage.getItem("user"));
  //   const obj = token.token;
  //   const createCreditNoteBody = {
  //     order_id: Number(this.props.match.params.id),
  //     reference: this.state.referenceNote,
  //     total_amount: this.state.basketvalue,
  //     data: this.state.inputList.map((x) => ({
  //       order_item_id: x.orderItemNumber,
  //       item_code: x.medi_itemcode,
  //       item_description: x.medi_title,
  //       quantity: x.quantity,
  //       unit_price: x.unitprice,
  //       amount: x.subtotal,
  //     })),
  //   };
  //   this.setState({
  //     alert: (
  //       <SweetAlert
  //         title="Confirm Credit Note"
  //         warning
  //         style={{ display: "block", marginTop: "-100px" }}
  //         onConfirm={() =>
  //           this.confirmSendCreditNoteValue(obj, createCreditNoteBody)
  //         }
  //         onCancel={this.hideAlert}
  //         confirmBtnBsStyle="info"
  //         cancelBtnBsStyle="danger"
  //         confirmBtnText="OK"
  //         cancelBtnText="Cancel"
  //         showCancel
  //       >
  //         Are you sure you want to credit this order?
  //       </SweetAlert>
  //     ),
  //   });
  // };
  // confirmSendCreditNoteValue = (obj, createCreditNoteBody) => {
  //   this.setState({ isLoading: true, alert: null });
  //   CreateCreditNote(obj, createCreditNoteBody)
  //     .then((res) => {
  //       this.setState({ isLoading: false });
  //       this.setState({ isCreditNoteModalOpen: false });
  //       window.location.reload();
  //     })
  //     .catch((error) => {
  //       this.setState({ isLoading: false });
  //       console.error("Error sending credit note", error);
  //     });
  // };
  // hideAlert = () => {
  //   this.setState({ alert: null });
  // };

  // creditNoteOnChange = (event) => {//important
  //   const target = event.target;
  //   const value = target.type === "select" ? target.selected : target.value;
  //   const name = target.name;
  //   this.setState({
  //     [name]: value,
  //   });
  // };
  // selectCreditNoteStatus(value) {
  //   this.setState({ creditNoteStatus: value });
  // }
  handleInputLocationChange = (e) => {
    const input = e.target.value;
    this.setState({ input });
    const [latitude, longitude] = input.split(",").map((coord) => coord.trim());
    if (input.includes(",")) {
      this.setState({
        latitude: latitude || "",
        longitude: longitude || "",
      });
    } else {
      this.setState({
        latitude: latitude,
        longitude: "",
      });
    }
    this.setState({ latiAndLogitError: null });
  };

  handleInsuremeValidationOnChange = (e) => {
    let name = e.target.name;
    const changeInsuremeValidations = this.state.insuremeValidation;
    changeInsuremeValidations[name] = e.target.checked;
    if (changeInsuremeValidations.claimHolderName) {
      this.state.insuremeValidationErrors["claimHolderNameError"] = null;
    }
    if (changeInsuremeValidations.dateAvailable) {
      this.state.insuremeValidationErrors["dateAvailableError"] = null;
    }
    if (changeInsuremeValidations.doctorSeal) {
      this.state.insuremeValidationErrors["doctorSealError"] = null;
    }
    if (changeInsuremeValidations.medicationCover) {
      this.state.insuremeValidationErrors["medicationCoverError"] = null;
    }
    if (changeInsuremeValidations.nameAvailable) {
      this.state.insuremeValidationErrors["nameAvailableError"] = null;
    }
    if (changeInsuremeValidations.signatureAvailable) {
      this.state.insuremeValidationErrors["signatureAvailableError"] = null;
    }
    if (changeInsuremeValidations.validityPeriod) {
      this.state.insuremeValidationErrors["validityPeriodError"] = null;
    }
    if (changeInsuremeValidations.checkPrice) {
      this.state.insuremeValidationErrors["checkPriceError"] = null;
    }
    if (changeInsuremeValidations.checkQuantity) {
      this.state.insuremeValidationErrors["checkQuantityError"] = null;
    }
    this.setState({ changeInsuremeValidations: changeInsuremeValidations });
  };

  handlePaymentOptionChange = (value) => {
    this.setState({
      paymentoption: value,
    });

    if (
      value.value !== "InsureMe" &&
      this.state.previousPaymentOption.value === "InsureMe"
    ) {
      this.setState({ isInsureme: false, insuremeOrderButtonDisabled: false });
      const unCheckMedicines = this.state.inputList.map((data) => {
        return {
          ...data,
          isChecked: false,
        };
      });
      this.setState({ inputList: unCheckMedicines });
    }
  };
  OpenPrintOption = async () => {
    try {
      this.confirmUpdate("onSubmitUpdate");
      await new Promise((resolve) => setTimeout(resolve, 3000));
      window.open(
        `${process.env.REACT_APP_BILL_GENERATE_URL}/bill-generate/${this.props.match.params.id}`,
        "_blank",
      );
    } catch (e) {
      console.error(e);
      alert("Something went wrong");
    }
  };

  getUnavailableCost = () => {
    const unavailableCost = this.state.inputList
      .filter((item) => !item.isPartialOrderItem)
      .reduce((sum, item) => sum + Number(item.subtotal || 0), 0);

    this.setState({ getUnavalibleCost: unavailableCost });
  };
  setInputRef = (el, index) => {
    if (!this.inputRef.current) {
      this.inputRef.current = {};
    }
    this.inputRef.current[index] = el;
  };

  handleAddressChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onSubmitAddressModal = () => {
    const validationState = {
      addressline1Error: null,
      cityError: null,
      countryError: null,
      addressTypeError: null,
      latiAndLogitError: null,
    };

    if (!this.state.addressline1 || this.state.addressline1.trim() === "") {
      validationState.addressline1Error = (
        <small className="text-danger">Address is required.</small>
      );
    }

    if (!this.state.city || this.state.city === "0") {
      validationState.cityError = (
        <small className="text-danger">District is required.</small>
      );
    }

    if (!this.state.country || this.state.country == "0") {
      validationState.countryError = (
        <small className="text-danger">Country is required.</small>
      );
    }

    if (!this.state.addressType || this.state.addressType === "0") {
      validationState.addressTypeError = (
        <small className="text-danger">Address Type is required.</small>
      );
    }

    if (!this.state.latitude || !this.state.longitude) {
      validationState.latiAndLogitError = (
        <small className="text-danger">
          Latitude and Longitude are required.
        </small>
      );
    }

    const hasErrors = Object.values(validationState).some(Boolean);
    if (hasErrors) {
      this.setState({ validationState: validationState });
      return;
    }

    this.setState({ validationState: validationState });
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const addressPayload = {
      address_line1: this.state.addressline1,
      address_line2: this.state.addressline2,
      city: this.state.city,
      postal_code: this.state.postalcode,
      country_id: this.state.country,
      latitude: this.state.latitude,
      longitude: this.state.longitude,
      address_type: this.state.addressType,
      customAddress: this.state.customAddress,
    };
    createAddress(obj, addressPayload, this.state.subscriber)
      .then((res) => {
        if (res.data.success) {
          this.handleAddressSuccess("bl");

          this.setState({
            addressdata: res.data.data.address,
            isCreateAddressModalOpen: false,
            addressline1: "",
            addressline2: "",
            city: "0",
            postalcode: "",
            country: "1",
            latitude: "",
            longitude: "",
            customAddress: "",
            input: "",
            addressType: "",
            address_id:
              this.state.addressModalType === "delivery"
                ? res.data.data.address_id
                : this.state.address_id,
            first_address:
              this.state.addressModalType === "delivery"
                ? res.data.data.address_id
                : this.state.address_id,
            billing_address_id:
              this.state.addressModalType === "billing"
                ? res.data.data.address_id
                : this.state.billing_address_id,
          });
        }
        console.log("res", res);
      })
      .catch((error) => {
        console.error("Error creating address", error);
      });
  };

  handleBillingSameToggle = () => {
    const nextChecked = !this.state.isBillingSame;
    if (nextChecked) {
      this.setState({
        isBillingSame: true,
        billing_address_id: this.state.address_id,
        first_billing_address: this.state.address_id,
        billing_city_id: this.state.city_id,
      });
    } else {
      this.setState({
        isBillingSame: false,
      });
    }
  };

  handleUploadDocument() {
    this.setState({ isUploadDocumentModalOpen: true });
  }

  handleDocumentFileTypeChange = (value) => {
    this.setState({ selectedDocumentType: value, documentTypeError: null });
  };

  uploadDocument() {
    document.getElementById("selectDocument").click();
  }

  handleDocumentFileChange = (event) => {
    const fileArray = Array.from(event.target.files);
    const File = fileArray.map((file) => {
      file["isNewFile"] = true;
      return file;
    });

    this.setState((prevState) => ({
      choosedDocument: [...prevState.choosedDocument, ...File],
      documentError: null,
    }));
    // Clear file input to allow re-uploading the same file
    event.target.value = "";
  };

  handleRemoveAttachments = (name) => {
    const removeDocument = this.state.selectedDocument.filter(
      (doc) => doc.name !== name,
    );
    this.setState({ selectedDocument: removeDocument });
  };

  // handleUploadDocument() {
  //   this.setState({ isUploadDocumentModalOpen: true });
  // }

  handleAddDocument = () => {
    let error = false;
    if (
      !this.state.choosedDocument ||
      this.state.choosedDocument.length === 0
    ) {
      this.setState({
        documentError: (
          <small className="text-danger">
            Please select a document to upload.
          </small>
        ),
      });
      error = true;
    }
    if (this.state.selectedDocumentType == "") {
      this.setState({
        documentTypeError: (
          <small className="text-danger">Document type is required.</small>
        ),
      });
      error = true;
    }
    if (!error) {
      console.log("im INN");
      this.handleSubmitUploadDocument(this.props.match.params.id);
    }
  };

  handleSubmitUploadDocument = (orderId) => {
    console.log("orderId", orderId);
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const formData = new FormData();
    this.state.choosedDocument.forEach((file, index) => {
      formData.append(`document[${index}]`, file);
    });
    formData.append("type", this.state.selectedDocumentType.value);
    formData.append("order_id", orderId);
    formData.append("channel", "admin");
    console.log("formData", formData);
    uploadOrderDocument(obj, formData)
      .then(async (res) => {
        console.log("Documents uploaded successfully", res);
        this.setState({ documentError: null, documentTypeError: null });

        const uploadedUrls = res.data.data.document_urls || [];
        console.log("uploadedUrls", res.data.data.document_urls);
        let uploadedDocuments = [];

        if (uploadedUrls.length > 0) {
          uploadedDocuments = await Promise.all(
            uploadedUrls.map(async (file, index) => {
              const fetchedFile = await fetch(file.url);
              const blob = await fetchedFile.blob();
              const filesFromApi = new File(
                [blob],
                `document new ${index + 1}`,
                {
                  type: blob.type,
                },
              );
              filesFromApi.isNewFile = false;
              filesFromApi.documentId = file.id;
              return filesFromApi;
            }),
          );
        } else {
          uploadedDocuments = (this.state.choosedDocument || []).map((doc) => {
            doc.isNewFile = true;
            return doc;
          });
        }

        const documents = [
          ...(this.state.selectedDocument || []),
          ...uploadedDocuments,
        ];

        this.setState({
          selectedDocument: documents,
          choosedDocument: [],
        });
        this.setState({ isUploadDocumentModalOpen: false });
      })
      .catch((error) => {
        console.error("Error uploading documents:", error);
        // this.setState({ isUploadDocumentModalOpen: false });
      });
  };

  handleConfirmDeleteAttachment = (name, id) => {
    this.setState({
      alert: (
        <SweetAlert
          className="order_alert"
          title="Are you sure you want to delete this document?"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.handleRemoveAttachmentsFromDb(name, id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="secondary"
          confirmBtnText="Delete"
          cancelBtnText="Cancel"
          showCancel
        >
          <h4>{name}</h4>
        </SweetAlert>
      ),
    });
  };

  handleRemoveAttachmentsFromDb = (name, id) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    deleteOrderDocument(id, obj)
      .then((res) => {
        console.log("Document deleted successfully", res);
        const removeDocument = this.state.selectedDocument.filter(
          (doc) => doc.name !== name,
        );
        this.setState({ selectedDocument: removeDocument, alert: null });
      })
      .catch((error) => {
        console.error("Error deleting document:", error);
      });
  };

  render() {
    let defaultFlashRef =
      this.state.store !== 1 && this.state.store !== null
        ? "Delta Force Clinic"
        : "Whatsapp";
    const enviorment = process.env.REACT_APP_ENVIRONMENT;
    const leadId = this.state.subscriber;
    const subscriber_detail = this.state.subscriber_detail;
    const country_detail = this.state.country_detail;
    const order = this.state.orderdetail;
    const view = <Tooltip id="view">View</Tooltip>;
    const subscriptiondetail = this.state.subscriptiondetail;
    const medicationdata = this.state.medicationdata;
    const quanitydata = this.state.quanitydata;
    var c = 1;
    var p = 1;
    var b = 1;
    const errormessages = this.state.errormessages;
    const medicationerrormessage = this.state.medicationerrormessage;

    // Created for Credit Note - Start
    const isSuperAdmin = this.state.tokenDetails.token.role === 1;

    const shouldShowButton = this.state.status === 3 || this.state.status === 8;
    const buttonText = this.state.creditNoteData
      ? shouldShowButton && this.state.creditNoteData.status === "DRAFT"
        ? "Edit"
        : "View"
      : shouldShowButton
        ? "Create"
        : null;

    const creditNoteValue =
      this.state.creditNoteData &&
      this.state.creditNoteData.status === "APPROVED"
        ? Number(this.state.creditNoteData.total_amount)
        : 0;
    // Created for Credit Note - End

    return (
      <>
        <>
          {/* {this.state.packagefeatures[0]
            ? (this.state.packagefeatures[0].raya != "" ||
                this.state.packagefeatures[0].mad != "" ||
                this.state.packagefeatures[0].express != "") && ( */}
          {this.state.packagefeatures[0] ||
          this.state.isInsureme ||
          (this.state.isFirstOrder && !this.state.sub_orderType) ? (
            <div className="package_feature">
              {this.state.catalougepackagename && (
                <div className="package_featurelist">
                  {!!this.state.logo_1 ? (
                    <img
                      height="50px"
                      src={this.state.logo_1 || ""}
                      alt="logo"
                    />
                  ) : (
                    <div style={{ height: "50px" }}>{null}</div>
                  )}
                  <h5 style={{ fontSize: "14px", width: "110px" }}>
                    Package Name:
                  </h5>
                  <p
                    style={{
                      fontSize: "14px",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                    }}
                  >
                    {this.state.catalougepackagename}
                  </p>
                </div>
              )}
              {this.state.packagefeatures[0] &&
                this.state.packagefeatures[0].raya != "" && (
                  <div
                    className="package_featurelist"
                    style={{ margin: "0px" }}
                  >
                    <h5>Raya:</h5>
                    <p
                      style={{
                        fontSize: "14px",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                      }}
                    >
                      {this.state.packagefeatures[0].raya}%
                    </p>
                  </div>
                )}
              {this.state.packagefeatures[0] &&
                this.state.packagefeatures[0].mad != "" && (
                  <div className="package_featurelist">
                    <h5 style={{ fontSize: "14px" }}>Medicine:</h5>
                    <p
                      style={{
                        fontSize: "14px",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                      }}
                    >
                      {this.state.packagefeatures[0].mad}%
                    </p>
                  </div>
                )}
              {this.state.packagefeatures[0] &&
                this.state.packagefeatures[0].express.length != 0 &&
                this.state.packagefeatures[0].express[3].t_count != 0 && (
                  <div className="package_featurelist">
                    <h5 style={{ fontSize: "12px" }}>N.O.Free Delivery:</h5>
                    {this.state.packagefeatures[0].express.length != 0 &&
                      Number(this.state.packagefeatures[0].express[0].free) !==
                        0 && (
                        <>
                          <h5 style={{ fontSize: "12px" }}>Standard:</h5>
                          <p
                            style={{
                              fontSize: "14px",
                              textTransform: "uppercase",
                              fontWeight: "bold",
                            }}
                          >
                            {this.state.packagefeatures[0].express[0].free}
                          </p>
                        </>
                      )}
                    {this.state.packagefeatures[0] &&
                      this.state.packagefeatures[0].express.length != 0 &&
                      Number(this.state.packagefeatures[0].express[1].free) !==
                        0 && (
                        <>
                          <h5 style={{ fontSize: "12px" }}>Express:</h5>
                          <p
                            style={{
                              fontSize: "14px",
                              textTransform: "uppercase",
                              fontWeight: "bold",
                            }}
                          >
                            {this.state.packagefeatures[0].express[1].free}
                          </p>
                        </>
                      )}
                    {this.state.packagefeatures[0] &&
                      this.state.packagefeatures[0].express.length != 0 &&
                      Number(this.state.packagefeatures[0].express[2].free) !==
                        0 && (
                        <>
                          <h5 style={{ fontSize: "12px" }}>Island Wide:</h5>
                          <p
                            style={{
                              fontSize: "14px",
                              textTransform: "uppercase",
                              fontWeight: "bold",
                            }}
                          >
                            {this.state.packagefeatures[0].express[2].free}
                          </p>
                        </>
                      )}
                  </div>
                )}
              {this.state.packagefeatures[0] &&
                this.state.packagefeatures[0].express.length != 0 &&
                this.state.packagefeatures[0].express[3].t_count !== 0 && (
                  <>
                    <div className="package_featurelist">
                      <h5 style={{ fontSize: "12px" }}>Delivery Discounts:</h5>
                      {this.state.packagefeatures[0].express.length != 0 &&
                        Number(
                          this.state.packagefeatures[0].express[0].discount,
                        ) !== 0 && (
                          <>
                            <h5 style={{ fontSize: "12px" }}>Standard:</h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {
                                this.state.packagefeatures[0].express[0]
                                  .discount
                              }
                              %
                            </p>
                          </>
                        )}
                      {this.state.packagefeatures[0] &&
                        this.state.packagefeatures[0].express.length != 0 &&
                        Number(
                          this.state.packagefeatures[0].express[1].discount,
                        ) !== 0 && (
                          <>
                            <h5 style={{ fontSize: "12px" }}>Express:</h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {
                                this.state.packagefeatures[0].express[1]
                                  .discount
                              }
                              %
                            </p>
                          </>
                        )}
                      {this.state.packagefeatures[0] &&
                        this.state.packagefeatures[0].express.length != 0 &&
                        Number(
                          this.state.packagefeatures[0].express[2].discount,
                        ) !== 0 && (
                          <>
                            <h5 style={{ fontSize: "12px" }}>Island Wide:</h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {
                                this.state.packagefeatures[0].express[2]
                                  .discount
                              }
                              %
                            </p>
                          </>
                        )}
                    </div>
                    <div className="package_featurelist">
                      <h5 style={{ fontSize: "12px" }}>Delivery Base price:</h5>
                      {this.state.packagefeatures[0] &&
                        this.state.packagefeatures[0].express.length != 0 &&
                        Number(
                          this.state.packagefeatures[0].express[0].base_price,
                        ) !== 0 && (
                          <>
                            <h5 style={{ fontSize: "12px" }}>Standard:</h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {Number(
                                this.state.packagefeatures[0].express[0]
                                  .base_price,
                              ).toFixed(2)}
                            </p>
                          </>
                        )}
                      {this.state.packagefeatures[0] &&
                        this.state.packagefeatures[0].express.length != 0 &&
                        Number(
                          this.state.packagefeatures[0].express[1].base_price,
                        ) !== 0 && (
                          <>
                            <h5 style={{ fontSize: "12px" }}>Express:</h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {Number(
                                this.state.packagefeatures[0].express[1]
                                  .base_price,
                              ).toFixed(2)}
                            </p>
                          </>
                        )}
                      {this.state.packagefeatures[0] &&
                        this.state.packagefeatures[0].express.length != 0 &&
                        Number(
                          this.state.packagefeatures[0].express[2].base_price,
                        ) !== 0 && (
                          <>
                            <h5 style={{ fontSize: "12px" }}>Island Wide:</h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {Number(
                                this.state.packagefeatures[0].express[2]
                                  .base_price,
                              ).toFixed(2)}
                            </p>
                          </>
                        )}
                    </div>
                  </>
                )}
              {this.state.isClaimableOrder && (
                <div
                  className="package_featurelist"
                  style={{ marginLeft: "auto" }}
                >
                  <h5
                    className="btn btn-fill claimButton"
                    style={{
                      fontSize: "16px",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                    }}
                  >
                    Automatic Claim Order
                  </h5>
                </div>
              )}
              {this.state.isInsureme && (
                <div
                  className="package_featurelist"
                  style={{ marginLeft: "auto" }}
                >
                  <h5
                    className="btn btn-fill claimButton"
                    style={{
                      fontSize: "16px",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      marginRight: "25px",
                    }}
                  >
                    Insureme Order
                  </h5>
                </div>
              )}
              {this.state.isFirstOrder && !this.state.sub_orderType && (
                <div
                  className="package_featurelist"
                  style={{ marginLeft: "auto" }}
                >
                  <h5
                    className="btn btn-fill claimButton"
                    style={{
                      fontSize: "16px",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      marginRight: "25px",
                      border: "unset",
                      outline: "none",
                      boxShadow: "none",
                    }}
                  >
                    🎈 Add Balloon & Bookmark
                  </h5>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </>
        <div className="main-content">
          {this.state.contentLoading ? <LoadingOrder /> : ""}
          <Grid fluid>
            <NotificationSystem ref="notificationSystem" style={style} />
            {this.state.alert}
            {this.state.alertquote}

            <Card
              content={
                <Row>
                  {/* {this.state.packagefeatures[0]
                  ? (this.state.packagefeatures[0].raya != "" ||
                      this.state.packagefeatures[0].mad != "" ||
                      this.state.packagefeatures[0].express != "") && (
                      <div className="package_feature">
                        {this.state.catalougepackagename && (
                          <div className="package_featurelist">
                            {this.state.logo_1 !== "" ? (
                              <img
                                height="50px"
                                src={this.state.logo_1}
                                alt="logo"
                              />
                            ) : (
                              <div style={{ height: "50px" }}>{null}</div>
                            )}
                            <h5 style={{ fontSize: "14px", width: "110px" }}>
                              Package Name:
                            </h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {this.state.catalougepackagename}
                            </p>
                          </div>
                        )}
                        {this.state.packagefeatures[0].raya != "" && (
                          <div
                            className="package_featurelist"
                            style={{ margin: "0px" }}
                          >
                            <h5>Raya:</h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {this.state.packagefeatures[0].raya}%
                            </p>
                          </div>
                        )}
                        {this.state.packagefeatures[0].mad != "" && (
                          <div className="package_featurelist">
                            <h5 style={{ fontSize: "14px" }}>Medicine:</h5>
                            <p
                              style={{
                                fontSize: "14px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              {this.state.packagefeatures[0].mad}%
                            </p>
                          </div>
                        )}
                        {this.state.packagefeatures[0].express.length != 0 &&
                          this.state.packagefeatures[0].express[3].t_count !=
                            0 && (
                            <div className="package_featurelist">
                              <h5 style={{ fontSize: "12px" }}>
                                N.O.Free Delivery:
                              </h5>
                              {this.state.packagefeatures[0].express.length !=
                                0 &&
                                Number(
                                  this.state.packagefeatures[0].express[0].free
                                ) !== 0 && (
                                  <>
                                    <h5 style={{ fontSize: "12px" }}>
                                      Standard:
                                    </h5>
                                    <p
                                      style={{
                                        fontSize: "14px",
                                        textTransform: "uppercase",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {
                                        this.state.packagefeatures[0].express[0]
                                          .free
                                      }
                                    </p>
                                  </>
                                )}
                              {this.state.packagefeatures[0].express.length !=
                                0 &&
                                Number(
                                  this.state.packagefeatures[0].express[1].free
                                ) !== 0 && (
                                  <>
                                    <h5 style={{ fontSize: "12px" }}>
                                      Express:
                                    </h5>
                                    <p
                                      style={{
                                        fontSize: "14px",
                                        textTransform: "uppercase",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {
                                        this.state.packagefeatures[0].express[1]
                                          .free
                                      }
                                    </p>
                                  </>
                                )}
                              {this.state.packagefeatures[0].express.length !=
                                0 &&
                                Number(
                                  this.state.packagefeatures[0].express[2].free
                                ) !== 0 && (
                                  <>
                                    <h5 style={{ fontSize: "12px" }}>
                                      Island Wide:
                                    </h5>
                                    <p
                                      style={{
                                        fontSize: "14px",
                                        textTransform: "uppercase",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {
                                        this.state.packagefeatures[0].express[2]
                                          .free
                                      }
                                    </p>
                                  </>
                                )}
                            </div>
                          )}
                        {this.state.packagefeatures[0].express.length != 0 &&
                          this.state.packagefeatures[0].express[3].t_count !==
                            0 && (
                            <>
                              <div className="package_featurelist">
                                <h5 style={{ fontSize: "12px" }}>
                                  Delivery Discounts:
                                </h5>
                                {this.state.packagefeatures[0].express.length !=
                                  0 &&
                                  Number(
                                    this.state.packagefeatures[0].express[0]
                                      .discount
                                  ) !== 0 && (
                                    <>
                                      <h5 style={{ fontSize: "12px" }}>
                                        Standard:
                                      </h5>
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          textTransform: "uppercase",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {
                                          this.state.packagefeatures[0]
                                            .express[0].discount
                                        }
                                        %
                                      </p>
                                    </>
                                  )}
                                {this.state.packagefeatures[0].express.length !=
                                  0 &&
                                  Number(
                                    this.state.packagefeatures[0].express[1]
                                      .discount
                                  ) !== 0 && (
                                    <>
                                      <h5 style={{ fontSize: "12px" }}>
                                        Express:
                                      </h5>
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          textTransform: "uppercase",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {
                                          this.state.packagefeatures[0]
                                            .express[1].discount
                                        }
                                        %
                                      </p>
                                    </>
                                  )}
                                {this.state.packagefeatures[0].express.length !=
                                  0 &&
                                  Number(
                                    this.state.packagefeatures[0].express[2]
                                      .discount
                                  ) !== 0 && (
                                    <>
                                      <h5 style={{ fontSize: "12px" }}>
                                        Island Wide:
                                      </h5>
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          textTransform: "uppercase",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {
                                          this.state.packagefeatures[0]
                                            .express[2].discount
                                        }
                                        %
                                      </p>
                                    </>
                                  )}
                              </div>
                              <div className="package_featurelist">
                                <h5 style={{ fontSize: "12px" }}>
                                  Delivery Base price:
                                </h5>
                                {this.state.packagefeatures[0].express.length !=
                                  0 &&
                                  Number(
                                    this.state.packagefeatures[0].express[0]
                                      .base_price
                                  ) !== 0 && (
                                    <>
                                      <h5 style={{ fontSize: "12px" }}>
                                        Standard:
                                      </h5>
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          textTransform: "uppercase",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {Number(
                                          this.state.packagefeatures[0]
                                            .express[0].base_price
                                        ).toFixed(2)}
                                      </p>
                                    </>
                                  )}
                                {this.state.packagefeatures[0].express.length !=
                                  0 &&
                                  Number(
                                    this.state.packagefeatures[0].express[1]
                                      .base_price
                                  ) !== 0 && (
                                    <>
                                      <h5 style={{ fontSize: "12px" }}>
                                        Express:
                                      </h5>
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          textTransform: "uppercase",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {Number(
                                          this.state.packagefeatures[0]
                                            .express[1].base_price
                                        ).toFixed(2)}
                                      </p>
                                    </>
                                  )}
                                {this.state.packagefeatures[0].express.length !=
                                  0 &&
                                  Number(
                                    this.state.packagefeatures[0].express[2]
                                      .base_price
                                  ) !== 0 && (
                                    <>
                                      <h5 style={{ fontSize: "12px" }}>
                                        Island Wide:
                                      </h5>
                                      <p
                                        style={{
                                          fontSize: "14px",
                                          textTransform: "uppercase",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {Number(
                                          this.state.packagefeatures[0]
                                            .express[2].base_price
                                        ).toFixed(2)}
                                      </p>
                                    </>
                                  )}
                              </div>
                            </>
                          )}
                        {this.state.isClaimableOrder && (
                          <div
                            className="package_featurelist"
                            style={{ marginLeft: "auto" }}
                          >
                            <h5
                              className="btn btn-fill claimButton"
                              style={{
                                fontSize: "16px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                              }}
                            >
                              Automatic Claim Order
                            </h5>
                          </div>
                        )}
                      </div>
                    )
                  : ""} */}

                  {/*this.state.ispaywarning && this.state.order_type == 1 && (
                  <div className="paywarning_message_display">
                    This Order Value is more than Rs.5000. Please contact and
                    ask them to pay on card
                  </div>
                )*/}

                  <Col sm={8} className="orderFormdata-container">
                    <input
                      style={{ width: "0px", height: "0px", border: "none" }}
                      type="text"
                      ref={this.message_error}
                    />
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <div
                      className="order_topdata_container"
                      style={{
                        marginBottom: "40px",
                        padding: "0 20px",
                      }}
                    >
                      <Row>
                        <Col md={12}>
                          <h3
                            style={{
                              margin: "0",
                              letterSpacing: "0.5px",
                              fontSize: "24px",
                            }}
                          >
                            Order Details
                          </h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <br></br>
                            <ControlLabel style={{ display: "block" }}>
                              Order Type
                            </ControlLabel>
                            {this.state.sub_orderType !== 4 ? (
                              <div
                                className="order_source_data"
                                style={{ marginTop: 16, marginBottom: 16 }}
                              >
                                <Switch
                                  checked={this.state.sub_orderType}
                                  onColor="#6c757d"
                                  offColor="#007bff"
                                  onHandleColor="#007bff"
                                  offHandleColor="#6c757d"
                                  height={32}
                                  width={70}
                                  uncheckedIcon={
                                    <div
                                      style={{
                                        padding: "7px 6px",
                                        color: "white",
                                        fontWeight: "600",
                                      }}
                                    >
                                      B2C
                                    </div>
                                  }
                                  checkedIcon={
                                    <div
                                      style={{
                                        padding: "7px 10px",
                                        color: "white",
                                        fontWeight: "600",
                                      }}
                                    >
                                      B2B
                                    </div>
                                  }
                                  className="react-switch"
                                  id="small-radius-switch"
                                />
                              </div>
                            ) : (
                              <div
                                className="order_source_data"
                                style={{
                                  marginTop: 16,
                                  marginBottom: 16,
                                  cursor: "not-allowed",
                                }}
                              >
                                <Switch
                                  onColor="#6c757d"
                                  offColor="#007bff"
                                  onHandleColor="#007bff"
                                  offHandleColor="#6c757d"
                                  height={32}
                                  width={70}
                                  uncheckedIcon={
                                    <div
                                      style={{
                                        padding: "7px 6px",
                                        color: "white",
                                        fontWeight: "600",
                                        cursor: "not-allowed",
                                      }}
                                    >
                                      PR
                                    </div>
                                  }
                                  checkedIcon={
                                    <div
                                      style={{
                                        padding: "7px 10px",
                                        color: "white",
                                        fontWeight: "600",
                                      }}
                                    ></div>
                                  }
                                  className="react-switch"
                                  id="small-radius-switch"
                                />
                              </div>
                            )}
                          </FormGroup>

                          <FormGroup>
                            <ControlLabel>Subscriber</ControlLabel>
                            <select
                              name="subscriber"
                              style={{ textTransform: "capitalize" }}
                              disabled="disabled"
                              onChange={this.onChange}
                              value={this.state.subscriber}
                              className="form-control"
                            >
                              <option value="0">Select Subscriber</option>

                              <option
                                value={subscriber_detail.id}
                                key={subscriber_detail.id}
                              >
                                {subscriber_detail.name}
                              </option>
                            </select>
                            {this.state.subscriberError}
                          </FormGroup>

                          <FormGroup>
                            <ControlLabel>Prescriptions </ControlLabel>
                            <br />
                            <div style={{ display: "inline-block" }}>
                              {this.state.priscriptionurl.map((pre, key) => (
                                <>
                                  {pre.prescription_url.prescription_file !=
                                    "" && (
                                    <a
                                      key={key}
                                      style={{
                                        fontSize: "25px",
                                        display: "inline-block",
                                        color: "black",
                                      }}
                                      href={
                                        pre.prescription_url.prescription_file
                                      }
                                      target="_blank"
                                      onClick={() => {
                                        if (Number(this.state.status) === 1) {
                                          this.sendProcess("processing", {
                                            stayOnPage: true,
                                          });
                                        }
                                      }}
                                    >
                                      <Button style={{}}>P{p++}</Button>
                                      &nbsp;
                                    </a>
                                  )}
                                </>
                              ))}
                              {this.state.prescription_text != null ? (
                                <>
                                  {b == 1 ? (
                                    <Button
                                      style={{ marginTop: "-6px" }}
                                      onClick={this.displayNoteb.bind(this)}
                                    >
                                      P text
                                    </Button>
                                  ) : (
                                    ""
                                  )}
                                  &nbsp;&nbsp;
                                  <>
                                    <span style={{ display: "none" }}>
                                      {b--}
                                    </span>
                                  </>
                                </>
                              ) : (
                                ""
                              )}
                              {this.state.is_abusable_url != null ? (
                                <>
                                  <a
                                    style={{
                                      fontSize: "25px",
                                      display: "inline-block",
                                      color: "black",
                                    }}
                                    href={this.state.is_abusable_url}
                                    target="_blank"
                                  >
                                    <Button style={{}}>
                                      Sealed Prescription
                                    </Button>
                                    &nbsp;
                                  </a>
                                </>
                              ) : (
                                ""
                              )}
                              {this.state.prescription_note != null &&
                              this.state.prescription_note != "" ? (
                                <>
                                  <Button
                                    style={{
                                      marginBottom: "6px",
                                      marginRight: "3px",
                                    }}
                                    onClick={this.displayorderNote.bind(this)}
                                  >
                                    P note
                                  </Button>
                                </>
                              ) : (
                                ""
                              )}
                              <input
                                style={{ display: "none" }}
                                id="selectImage"
                                type="file"
                                className="form-control"
                                name="prescription"
                                multiple
                                onChange={(e) => this.handleFileChanges(e)}
                              />
                              &nbsp;
                              <Button
                                onClick={this.upload}
                                style={{
                                  color: "#2B3A41",
                                  marginBottom: "6px",
                                }}
                              >
                                {" "}
                                <i
                                  className={
                                    this.state.selectedFile == ""
                                      ? "fa fa-plus"
                                      : "fa fa-pencil fa-fw"
                                  }
                                ></i>{" "}
                                {this.state.selectedFile == ""
                                  ? "Choose File"
                                  : "Change File"}
                                {this.state.selectedFile.length > 0 && (
                                  <i
                                    className="fa fa-check"
                                    style={{
                                      color: "green",
                                      marginLeft: 5,
                                      fontSize: "16px",
                                    }}
                                    aria-hidden="true"
                                  ></i>
                                )}
                              </Button>
                              {/* Collapse data  */}
                              <div>
                                <Collapse isOpened={this.state.notedisplay}>
                                  {this.state.prescription_text != null && (
                                    <>
                                      {this.state.getOrderChannel === "app" &&
                                      Number(this.state.source.value) !== 15 ? (
                                        <>
                                          {c++}. Prescription Text:{" "}
                                          {this.state.prescription_text}
                                          <br />
                                        </>
                                      ) : (
                                        this.state.store !== 1 &&
                                        this.state.store !== null &&
                                        Number(this.state.source.value) ==
                                          15 && (
                                          <Button
                                            onClick={() =>
                                              window.open(
                                                this.state.prescription_text,
                                                "_blank",
                                              )
                                            }
                                          >
                                            Prescription
                                          </Button>
                                        )
                                      )}
                                      <br />
                                    </>
                                  )}
                                </Collapse>
                                {this.state.prescription_note != null ? (
                                  <Collapse
                                    isOpened={this.state.ordernotedisplay}
                                  >
                                    Prescription Note :{" "}
                                    {this.state.prescription_note}
                                    <br />
                                  </Collapse>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="6" style={{ width: "45%" }}>
                          <FormGroup className="fl_datepicker">
                            <br></br>
                            <div
                              style={{ position: "relative", bottom: "5px" }}
                            >
                              <ControlLabel
                                style={{
                                  marginTop: "1px",
                                  borderTop: "5px",
                                }}
                              >
                                {" "}
                                Order Date
                              </ControlLabel>
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{ placeholder: "Date Picker Here" }}
                                value={this.state.orderdate}
                                closeOnSelect={true}
                                onChange={this.handleDateChange}
                              />
                            </div>
                          </FormGroup>
                          {(this.state.store == 1 ||
                            this.state.store === null) && (
                            <FormGroup>
                              <ControlLabel>Sales Rep </ControlLabel>
                              <select
                                name="sales_rep"
                                value={this.state.sales_rep}
                                onChange={this.onChange}
                                className="form-control"
                              >
                                <option value="0">Select Sales Rep</option>
                                {this.state.sales_rep_data.map(
                                  (sales_data, key) => (
                                    <option value={sales_data.value} key={key}>
                                      {sales_data.label}
                                    </option>
                                  ),
                                )}
                              </select>
                            </FormGroup>
                          )}
                          <FormGroup>
                            <ControlLabel>Upload Document </ControlLabel>
                            <br></br>
                            <Button
                              onClick={() => this.handleUploadDocument()}
                              style={{
                                color: "#2B3A41",
                              }}
                            >
                              <i className="fa fa-upload"></i>{" "}
                              {this.state.selectedDocument.length === 0
                                ? "Upload Document"
                                : "Change File"}
                            </Button>
                          </FormGroup>
                          {this.state.selectedDocument &&
                            this.state.selectedDocument.length > 0 && (
                              <div style={{ marginTop: 10 }}>
                                {[]
                                  .concat(...this.state.selectedDocument)
                                  .map((doc, index) => (
                                    <span
                                      style={{
                                        background: "white",
                                        color: "black",
                                        padding: "10px",
                                        borderRadius: "10px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        marginRight: "10px",
                                        marginBottom: "10px",
                                        border: "1px solid #ccc",
                                      }}
                                      key={index}
                                    >
                                      <a
                                        href={
                                          doc instanceof Blob
                                            ? URL.createObjectURL(doc)
                                            : "#"
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={(e) => {
                                          if (!(doc instanceof Blob)) {
                                            e.preventDefault();
                                          }
                                        }}
                                      >
                                        {doc.name || "Document"}
                                      </a>
                                      <img
                                        onClick={() =>
                                          this.handleConfirmDeleteAttachment(
                                            doc.name,
                                            doc.documentId,
                                          )
                                        }
                                        style={{
                                          padding: "5px",
                                          background: "red",
                                          cursor: "pointer",
                                          width: "20px",
                                          alignSelf: "flex-start",
                                          color: "red",
                                          marginLeft: "15px",
                                          borderRadius: "15px",
                                        }}
                                        src="https://img.icons8.com/ios-glyphs/30/FFFFFF/delete-sign.png"
                                        alt="remove"
                                      />
                                    </span>
                                  ))}
                              </div>
                            )}
                        </Col>
                      </Row>
                      <br />
                      {(this.state.store == 1 || this.state.store === null) && (
                        <Row>
                          <Col md="6">
                            <FormGroup>
                              <ControlLabel>Source</ControlLabel>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="source"
                                value={this.state.source}
                                onChange={(value) => {
                                  if (value.value == "2") {
                                    this.setState({
                                      mypharmareferance: "",
                                      source: value,
                                    });
                                  } else if (value.value == "3") {
                                    this.setState({
                                      opharmareferance: "",
                                      source: value,
                                    });
                                  } else if (value.value == "4") {
                                    this.setState({
                                      mypharmareferance: "",
                                      opharmareferance: "",
                                      source: value,
                                    });
                                  } else {
                                    this.setState({ source: value });
                                  }
                                }}
                                placeholder="Select Source"
                                options={this.state.sourceOptions}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="6" style={{ width: "45%" }}>
                            {this.state.source.value === 3 ? (
                              <FormGroup>
                                <ControlLabel>MyPharma Referance</ControlLabel>
                                <FormControl
                                  name="mypharmareferance"
                                  value={this.state.mypharmareferance}
                                  onChange={(event) => {
                                    this.setState({
                                      mypharmareferance: event.target.value,
                                    });
                                  }}
                                  placeholder="Enter MyPharma Referance"
                                  type="text"
                                />
                                {this.state.mypharmareferanceError}
                              </FormGroup>
                            ) : (
                              ""
                            )}
                            {this.state.source.value == 2 ? (
                              <FormGroup>
                                <ControlLabel className="opharma">
                                  oPharma Referance
                                </ControlLabel>
                                <FormControl
                                  style={{ margin: "0" }}
                                  name="opharmareferance"
                                  value={this.state.opharmareferance}
                                  onChange={(event) => {
                                    this.setState({
                                      opharmareferance: event.target.value,
                                    });
                                    // event.target.value === ""
                                    //   ? this.setState({
                                    //       opharmareferanceError: (
                                    //         <small className="text-danger">
                                    //           OPharma Referance is required.
                                    //         </small>
                                    //       )
                                    //     })
                                    //   : this.setState({ opharmareferanceError: null });
                                  }}
                                  placeholder="Enter oPharma Referance"
                                  type="text"
                                />
                                {this.state.opharmareferanceError}
                              </FormGroup>
                            ) : this.state.source.value == 1 ||
                              this.state.source.value == 15 ? (
                              <>
                                <ControlLabel>Flash Reference</ControlLabel>
                                <select
                                  value={
                                    this.state.flashreference || defaultFlashRef
                                  }
                                  className="form-control"
                                  onChange={(event) => {
                                    this.setState({
                                      flashreference: event.target.value,
                                    });
                                  }}
                                >
                                  <option value="Watsapp">Whatsapp</option>
                                  <option value="Google">Google</option>
                                  <option value="Flash Hotline">
                                    Flash Hotline
                                  </option>
                                  <option value="NCD">NCD</option>
                                  <option value="Delta Force Clinic">
                                    Delta Force Clinic
                                  </option>
                                </select>
                              </>
                            ) : (
                              ""
                            )}
                            {this.state.source.value == 8 &&
                              this.state.documenturl.length > 0 && (
                                <Col md={6}>
                                  <ControlLabel>Documents</ControlLabel>
                                  <div style={{ display: "inline-block" }}>
                                    {this.state.documenturl.map((pre, key) => (
                                      <>
                                        {pre.document_url && (
                                          <a
                                            key={key}
                                            style={{
                                              fontSize: "25px",
                                              display: "inline-block",
                                              color: "black",
                                            }}
                                            href={pre.document_url}
                                            target="_blank"
                                          >
                                            <Button
                                              style={{ marginRight: "3px" }}
                                            >
                                              {`Doc ${key + 1}`}
                                            </Button>
                                          </a>
                                        )}
                                      </>
                                    ))}
                                  </div>
                                </Col>
                              )}
                          </Col>
                        </Row>
                      )}

                      {this.state.sub_orderType == true && (
                        <Row>
                          <Col md="4">
                            <FormGroup>
                              <ControlLabel>PO Number</ControlLabel>
                              <FormControl
                                style={{ margin: "0" }}
                                name="po_number"
                                value={this.state.po_number}
                                onChange={this.onChange}
                                placeholder="Enter PO Number"
                                type="text"
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="document_upload_container">
                              <ControlLabel>PO Document</ControlLabel>
                              <div className="docUrl_listview">
                                {this.state.PNdocUrl.length > 0 ? (
                                  <>
                                    <br></br>
                                    {this.state.PNdocUrl.map((pre, key) => (
                                      <div className="document_adddelete">
                                        <Button
                                          style={{
                                            marginRight: "3px",
                                            marginBottom: "10px",
                                            padding: 0,
                                          }}
                                        >
                                          {" "}
                                          <a
                                            className="orderdoc_nav_link"
                                            key={key}
                                            style={{
                                              fontSize: "25px",
                                              display: "inline-block",
                                              color: "black",
                                            }}
                                            href={pre}
                                            target="_blank"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                            }}
                                          >
                                            PO {key + 1}
                                          </a>
                                        </Button>
                                        <p
                                          className="delete_addeddoc delete_gen_doc"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.poFinaldeleteDoc(key);
                                          }}
                                        >
                                          x
                                        </p>
                                      </div>
                                    ))}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>

                              <input
                                style={{ display: "none" }}
                                id="select_podoc"
                                type="file"
                                className="form-control"
                                name="po_document"
                                multiple
                                onChange={this.handlePOFileChange}
                              />
                              <Button
                                onClick={this.uploadPODoc}
                                style={{ color: "#2B3A41" }}
                              >
                                {" "}
                                <i
                                  className={
                                    this.state.selectedFile == ""
                                      ? "fa fa-plus"
                                      : "fa fa-pencil fa-fw"
                                  }
                                ></i>{" "}
                                {this.state.selectedFile == ""
                                  ? "Choose File"
                                  : "Change File"}
                              </Button>
                              {this.state.po_document.length > 0 && (
                                <Button
                                  onClick={this.uploadPOFinal}
                                  style={{
                                    color: "#2B3A41",
                                    marginLeft: "10px",
                                  }}
                                >
                                  Upload
                                </Button>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="document_upload_container">
                              <ControlLabel>GRN Document</ControlLabel>
                              <div className="docUrl_listview">
                                {this.state.GRNDocUrl.length > 0 ? (
                                  <>
                                    {this.state.GRNDocUrl.map((pre, key) => (
                                      <div className="document_adddelete">
                                        <Button
                                          style={{
                                            marginRight: "3px",
                                            marginBottom: "10px",
                                            padding: 0,
                                          }}
                                        >
                                          <a
                                            className="orderdoc_nav_link"
                                            key={key}
                                            style={{
                                              fontSize: "25px",
                                              display: "inline-block",
                                              color: "black",
                                            }}
                                            href={pre}
                                            target="_blank"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                            }}
                                          >
                                            {" "}
                                            GRN {key + 1}{" "}
                                          </a>
                                        </Button>
                                        <p
                                          className="delete_addeddoc delete_gen_doc"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            this.grnFinaldeleteDoc(key);
                                          }}
                                        >
                                          x
                                        </p>
                                      </div>
                                    ))}
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                              <input
                                style={{ display: "none" }}
                                id="select_grndoc"
                                type="file"
                                className="form-control"
                                name="grn_document"
                                multiple
                                onChange={this.handleGRNFileChange}
                                placeholder="Enter oPharma Referance"
                              />
                              <Button
                                onClick={this.uploadGRNDoc}
                                style={{ color: "#2B3A41" }}
                              >
                                {" "}
                                <i
                                  className={
                                    this.state.selectedFile == ""
                                      ? "fa fa-plus"
                                      : "fa fa-pencil fa-fw"
                                  }
                                ></i>{" "}
                                {this.state.selectedFile == ""
                                  ? "Choose File"
                                  : "Change File"}
                              </Button>
                              {this.state.grn_document.length > 0 && (
                                <Button
                                  onClick={this.uploadGRNFinal}
                                  style={{
                                    color: "#2B3A41",
                                    marginLeft: "10px",
                                  }}
                                >
                                  Upload
                                </Button>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      )}
                      <Row>&nbsp;</Row>
                      <Row>
                        <Col md={6} sm={6} style={{}}>
                          <FormGroup>
                            <p>
                              <b>Substitue Medicine : </b>
                              {this.state.is_substitute_medicine == 1
                                ? "Yes"
                                : "No"}
                            </p>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    {(this.state.store == 1 ||
                      this.state.store === null ||
                      this.state.channel == "app") &&
                      (this.state.subscriber != 0 ? (
                        <div
                          className="order_address_container"
                          style={{
                            padding: "0 20px",
                          }}
                        >
                          <Row>
                            <Col md={6}>
                              <h3
                                style={{
                                  margin: "0",
                                  letterSpacing: "0.5px",
                                  fontSize: "24px",
                                }}
                              >
                                Delivery Address
                              </h3>
                            </Col>
                            <Col md={6} style={{ textAlign: "right" }}>
                              <Button
                                fill
                                // onClick={this.addanother.bind(this)}
                                onClick={() =>
                                  this.setState({
                                    isCreateAddressModalOpen: true,
                                    addressModalType: "delivery",
                                  })
                                }
                                style={{ marginBottom: "17px" }}
                              >
                                Add Another Address
                                <i className="fa fa-plus"></i>
                              </Button>
                            </Col>
                          </Row>

                          <Row>
                            <Col md={12}>
                              {this.state.addressline1Error && (
                                <small className="text-danger">
                                  {this.state.addressline1Error}
                                </small>
                              )}

                              {this.state.addressdata.length ? (
                                <div
                                  style={{
                                    padding: "20px 0",
                                  }}
                                >
                                  {this.state.addressdata.map((add, key) =>
                                    this.state.first_address == add.id ? (
                                      <p key={key}>
                                        {" "}
                                        <div
                                          style={{
                                            borderColor: "#D3D3D3",
                                          }}
                                        >
                                          <input
                                            name="addressradio"
                                            checked={
                                              this.state.address_id == add.id
                                                ? "true"
                                                : ""
                                            }
                                            onChange={this.warningChangeAddress.bind(
                                              this,
                                              add.id,
                                              add.country_id,
                                              this.state.billing_address_id,
                                              add.country_id,
                                              "delivery",
                                            )}
                                            type="radio"
                                          />{" "}
                                          &nbsp;
                                          {add.address_line1},
                                          {add.address_line2} ,
                                          {this.state.city_info.map((city) => (
                                            <React.Fragment>
                                              {city.id == add.city
                                                ? city.city_name
                                                : ""}{" "}
                                            </React.Fragment>
                                          ))}{" "}
                                          ,
                                          {country_detail.map(
                                            (country_data) => (
                                              <React.Fragment>
                                                {country_data.id ==
                                                add.country_id
                                                  ? country_data.country_name +
                                                    ","
                                                  : ""}{" "}
                                              </React.Fragment>
                                            ),
                                          )}
                                          {add.postal_code}
                                          {this.state.address_id == add.id ? (
                                            <i
                                              style={{
                                                color: "green",
                                                fontSize: "20px",
                                              }}
                                              className="fa fa-check"
                                            ></i>
                                          ) : (
                                            ""
                                          )}
                                        </div>{" "}
                                      </p>
                                    ) : (
                                      ""
                                    ),
                                  )}

                                  {this.state.addressdata.length > 1 && (
                                    <div className="collapeable_addresses_list">
                                      <Collapsible
                                        trigger="View Other Addresses"
                                        transitionTime={200}
                                        onClosing={() => {
                                          this.setState({
                                            first_address:
                                              this.state.address_id,
                                          });
                                        }}
                                      >
                                        {this.state.addressdata.map(
                                          (add, key) =>
                                            this.state.first_address !=
                                            add.id ? (
                                              <p key={key}>
                                                {" "}
                                                <div
                                                  style={{
                                                    borderColor: "#D3D3D3",
                                                  }}
                                                >
                                                  <input
                                                    name="addressradio"
                                                    value={add.id}
                                                    checked={
                                                      this.state.address_id ==
                                                      add.id
                                                    }
                                                    onChange={this.warningChangeAddress.bind(
                                                      this,
                                                      add.id,
                                                      add.country_id,
                                                      this.state
                                                        .billing_address_id,
                                                      add.country_id,
                                                      "delivery",
                                                    )}
                                                    type="radio"
                                                  ></input>{" "}
                                                  {add.address_line1},
                                                  {add.address_line2} ,
                                                  {this.state.city_info.map(
                                                    (city) => (
                                                      <React.Fragment>
                                                        {city.id == add.city
                                                          ? city.city_name
                                                          : ""}
                                                      </React.Fragment>
                                                    ),
                                                  )}{" "}
                                                  ,
                                                  {country_detail.map(
                                                    (country_data) => (
                                                      <React.Fragment>
                                                        {country_data.id ==
                                                        add.country_id
                                                          ? country_data.country_name +
                                                            ","
                                                          : ""}{" "}
                                                      </React.Fragment>
                                                    ),
                                                  )}
                                                  {add.postal_code}
                                                  {this.state.address_id ==
                                                  add.id ? (
                                                    <i
                                                      style={{
                                                        color: "green",
                                                        fontSize: "20px",
                                                      }}
                                                      className="fa fa-check"
                                                    ></i>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>{" "}
                                              </p>
                                            ) : (
                                              ""
                                            ),
                                        )}
                                      </Collapsible>
                                    </div>
                                  )}
                                </div>
                              ) : null}
                            </Col>
                          </Row>
                        </div>
                      ) : (
                        ""
                      ))}
                    {this.state.subscriber != 0 && this.state.sub_orderType ? (
                      <div
                        className="order_address_container"
                        style={{
                          padding: "0 20px",
                        }}
                      >
                        <Row>
                          <Col md={6}>
                            <h3
                              style={{
                                margin: "0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                              }}
                            >
                              Billing Address
                            </h3>
                          </Col>
                          <Col md={6} style={{ textAlign: "right" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: "12px",
                                flexWrap: "nowrap",
                              }}
                            >
                              <div
                                style={{
                                  marginBottom: 0,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <Checkbox
                                  number="57"
                                  checked={
                                    this.state.first_address ===
                                    this.state.first_billing_address
                                  }
                                  onClick={this.handleBillingSameToggle}
                                  label={
                                    <p
                                      style={{
                                        fontWeight: "bold",
                                        marginTop: "-1.5px",
                                      }}
                                    >
                                      &nbsp;&nbsp;Same as delivery address
                                    </p>
                                  }
                                />
                              </div>
                              <Button
                                style={{
                                  marginBottom: "17px",
                                  whiteSpace: "nowrap",
                                }}
                                fill
                                // onClick={this.addanother.bind(this)}
                                onClick={() =>
                                  this.setState({
                                    isCreateAddressModalOpen: true,
                                    addressModalType: "billing",
                                  })
                                }
                              >
                                Add Another Address
                                <i className="fa fa-plus"></i>
                              </Button>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            {this.state.addressline1Error && (
                              <small className="text-danger">
                                {this.state.addressline1Error}
                              </small>
                            )}

                            {this.state.addressdata.length ? (
                              <div
                                style={{
                                  padding: "20px 0",
                                }}
                              >
                                {this.state.addressdata.map((add, key) =>
                                  this.state.first_billing_address == add.id ? (
                                    <p key={key}>
                                      {" "}
                                      <div
                                        style={{
                                          borderColor: "#D3D3D3",
                                        }}
                                      >
                                        <input
                                          name="billingAddressRadio"
                                          value={add.id}
                                          checked={
                                            this.state.billing_address_id ==
                                            add.id
                                          }
                                          onChange={this.warningChangeAddress.bind(
                                            this,
                                            add.id,
                                            add.country_id,
                                            add.id,
                                            add.country_id,
                                            "billing",
                                          )}
                                          type="radio"
                                        />{" "}
                                        &nbsp;
                                        {add.address_line1},{add.address_line2}{" "}
                                        ,
                                        {this.state.city_info.map((city) => (
                                          <React.Fragment>
                                            {city.id == add.city
                                              ? city.city_name
                                              : ""}{" "}
                                          </React.Fragment>
                                        ))}{" "}
                                        ,
                                        {country_detail.map((country_data) => (
                                          <React.Fragment>
                                            {country_data.id == add.country_id
                                              ? country_data.country_name + ","
                                              : ""}{" "}
                                          </React.Fragment>
                                        ))}
                                        {add.postal_code}
                                        {this.state.billing_address_id ==
                                        add.id ? (
                                          <i
                                            style={{
                                              color: "green",
                                              fontSize: "20px",
                                            }}
                                            className="fa fa-check"
                                          ></i>
                                        ) : (
                                          ""
                                        )}
                                      </div>{" "}
                                    </p>
                                  ) : (
                                    ""
                                  ),
                                )}

                                {this.state.addressdata.length > 1 && (
                                  <div className="collapeable_addresses_list">
                                    <Collapsible
                                      trigger="View Other Addresses"
                                      transitionTime={200}
                                      onClosing={() => {
                                        this.setState({
                                          first_billing_address:
                                            this.state.billing_address_id,
                                        });
                                      }}
                                    >
                                      {this.state.addressdata.map((add, key) =>
                                        this.state.first_billing_address !=
                                        add.id ? (
                                          <p key={key}>
                                            {" "}
                                            <div
                                              style={{
                                                borderColor: "#D3D3D3",
                                              }}
                                            >
                                              <input
                                                name="billingAddressRadio"
                                                value={add.id}
                                                checked={
                                                  this.state
                                                    .billing_address_id ==
                                                  add.id
                                                }
                                                onChange={this.warningChangeAddress.bind(
                                                  this,
                                                  add.id,
                                                  add.country_id,
                                                  add.id,
                                                  add.country_id,
                                                  "billing",
                                                )}
                                                type="radio"
                                              ></input>{" "}
                                              {add.address_line1},
                                              {add.address_line2} ,
                                              {this.state.city_info.map(
                                                (city) => (
                                                  <React.Fragment>
                                                    {city.id == add.city
                                                      ? city.city_name
                                                      : ""}
                                                  </React.Fragment>
                                                ),
                                              )}{" "}
                                              ,
                                              {country_detail.map(
                                                (country_data) => (
                                                  <React.Fragment>
                                                    {country_data.id ==
                                                    add.country_id
                                                      ? country_data.country_name +
                                                        ","
                                                      : ""}{" "}
                                                  </React.Fragment>
                                                ),
                                              )}
                                              {add.postal_code}
                                              {this.state.billing_address_id ==
                                              add.id ? (
                                                <i
                                                  style={{
                                                    color: "green",
                                                    fontSize: "20px",
                                                  }}
                                                  className="fa fa-check"
                                                ></i>
                                              ) : (
                                                ""
                                              )}
                                            </div>{" "}
                                          </p>
                                        ) : (
                                          ""
                                        ),
                                      )}
                                    </Collapsible>
                                  </div>
                                )}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* {!!this.state.ClaimPolicyDetails ||
                  this.state.ClaimPolicyDetails !== "" ? (
                    <div
                      className="order_medicine_container"
                      style={{
                        padding: "0 20px",
                      }}
                    >
                      <Row>
                        <h3>Policy Details</h3>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <b>
                            <div
                              style={{ padding: "5px", fontWeight: "bold" }}
                              dangerouslySetInnerHTML={{
                                __html: this.state.ClaimPolicyDetails,
                              }}
                            ></div>
                          </b>
                        </Col>
                      </Row>
                      <Row>
                        {this.state.familyDetails.length > 0 && (
                          <h4 style={{ padding: "0px 0px 0px 10px" }}>
                            Family Details
                          </h4>
                        )}
                        {this.state.familyDetails.length > 0 &&
                          this.state.familyDetails &&
                          this.state.familyDetails.map((item) => (
                            <>
                              <div style={{ padding: "10px" }}>
                                <div
                                  style={{
                                    border: "2px solid",
                                    borderRadius: "8px",
                                    padding: "10px",
                                  }}
                                >
                                  <p style={{ fontWeight: "bold" }}>
                                    Name: {item.name}
                                  </p>
                                  <p style={{ fontWeight: "bold" }}>
                                    Relation: {item.relation}
                                  </p>
                                  <p style={{ fontWeight: "bold" }}>
                                    Mobile No: {item.phone}
                                  </p>
                                </div>
                              </div>
                            </>
                          ))}
                      </Row>
                    </div>
                  ) : (
                    ""
                  )} */}
                    {this.state.subscriber != 0 ? (
                      this.state.address_id != 0 || this.state.city_id != 0 ? (
                        <div
                          className="order_medicine_container"
                          style={{
                            padding: "0 20px",
                          }}
                        >
                          {this.state.trackIsChangedOrderItemValues.length >
                          0 ? (
                            <div
                              style={{
                                background: "#059212",
                                display: "flex",
                                border: "none",
                                padding: "5px",
                                margin: "0px -30px",
                              }}
                            >
                              <button
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "#059212",
                                  border: "#059212",
                                  color: "#fff",
                                  width: "100%",
                                  height: "30px",
                                }}
                              >
                                This order has been amended
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                          <Row>
                            <div
                              style={{
                                textAlign: "end",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <h3
                                  style={{
                                    margin: "0",
                                    letterSpacing: "0.5px",
                                    fontSize: "24px",
                                  }}
                                >
                                  Order Items
                                </h3>
                              </div>
                              <br />
                              {buttonText ? (
                                <Button
                                  onClick={this.viewCreditNote.bind(this)}
                                  style={{ color: "#2B3A41" }}
                                >
                                  {`${buttonText} Credit Note`}
                                </Button>
                              ) : null}
                              &nbsp; &nbsp;
                              {this.state.paymentOption &&
                                this.state.paymentOption !== "Mintpay" && (
                                  // (this.state.store == 1 ||
                                  //   this.state.store == null) &&
                                  <Button
                                    onClick={this.opendiscountmodal.bind(this)}
                                    style={{ color: "#2B3A41" }}
                                  >
                                    {" "}
                                    <i className="fa fa-plus"></i> Add
                                    Discount{" "}
                                  </Button>
                                )}
                            </div>
                            <div>
                              {this.state.sub_orderType == true && (
                                <Button
                                  style={{ padding: "6px 18px" }}
                                  onClick={() =>
                                    this.viewPdfDetails(
                                      this.props.match.params.id,
                                    )
                                  }
                                >
                                  Printable Invoice
                                </Button>
                              )}
                            </div>
                            <div className="order_items_header">
                              {/* <Button
                              style={{ color: "#2B3A41" }}
                              onClick={this.Add_New_Medication.bind(this)}
                            >
                              {" "}
                              <i className="fa fa-plus"></i> Add New Medicine
                            </Button>
                            &nbsp; */}
                              {(this.state.store == 1 ||
                                this.state.store === null) && (
                                <Col
                                  md={5}
                                  sm={6}
                                  style={{ display: "contents" }}
                                >
                                  <FormGroup
                                    style={{
                                      // flex: "3",
                                      textAlign: "end",
                                      marginTop: "27px",
                                      display: "flex",
                                    }}
                                  >
                                    <Checkbox
                                      number="46"
                                      checked={this.state.refillableOrder}
                                      onClick={(e) =>
                                        this.checkRefillableOrder(e)
                                      }
                                      label={
                                        <p
                                          style={{
                                            fontWeight: "bold",
                                            marginTop: "-1.5px",
                                          }}
                                        >
                                          Refillable order
                                        </p>
                                      }
                                    ></Checkbox>
                                  </FormGroup>
                                  <FormGroup
                                    style={{
                                      // flex: "3",
                                      textAlign: "end",
                                      marginTop: "27px",
                                      display: "flex",
                                    }}
                                  >
                                    <Checkbox
                                      number="47"
                                      disabled={
                                        this.state.status === 3 ||
                                        this.state.status === 8 ||
                                        this.state.status === 4 ||
                                        this.state.status === 11 ||
                                        this.state.isInsureme
                                      }
                                      checked={this.state.isPartialOrder}
                                      onClick={(e) =>
                                        this.handlePartialOrderOnChange(e)
                                      }
                                      label={
                                        <p
                                          style={{
                                            fontWeight: "bold",
                                            marginTop: "-1.5px",
                                          }}
                                        >
                                          Is Pending Item?
                                        </p>
                                      }
                                    ></Checkbox>
                                    {/* &nbsp; */}
                                  </FormGroup>
                                  <FormGroup
                                    style={{
                                      // flex: "3",
                                      textAlign: "end",
                                      marginTop: "27px",
                                      display: "flex",
                                    }}
                                  >
                                    <Checkbox
                                      number="50"
                                      checked={this.state.isAbusableOrder}
                                      onClick={(e) =>
                                        this.handleAbusableOrderOnChange(e)
                                      }
                                      label={
                                        <p
                                          style={{
                                            fontWeight: "bold",
                                            marginTop: "-1.5px",
                                          }}
                                        >
                                          Abusable Drug
                                        </p>
                                      }
                                    ></Checkbox>
                                  </FormGroup>
                                  {this.state
                                    .isPackageHasClaimMedicineAllowed &&
                                    isSuperAdmin && (
                                      <FormGroup
                                        style={{
                                          textAlign: "end",
                                          marginTop: "27px",
                                          display: "flex",
                                        }}
                                      >
                                        <Checkbox
                                          number="48"
                                          checked={this.state.isClaimableOrder}
                                          onClick={(e) =>
                                            this.handleMarkedAsClaimOrderOnChange(
                                              e,
                                            )
                                          }
                                          label={
                                            <p
                                              style={{
                                                fontWeight: "bold",
                                                marginTop: "-1.5px",
                                              }}
                                            >
                                              Claim order
                                            </p>
                                          }
                                          disabled={
                                            this.state.selectedFile.length ===
                                              0 &&
                                            this.state.priscriptionurl
                                              .length === 0
                                              ? true
                                              : false
                                          }
                                        ></Checkbox>
                                      </FormGroup>
                                    )}
                                </Col>
                              )}
                            </div>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <div className="table-responsive">
                                <table
                                  style={{
                                    borderCollapse: "separate",
                                    borderSpacing: "10px 0",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      {/* <th>&nbsp;</th> */}
                                      {/* {this.state.isClaimableOrder ? (
                                      <th>
                                        <input
                                          type="checkbox"
                                          onClick={(e) =>
                                            this.handleAllChecked(e)
                                          }
                                          checked={this.state.isAllChecked}
                                          value="checkedall"
                                        />
                                        Claim
                                      </th>
                                    ) : (
                                      <td>&nbsp;</td>
                                    )} */}
                                      <th style={{ paddingLeft: 0 }}>
                                        <ControlLabel>Sr.No </ControlLabel>
                                      </th>
                                      <th style={{ paddingLeft: 0 }}>
                                        <ControlLabel>Barcode</ControlLabel>
                                      </th>
                                      {/* <th>
                                      <ControlLabel>Item type</ControlLabel>
                                    </th> */}
                                      <th style={{ textAlign: "center" }}>
                                        <ControlLabel>Item Name </ControlLabel>
                                      </th>
                                      {/* <th>
                                      <ControlLabel>Unit Price </ControlLabel>
                                    </th> */}
                                      {/* <th>
                                      <ControlLabel>
                                        Available Quantity
                                      </ControlLabel>
                                    </th> */}
                                      <th style={{ textAlign: "center" }}>
                                        <ControlLabel>Unit Price </ControlLabel>
                                      </th>
                                      <th style={{ textAlign: "center" }}>
                                        <ControlLabel>Sale Price </ControlLabel>
                                      </th>
                                      <th style={{ textAlign: "center" }}>
                                        <ControlLabel>QTY</ControlLabel>
                                      </th>
                                      <th style={{ textAlign: "center" }}>
                                        <ControlLabel>Discount</ControlLabel>
                                      </th>
                                      <th style={{ textAlign: "center" }}>
                                        <ControlLabel>Total </ControlLabel>
                                      </th>
                                      {/* {this.state.inputList.length > 0 && this.state.inputList.some((data) => data.description !== "") && ( */}
                                      {/* <th>
                                      <ControlLabel>Upseller </ControlLabel>
                                    </th>
                                    <th>
                                      {/* <ControlLabel>Partial Order</ControlLabel> */}
                                      {/* <ControlLabel>Partial Order</ControlLabel>
                                    </th> */}
                                      {/* )} */}
                                      <th></th>
                                    </tr>
                                    <tr>
                                      <td colSpan={10}>
                                        <div
                                          style={{
                                            borderBottom: "1px solid #e3e3e3",
                                            margin: "10px 0",
                                          }}
                                        ></div>
                                      </td>
                                    </tr>
                                  </thead>

                                  {this.state.inputList.length > 0 ? (
                                    <tbody>
                                      {this.state.inputList.map((x, i) => {
                                        return (
                                          <>
                                            <tr
                                              style={{
                                                backgroundColor:
                                                  !!x.isRowSelected
                                                    ? "#D7FFDB"
                                                    : // : x.description &&
                                                      //   !x.isPartialOrderItem
                                                      // ? "#FABF9C"
                                                      "unset",
                                                cursor: "pointer",
                                                // padding: "12px 8px",
                                                verticalAlign: "top",
                                                borderColor: "#e3e3e3",
                                                // display: "flex",
                                                // marginBottom: "10px",
                                              }}
                                            >
                                              {/* <td>
                                            {x.description !== "" &&
                                            this.state.isClaimableOrder ? (
                                              <input
                                                key={x.description}
                                                onClick={(e) =>
                                                  this.handleCheckboxChange(
                                                    e.target.checked,
                                                    x.description
                                                  )
                                                }
                                                type="checkbox"
                                                value={x.description}
                                                checked={x.isChecked}
                                              />
                                            ) : (
                                              <td>&nbsp;</td>
                                            )}
                                          </td> */}
                                              <td
                                                style={{
                                                  width: "5%",
                                                  paddingLeft: 0,
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      paddingTop: "4px",
                                                    }}
                                                  >
                                                    <FormControl
                                                      style={{
                                                        margin: 0,
                                                      }}
                                                      name="srno"
                                                      disabled="disabled"
                                                      value={x.srno}
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i,
                                                        )
                                                      }
                                                      placeholder="1"
                                                      type="text"
                                                    />
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      flexDirection: "column",
                                                      marginTop: "5px",
                                                    }}
                                                  >
                                                    <input
                                                      key={x.isRowSelected}
                                                      onClick={(e) =>
                                                        this.isCheckedTracking(
                                                          i,
                                                        )
                                                      }
                                                      type="checkbox"
                                                      value={x.id}
                                                      checked={x.isRowSelected}
                                                      style={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                      }}
                                                    />
                                                    <div
                                                      style={{
                                                        marginTop: "5px",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Check
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  width: "5%",
                                                  paddingLeft: 0,
                                                }}
                                              >
                                                <div>
                                                  <ForwardedFormControl
                                                    type="text"
                                                    name="Barcode"
                                                    disabled={
                                                      x.isOldMedicine ||
                                                      this.state.status ===
                                                        12 ||
                                                      this.state.status ===
                                                        11 ||
                                                      this.state.status === 3 ||
                                                      this.state.status === 4 ||
                                                      this.state.status === 8 ||
                                                      this.state.status === 19
                                                    }
                                                    placeholder="Barcode"
                                                    style={{
                                                      backgroundColor:
                                                        "#ffffff",
                                                      border:
                                                        "1px solid #e3e3e3",
                                                      borderRadius: "4px",
                                                      color: "#565656",
                                                      padding: "4px 5px",
                                                      height: "40px",
                                                      boxShadow: "none",
                                                      width: "100%",
                                                      fontSize: "8px",
                                                    }}
                                                    onChange={(e) =>
                                                      this.handleBarcodeNoChange(
                                                        e,
                                                        x.id,
                                                        i,
                                                      )
                                                    }
                                                    // ref={(el) =>
                                                    //   setBarcodeRef(el, index)
                                                    // }
                                                    value={x.barcode}
                                                    ref={
                                                      i ===
                                                      this.state.inputList
                                                        .length -
                                                        1
                                                        ? this.barcodeInputRef
                                                        : null
                                                    }
                                                  />
                                                </div>
                                                <div
                                                  style={{
                                                    cursor: "pointer",
                                                    marginTop: 8,
                                                    width: "100%",
                                                  }}
                                                >
                                                  {/* want to show the location with  {x.location} */}
                                                  {x.location && (
                                                    <div
                                                      style={{
                                                        fontSize: "14px",
                                                        color: "#008000",
                                                        fontWeight: "bold",
                                                        paddingLeft: "6px",
                                                        textTransform:
                                                          "uppercase",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      {x.location}
                                                    </div>
                                                  )}
                                                </div>
                                              </td>

                                              <td
                                                style={{
                                                  width: "48%",
                                                }}
                                              >
                                                {/* <div
                                                  onKeyUp={(e) =>
                                                    this.inputOnChange(e, i)
                                                  }
                                                  // className="Appy"
                                                  style={{ paddingTop: "4px" }}
                                                > */}
                                                <AsyncSelect
                                                  isDisabled={
                                                    [
                                                      11, 12, 3, 4, 8, 19,
                                                    ].includes(
                                                      this.state.status,
                                                    ) ||
                                                    this.state
                                                      .disablePaymentOption
                                                  }
                                                  className="react-select primary"
                                                  classNamePrefix="react-select"
                                                  name="description"
                                                  value={
                                                    x.description === ""
                                                      ? ""
                                                      : x.selectmedication
                                                  }
                                                  // value={this.state.medicationItems[i] !== undefined ? this.state.medicationItems[i].find(obj => obj.value === x.description) : "unde"}
                                                  //  value={ x.description}
                                                  onChange={(value) =>
                                                    this.handleMedicineSelectChange(
                                                      value,
                                                      i,
                                                    )
                                                  }
                                                  ref={(ref) =>
                                                    this.setInputRef(ref, i)
                                                  }
                                                  loadOptions={
                                                    this.loadMedicationOptions
                                                  }
                                                  cacheOptions
                                                  defaultOptions={false}
                                                  placeholder="Medication"
                                                  noOptionsMessage={() =>
                                                    "Type Item Name or Code or Barcode"
                                                  }
                                                />
                                                {/* </div> */}

                                                {x.discount_used === 1 && (
                                                  <div>
                                                    <label>
                                                      <span
                                                        style={{
                                                          fontSize: "10px",
                                                          color: "#FF0000",
                                                        }}
                                                      >
                                                        {x.discount_used ===
                                                        null
                                                          ? ""
                                                          : x.discount_used ===
                                                              1
                                                            ? "*Discount Applied"
                                                            : ""}
                                                      </span>
                                                    </label>
                                                  </div>
                                                )}
                                                <div
                                                  style={{
                                                    cursor: "pointer",
                                                    marginTop: 8,
                                                    width: "100%",
                                                  }}
                                                >
                                                  <FormGroup>
                                                    <textarea
                                                      style={{
                                                        margin: 0,
                                                        width: "100%",
                                                        padding: "5px",
                                                        fontSize: "10px",
                                                        height: "35px",
                                                        border:
                                                          "1px solid #e3e3e3",
                                                        borderRadius: "4px",
                                                        color:
                                                          x.item_description
                                                            ? "#000000"
                                                            : "#aaaaaa",
                                                        resize: "none",
                                                        outline:
                                                          "1px solid #e3e3e3",
                                                      }}
                                                      disabled={
                                                        this.state.status ===
                                                          11 ||
                                                        this.state.status ===
                                                          12 ||
                                                        this.state.status ===
                                                          3 ||
                                                        this.state
                                                          .disablePaymentOption ||
                                                        this.state.status ===
                                                          4 ||
                                                        this.state.status ===
                                                          8 ||
                                                        this.state.status === 19
                                                      }
                                                      name="item_description"
                                                      onChange={(e) =>
                                                        this.handleInputDescriptionChange(
                                                          e,
                                                          i,
                                                          "item_description",
                                                        )
                                                      }
                                                      placeholder="Description"
                                                      type="text"
                                                      rows={4}
                                                      value={x.item_description}
                                                    ></textarea>
                                                  </FormGroup>
                                                  {/* <FormControl
                                                style={{ margin: 0 }}
                                                name="Discription"
                                                onChange={(e) =>
                                                  this.handleInputChange(e, i)
                                                }
                                                placeholder="Description"
                                                type="text"
                                                rows={5}
                                              /> */}
                                                </div>
                                              </td>
                                              {/* <td style={{ width: "10%" }}>
                                            <FormControl
                                              className="no-padding"
                                              name="unitprice"
                                              disabled="disabled"
                                              value={x.unitprice}
                                              onChange={(e) =>
                                                this.handleInputChange(e, i)
                                              }
                                              placeholder="0.00"
                                              type="number"
                                            />
                                          </td> */}
                                              {/* <td style={{ width: "8%" }}>
                                            <center>
                                              <b>
                                                {x.availableQuantity === null
                                                  ? "-"
                                                  : x.availableQuantity}
                                              </b>
                                            </center>
                                          </td> */}
                                              <td style={{ width: "17%" }}>
                                                <FormControl
                                                  className="no-padding"
                                                  name="selling_price"
                                                  disabled="disabled"
                                                  value={x.selling_price}
                                                  // onChange={(e) =>
                                                  //   this.handleInputChange(e, i)
                                                  // }
                                                  placeholder="0.00"
                                                  type="number"
                                                />
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  {this.state.store === 1 ||
                                                  this.state.store === null ? (
                                                    <>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                          fontWeight: "bold",
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        <input
                                                          key={
                                                            x.description + 1
                                                          }
                                                          onClick={(e) =>
                                                            this.handlePartialOrderCheckboxChange(
                                                              e,
                                                            )
                                                          }
                                                          type="checkbox"
                                                          value={x.id}
                                                          checked={
                                                            x.isPartialOrderItem
                                                          }
                                                          disabled={
                                                            // !this.state
                                                            //   .isPartialOrder ||
                                                            this.state
                                                              .status === 11 ||
                                                            this.state
                                                              .status === 12 ||
                                                            this.state
                                                              .status === 4 ||
                                                            this.state
                                                              .status === 3 ||
                                                            this.state
                                                              .status === 8 ||
                                                            this.state
                                                              .status === 19
                                                          }
                                                        />
                                                        <div
                                                          style={{
                                                            marginTop: "5px",
                                                          }}
                                                        >
                                                          {this.state
                                                            .sub_orderType
                                                            ? x.isPartialOrderItem
                                                              ? "Available"
                                                              : "Unavailable"
                                                            : "Available"}
                                                        </div>
                                                      </div>
                                                      &nbsp; &nbsp;
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                  &nbsp;&nbsp;&nbsp;&nbsp;
                                                  {this.state.sub_orderType ==
                                                    true &&
                                                    x.isPartialOrderItem && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                          fontWeight: "bold",
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        <input
                                                          key={
                                                            x.description + 1
                                                          }
                                                          onClick={(e) =>
                                                            this.handleis_printableOnChange(
                                                              e,
                                                            )
                                                          }
                                                          value={x.id}
                                                          type="checkbox"
                                                          checked={
                                                            x.is_printable
                                                          }
                                                        />
                                                        <div
                                                          style={{
                                                            marginTop: "5px",
                                                          }}
                                                        >
                                                          Printable
                                                        </div>
                                                      </div>
                                                    )}
                                                </div>

                                                {/* <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  flexDirection: "column",
                                                  // marginTop: "25px",
                                                }}
                                              >
                                                <input
                                                  key={x.description + 1}
                                                  onClick={(e) =>
                                                    this.handleUpsellerCheckboxChange(
                                                      e
                                                    )
                                                  }
                                                  type="checkbox"
                                                  value={x.id}
                                                  checked={x.isUpSeller}
                                                />
                                                <div
                                                  style={{
                                                    marginTop: "5px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Upseller
                                                </div>
                                              </div> */}
                                              </td>

                                              <td style={{ width: "17%" }}>
                                                <FormControl
                                                  className="no-padding"
                                                  name="unitprice"
                                                  onWheel={(e) =>
                                                    e.target.blur()
                                                  }
                                                  disabled={
                                                    this.state.status === 11 ||
                                                    this.state.status === 12 ||
                                                    this.state.status === 3 ||
                                                    this.state
                                                      .disablePaymentOption ||
                                                    this.state.status === 4 ||
                                                    this.state.status === 8 ||
                                                    this.state.status === 19
                                                  }
                                                  // disabled="disabled"
                                                  value={x.unitprice}
                                                  onChange={(e) =>
                                                    this.handleInputChange(
                                                      e,
                                                      i,
                                                      "unitprice",
                                                    )
                                                  }
                                                  placeholder="0.00"
                                                  type="number"
                                                />

                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    // marginTop: "25px",
                                                  }}
                                                >
                                                  {x.description !== "" &&
                                                  (this.state
                                                    .isClaimableOrder ||
                                                    this.state.isInsureme) ? (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      <input
                                                        key={x.description}
                                                        disabled={
                                                          this.state.status ===
                                                            11 ||
                                                          this.state.status ===
                                                            12 ||
                                                          this.state.status ===
                                                            4 ||
                                                          this.state.status ===
                                                            8 ||
                                                          this.state
                                                            .disablePaymentOption ||
                                                          this.state.status ===
                                                            3 ||
                                                          this.state.status ===
                                                            19
                                                        }
                                                        onClick={(e) =>
                                                          this.handleCheckboxChange(
                                                            e.target.checked,
                                                            x.id,
                                                          )
                                                        }
                                                        type="checkbox"
                                                        value={x.id}
                                                        checked={x.isChecked}
                                                      />
                                                      <div
                                                        style={{
                                                          marginTop: "5px",
                                                        }}
                                                      >
                                                        Claimable
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    <td>&nbsp;</td>
                                                  )}
                                                </div>
                                              </td>
                                              <td style={{ width: "10%" }}>
                                                <FormControl
                                                  className="no-padding qty_imput"
                                                  name="quantity"
                                                  disabled={
                                                    this.state.status === 11 ||
                                                    this.state.status === 12 ||
                                                    this.state.status === 3 ||
                                                    this.state
                                                      .disablePaymentOption ||
                                                    this.state.status === 4 ||
                                                    this.state.status === 8 ||
                                                    this.state.status === 19
                                                  }
                                                  min={1}
                                                  value={x.quantity}
                                                  onWheel={(e) =>
                                                    e.target.blur()
                                                  }
                                                  onChange={(e) =>
                                                    this.handleInputChange(
                                                      e,
                                                      i,
                                                      "quantity",
                                                    )
                                                  }
                                                  placeholder="0"
                                                  type="number"
                                                  style={{
                                                    width: "100%",
                                                    border:
                                                      this.state
                                                        .isOverQuantity === i &&
                                                      "2px solid #fb404b",
                                                    textAlign: "center",
                                                  }}
                                                />
                                                {/* {" "}
                                            /{" "} */}
                                                {/* {x.quantity_type === 1
                                              ? x.quantity_per_box
                                              : "-"} */}
                                                {/* <div
                                                style={{
                                                  position: "absolute",
                                                  color: "#fb404b",
                                                  fontSize: 11.9,
                                                  marginTop: 5,
                                                  justifyContent: "center",
                                                }}
                                              >
                                                {this.state.isWrongQuantity &&
                                                this.state.wrongFieldId === i
                                                  ? "Wrong Quantity"
                                                  : null}
                                              </div> */}
                                                <div
                                                  style={{
                                                    display: "ruby",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    marginTop: "5px",
                                                  }}
                                                >
                                                  {/* {x.availableQuantity && ( */}
                                                  <div
                                                    style={{
                                                      fontSize: "12px",
                                                      color: "#008000",
                                                      fontWeight: "bold",
                                                      paddingLeft: "6px",
                                                    }}
                                                  >
                                                    Stock:{" "}
                                                    <div>
                                                      {Number(
                                                        x.availableQuantity,
                                                      )}
                                                    </div>
                                                  </div>
                                                  {/* )} */}

                                                  {/* {x.actualAllocated > 0 && ( */}
                                                  <div
                                                    style={{
                                                      fontWeight: "bold",
                                                      color: "red",
                                                      paddingLeft: "6px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {/* {x.availableQuantity && ( */}
                                                    {(this.state.store === 1 ||
                                                      this.state.store ===
                                                        null) && (
                                                      <div
                                                        style={{
                                                          fontSize: "12px",
                                                          color: "#ff8a26",
                                                          fontWeight: "bold",
                                                          borderTop:
                                                            "1px #ccc dashed",
                                                          paddingTop: "3px",
                                                        }}
                                                        onClick={() =>
                                                          this.handleShowAllocatedMedicineModal(
                                                            x.selectmedication
                                                              .value,
                                                          )
                                                        }
                                                      >
                                                        Allocated:
                                                        <div>
                                                          <div></div>
                                                          <div>
                                                            {Number(
                                                              x.total_allocated,
                                                            ) || 0}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                    {/* )} */}
                                                  </div>
                                                  {/* )} */}
                                                </div>

                                                {/* <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  // marginTop: "2px",
                                                }}
                                              >
                                                {x.description !== "" &&
                                                this.state.isClaimableOrder ? (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                    }}
                                                  >
                                                    <input
                                                      key={x.description}
                                                      onClick={(e) =>
                                                        this.handleCheckboxChange(
                                                          e.target.checked,
                                                          x.description
                                                        )
                                                      }
                                                      type="checkbox"
                                                      value={x.description}
                                                      checked={x.isChecked}
                                                    />
                                                    Claimable
                                                  </div>
                                                ) : (
                                                  <td>&nbsp;</td>
                                                )}
                                              </div> */}
                                              </td>

                                              <td style={{ width: "5%" }}>
                                                <div>
                                                  {x.margin_discount_sub_type ==
                                                  2 ? (
                                                    <FormControl
                                                      className="no-padding"
                                                      name="newmargin"
                                                      value={x.newmargin}
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i,
                                                        )
                                                      }
                                                      disabled={
                                                        this.state.status ===
                                                          11 ||
                                                        this.state.status ===
                                                          12 ||
                                                        this.state.status ===
                                                          4 ||
                                                        this.state.status ===
                                                          8 ||
                                                        this.state
                                                          .paymentOption ===
                                                          "Mintpay" ||
                                                        this.state
                                                          .disablePaymentOption ||
                                                        this.state.status ===
                                                          3 ||
                                                        this.state.status === 19
                                                      }
                                                      placeholder="0.00"
                                                      type="number"
                                                    />
                                                  ) : (
                                                    <FormControl
                                                      className="no-padding"
                                                      name="margin_discount_percentage"
                                                      value={
                                                        x.margin_discount_percentage
                                                      }
                                                      onChange={(e) =>
                                                        this.handleInputChange(
                                                          e,
                                                          i,
                                                        )
                                                      }
                                                      disabled={
                                                        this.state
                                                          .disablePaymentOption ||
                                                        this.state.status ===
                                                          11 ||
                                                        this.state.status ===
                                                          12 ||
                                                        this.state.status ===
                                                          4 ||
                                                        this.state.status ===
                                                          3 ||
                                                        this.state.status ===
                                                          8 ||
                                                        this.state.status === 19
                                                      }
                                                      placeholder="0.00"
                                                      type="number"
                                                      // disabled
                                                    />
                                                  )}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      flexDirection: "column",
                                                      // marginTop: "25px",
                                                    }}
                                                  >
                                                    <input
                                                      key={x.description + 1}
                                                      onClick={(e) =>
                                                        this.handleUpsellerCheckboxChange(
                                                          e,
                                                        )
                                                      }
                                                      type="checkbox"
                                                      value={x.id}
                                                      checked={x.isUpSeller}
                                                    />
                                                    <div
                                                      style={{
                                                        marginTop: "5px",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      Upseller
                                                    </div>
                                                  </div>
                                                  {/* <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    marginTop: "25px",
                                                  }}
                                                >
                                                  {x.description !== "" &&
                                                  this.state
                                                    .isClaimableOrder ? (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                      }}
                                                    >
                                                      <input
                                                        key={x.description}
                                                        onClick={(e) =>
                                                          this.handleCheckboxChange(
                                                            e.target.checked,
                                                            x.description
                                                          )
                                                        }
                                                        type="checkbox"
                                                        value={x.description}
                                                        checked={x.isChecked}
                                                      />
                                                      Claimable
                                                    </div>
                                                  ) : (
                                                    <td>&nbsp;</td>
                                                  )}
                                                </div> */}
                                                </div>
                                              </td>
                                              <td style={{ width: "5%" }}>
                                                <FormControl
                                                  className="no-padding"
                                                  name="subtotal"
                                                  disabled="disabled"
                                                  value={x.subtotal}
                                                  onChange={(e) =>
                                                    this.handleInputChange(e, i)
                                                  }
                                                  placeholder="0.00"
                                                  type="number"
                                                  style={{ width: "95px" }}
                                                />
                                                {(Number(
                                                  this.state.StoreManager,
                                                ) === 1 ||
                                                  Number(
                                                    this.state.StoreManager,
                                                  ) === 13) &&
                                                  !x.isPartialOrderItem && (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        value={x.id}
                                                        checked={
                                                          x.is_order_placed
                                                        }
                                                        onClick={(e) =>
                                                          this.handleItemOrderedCheckboxChange(
                                                            e,
                                                          )
                                                        }
                                                      />
                                                      <div
                                                        style={{
                                                          marginTop: "5px",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        Item Ordered
                                                      </div>
                                                    </div>
                                                  )}
                                                {/* <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  // marginTop: "25px",
                                                }}
                                              >
                                                {x.description !== "" &&
                                                this.state.isClaimableOrder ? (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    <input
                                                      key={x.description}
                                                      onClick={(e) =>
                                                        this.handleCheckboxChange(
                                                          e.target.checked,
                                                          x.id
                                                        )
                                                      }
                                                      type="checkbox"
                                                      value={x.id}
                                                      checked={x.isChecked}
                                                    />
                                                    Claimable
                                                  </div>
                                                ) : (
                                                  <td>&nbsp;</td>
                                                )}
                                              </div> */}
                                              </td>

                                              {/* {x.description !== "" && ( */}
                                              {/* <td align="center">
                                            <input
                                              key={x.description + 1}
                                              onClick={(e) =>
                                                this.handleUpsellerCheckboxChange(
                                                  e
                                                )
                                              }
                                              type="checkbox"
                                              value={x.description}
                                              checked={x.isUpSeller}
                                            />
                                          </td>
                                          <td align="center">
                                            <input
                                              key={x.description + 1}
                                              onClick={(e) =>
                                                this.handlePartialOrderCheckboxChange(
                                                  e
                                                )
                                              }
                                              type="checkbox"
                                              value={x.description}
                                              checked={x.isPartialOrder}
                                            />
                                          </td> */}
                                              {/* )} */}
                                              <td style={{ width: "5%" }}></td>
                                              <td
                                                style={{
                                                  paddingTop: "14px",
                                                }}
                                              >
                                                {!this.state
                                                  .disableRemoveOrderItem &&
                                                !this.state
                                                  .disablePaymentOption ? (
                                                  <a
                                                    href="javascript:void(0)"
                                                    onClick={(e) =>
                                                      this.handleRemoveClick(
                                                        i,
                                                        x.orderItemNumber,
                                                      )
                                                    }
                                                    disabled={
                                                      this.state
                                                        .disablePaymentOption
                                                    }
                                                  >
                                                    X
                                                  </a>
                                                ) : (
                                                  <span
                                                    style={{
                                                      color: "gray",
                                                      cursor: "not-allowed",
                                                    }}
                                                  >
                                                    X
                                                  </span>
                                                )}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colSpan={10}>
                                                <div
                                                  style={{
                                                    borderBottom:
                                                      "1px solid #e3e3e3",
                                                    margin: "10px 0",
                                                  }}
                                                ></div>
                                              </td>
                                            </tr>
                                          </>
                                        );
                                      })}
                                    </tbody>
                                  ) : (
                                    <tbody>
                                      <tr>
                                        <td
                                          colSpan={9}
                                          style={{
                                            textAlign: "center",
                                            padding: "40px",
                                          }}
                                        >
                                          {" "}
                                          No Medicine Added
                                        </td>
                                      </tr>
                                    </tbody>
                                  )}
                                </table>
                                {this.state.medicationaddError}
                              </div>
                            </Col>
                          </Row>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                            }}
                          >
                            {/* <Button
                              className="AddMedicine_Btn"
                              onClick={this.handleAddClick}
                              disabled={this.state.disablePaymentOption}
                            >
                              {" "}
                              <i className="fa fa-plus"></i> Add Medicine
                            </Button> */}
                            <Button
                              className="AddMedicine_Btn"
                              disabled={
                                this.state.status === 11 ||
                                this.state.status === 12 ||
                                this.state.status === 3 ||
                                this.state.status === 4 ||
                                this.state.status === 8 ||
                                this.state.status === 19 ||
                                this.state.sub_orderType == 4
                              }
                              onClick={() => this.handleAddMultipleClick(5)}
                            >
                              <i className="fa fa-plus"></i> Add Medicine
                            </Button>
                            &nbsp;&nbsp;
                          </div>
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    <React.Fragment>
                      {this.state.subscriber != 0 ? (
                        this.state.address_id != 0 ||
                        this.state.city_id != 0 ? (
                          <Row>
                            <Modal
                              show={this.state.showmediactonModal}
                              onHide={() =>
                                this.setState({ showmediactonModal: false })
                              }
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>Medication Details</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <input
                                  style={{
                                    width: "0px",
                                    height: "0px",
                                    border: "none",
                                  }}
                                  type="text"
                                  ref={this.medication_item_code_error}
                                />
                                {medicationerrormessage.length != 0 && (
                                  <div className=" alert alert-danger">
                                    {medicationerrormessage.map((data) => (
                                      <React.Fragment>
                                        <li>{data}</li>
                                      </React.Fragment>
                                    ))}
                                  </div>
                                )}
                                <FormGroup>
                                  <Checkbox
                                    number="49"
                                    checked={this.state.is_flash_medicine}
                                    onChange={(e) => this.isFalshMedicine(e)}
                                    label="Is Flash Medicine / Product?"
                                  ></Checkbox>
                                </FormGroup>
                                {this.state.is_flash_medicine && (
                                  <FormGroup>
                                    <ControlLabel>Supplier</ControlLabel>
                                    <select
                                      className="react-select primary form-control"
                                      name="supplier"
                                      value={this.state.supplier}
                                      onChange={(event) => {
                                        this.setState({
                                          supplier: event.target.value,
                                        });
                                      }}
                                    >
                                      <option value="0">Select Supplier</option>
                                      {this.state.suppliersData.map((cus) => (
                                        <option value={cus.id}>
                                          {cus.name}
                                        </option>
                                      ))}
                                    </select>
                                  </FormGroup>
                                )}

                                <FormGroup>
                                  <ControlLabel>Item Code</ControlLabel>
                                  <FormControl
                                    name="medicationitemcode"
                                    value={this.state.medicationitemcode}
                                    disabled={this.state.codeDisabled}
                                    onChange={(event) => {
                                      this.setState({
                                        medicationitemcode: event.target.value,
                                      });
                                      ((this.state.is_flash_medicine === 0) &
                                        event.target.value) ===
                                      ""
                                        ? this.setState({
                                            medicationitemcodeError: (
                                              <small className="text-danger">
                                                ItemCode is required.
                                              </small>
                                            ),
                                          })
                                        : this.setState({
                                            medicationitemcodeError: null,
                                          });
                                    }}
                                    placeholder="Enter ItemCode"
                                  />
                                  {this.state.medicationitemcodeError}
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Item Name</ControlLabel>
                                  <FormControl
                                    name="medicationitemname"
                                    value={this.state.medicationitemname}
                                    type="text"
                                    placeholder="Enter Item Name"
                                    onChange={this.medicationChange}
                                  ></FormControl>
                                  {this.state.medicationitemnameError}
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Unit Price</ControlLabel>
                                  <FormControl
                                    name="medicationunitprice"
                                    value={this.state.medicationunitprice}
                                    type="number"
                                    placeholder="Enter UnitPrice"
                                    onChange={this.medicationChange}
                                  ></FormControl>
                                  {this.state.medicationunitpriceError}
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>
                                    Medication Category
                                  </ControlLabel>
                                  <select
                                    name="medicationcategory"
                                    onChange={this.medicationChange}
                                    value={this.state.medicationcategory}
                                    className="form-control"
                                  >
                                    <option value="0">
                                      Select Medication Category
                                    </option>
                                    {this.state.category_detail.map(
                                      (mcatdata) => (
                                        <option value={mcatdata.id}>
                                          {mcatdata.category_name}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                  {this.state.medicationcategoryError}
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Country</ControlLabel>
                                  <select
                                    className=" primary form-control"
                                    name="medicationcity"
                                    value={this.state.medicationcity}
                                    onChange={this.medicationChange}
                                  >
                                    <option value="0">Select Country</option>
                                    {this.state.country_detail.map((cus) => (
                                      <option value={cus.id}>
                                        {cus.country_name}
                                      </option>
                                    ))}
                                  </select>
                                  {this.state.medicationcityError}
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Quantity</ControlLabel>
                                  <FormControl
                                    name="quantity"
                                    value={this.state.quantity}
                                    onChange={(event) => {
                                      this.setState({
                                        quantity: event.target.value,
                                      });
                                    }}
                                    placeholder="Enter quantity"
                                    type="number"
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Display Discount</ControlLabel>
                                  <FormControl
                                    name="display_discount"
                                    value={this.state.display_discount}
                                    placeholder="Enter Display Discount"
                                    onChange={(event) => {
                                      this.setState({
                                        display_discount: event.target.value,
                                      });
                                    }}
                                    type="number"
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Search Tags</ControlLabel>
                                  <TagsInput
                                    value={this.state.tags}
                                    onChange={(e) => this.handleChange(e)}
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Barcode</ControlLabel>
                                  <FormControl
                                    name="barcode"
                                    value={this.state.barcode}
                                    onChange={(event) => {
                                      this.setState({
                                        barcode: event.target.value,
                                      });
                                    }}
                                    placeholder="Enter Barcode"
                                    type="text"
                                  />
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Description</ControlLabel>
                                  <textarea
                                    className="form-control"
                                    name="medicationdescription"
                                    value={this.state.medicationdescription}
                                    cols={3}
                                    rows={2}
                                    placeholder="Enter Description"
                                    onChange={this.medicationChange}
                                  ></textarea>
                                  {this.state.medicationdescriptionError}
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Images</ControlLabel>
                                  <br></br>
                                  <input
                                    style={{ display: "none" }}
                                    id="selectImage"
                                    type="file"
                                    className="form-control"
                                    name="package_image"
                                    multiple
                                    onChange={this.handleFileChange}
                                  />
                                  <Button
                                    onClick={this.upload}
                                    style={{ color: "#2B3A41" }}
                                  >
                                    {" "}
                                    <i
                                      className={
                                        this.state.package_image == ""
                                          ? "fa fa-plus"
                                          : "fa fa-pencil fa-fw"
                                      }
                                    ></i>{" "}
                                    {this.state.package_image == ""
                                      ? "Choose File"
                                      : "Change File"}
                                  </Button>
                                </FormGroup>
                                <FormGroup>
                                  <Table>
                                    <tr>
                                      {this.state.package_image_data.map(
                                        (pid, i) => (
                                          <>
                                            <td style={{ width: "30px" }}>
                                              <Radio
                                                style={{
                                                  display: "inline-block",
                                                }}
                                                number={"5" + i}
                                                option={pid}
                                                name="primaryimage"
                                                onChange={this.onChange}
                                                //  checked={this.state.eligibility === "1"}
                                                //  label="Web"
                                              />
                                            </td>
                                            <td>
                                              <a href={pid} target="_blank">
                                                <img
                                                  src={pid}
                                                  style={{
                                                    height: "30px",
                                                    width: "30px",
                                                  }}
                                                ></img>
                                              </a>
                                            </td>
                                          </>
                                        ),
                                      )}
                                    </tr>
                                  </Table>

                                  {this.state.packageImageError}
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Add Commision 10%</ControlLabel>
                                  <Radio
                                    // style={{'display':'inline-block'}}
                                    number="10"
                                    option="1"
                                    name="medicationaddcommision"
                                    onChange={this.medicationChange}
                                    checked={
                                      this.state.medicationaddcommision === "1"
                                    }
                                    label="Yes"
                                  />
                                  <Radio
                                    // style={{'display':'inline-block'}}
                                    number="11"
                                    option="2"
                                    name="medicationaddcommision"
                                    onChange={this.medicationChange}
                                    checked={
                                      this.state.medicationaddcommision === "2"
                                    }
                                    label="No"
                                  />
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>
                                    Is Featured ? &nbsp;
                                  </ControlLabel>
                                  <Radio
                                    // style={{'display':'inline-block'}}
                                    number="12"
                                    option="1"
                                    name="medicationis_featured"
                                    onChange={this.medicationChange}
                                    checked={
                                      this.state.medicationis_featured === "1"
                                    }
                                    label="Yes"
                                  />
                                  <Radio
                                    // style={{'display':'inline-block'}}
                                    number="13"
                                    option="2"
                                    name="medicationis_featured"
                                    onChange={this.medicationChange}
                                    checked={
                                      this.state.medicationis_featured === "2"
                                    }
                                    label="No"
                                  />
                                </FormGroup>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  bsStyle="info"
                                  fill
                                  onClick={this.add_new_medication_category.bind(
                                    this,
                                  )}
                                >
                                  Submit
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </Row>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                    <br />
                    {(this.state.isClaimableOrder || this.state.isInsureme) && (
                      <div className="order_address_container">
                        <Row>
                          <Col md={6} sm={6} style={{}}>
                            <FormGroup>
                              <p>
                                &nbsp;&nbsp;
                                <b
                                  style={{
                                    margin: "0",
                                    letterSpacing: "0.5px",
                                    fontSize: "24px",
                                  }}
                                >
                                  Prescriptions Validations{" "}
                                </b>
                              </p>
                            </FormGroup>
                          </Col>

                          {(this.state.isClaimableOrder ||
                            this.state.isInsureme) && (
                            <>
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        width: "20%",
                                        padding: "0px 20px",
                                      }}
                                    >
                                      {" "}
                                      <Checkbox
                                        number="199"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Name Available
                                          </span>
                                        }
                                        name="nameAvailable"
                                        checked={
                                          this.state.insuremeValidation
                                            .nameAvailable
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .nameAvailableError
                                      }
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      <Checkbox
                                        number="200"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Medicine Cover
                                          </span>
                                        }
                                        name="medicationCover"
                                        checked={
                                          this.state.insuremeValidation
                                            .medicationCover
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .medicationCoverError
                                      }
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      {" "}
                                      <Checkbox
                                        number="201"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Validity Period
                                          </span>
                                        }
                                        name="validityPeriod"
                                        checked={
                                          this.state.insuremeValidation
                                            .validityPeriod
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .validityPeriodError
                                      }
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      <Checkbox
                                        number="202"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Claim Holder Name
                                          </span>
                                        }
                                        name="claimHolderName"
                                        checked={
                                          this.state.insuremeValidation
                                            .claimHolderName
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .claimHolderNameError
                                      }
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      {" "}
                                      <Checkbox
                                        number="203"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Doctor Seal
                                          </span>
                                        }
                                        name="doctorSeal"
                                        checked={
                                          this.state.insuremeValidation
                                            .doctorSeal
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .doctorSealError
                                      }
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <br />
                              <table style={{ width: "100%" }}>
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        width: "20%",
                                        padding: "0px 20px",
                                      }}
                                    >
                                      <Checkbox
                                        number="207"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Check price
                                          </span>
                                        }
                                        name="checkPrice"
                                        checked={
                                          this.state.insuremeValidation
                                            .checkPrice
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .checkPriceError
                                      }
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      {" "}
                                      <Checkbox
                                        number="208"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Check Quantity
                                          </span>
                                        }
                                        name="checkQuantity"
                                        checked={
                                          this.state.insuremeValidation
                                            .checkQuantity
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .checkQuantityError
                                      }
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      {" "}
                                      <Checkbox
                                        number="205"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Signature Available
                                          </span>
                                        }
                                        name="signatureAvailable"
                                        checked={
                                          this.state.insuremeValidation
                                            .signatureAvailable
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .signatureAvailableError
                                      }
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      <Checkbox
                                        number="206"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Date Available
                                          </span>
                                        }
                                        name="dateAvailable"
                                        checked={
                                          this.state.insuremeValidation
                                            .dateAvailable
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                      {
                                        this.state.insuremeValidationErrors
                                          .dateAvailableError
                                      }
                                    </td>
                                    <td style={{ width: "20%" }}>
                                      {" "}
                                      <Checkbox
                                        number="204"
                                        label={
                                          <span
                                            style={{
                                              fontSize: "1.5rem",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Family Claim
                                          </span>
                                        }
                                        name="familyClaim"
                                        checked={
                                          this.state.insuremeValidation
                                            .familyClaim
                                        }
                                        onChange={(e) =>
                                          this.handleInsuremeValidationOnChange(
                                            e,
                                          )
                                        }
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <table>
                                <br />
                              </table>
                            </>
                          )}
                        </Row>
                      </div>
                    )}

                    <div
                      className="order_middle_container"
                      style={{
                        position: "relative",
                        minHeight: "1px",
                        padding: "0 20px 20px 20px",
                      }}
                    >
                      {/* {(this.state.store === 1 ||
                        this.state.store === null) && ( */}
                      <Row>
                        <Col md={3} sm={3}>
                          <FormGroup className="order_source_data ">
                            {" "}
                            <ControlLabel>Delivery Type</ControlLabel>
                            <Select
                              isDisabled={this.state.package_delivery_discount}
                              className="react-select primary"
                              classNamePrefix="react-select"
                              placeholder="Delivery Type"
                              name="deliverytype"
                              value={this.state.deliverytype || null}
                              onChange={(value) =>
                                this.handleDeliveryTypeOnChange(value)
                              }
                              // options={this.state.deliveryTypeOptions}
                              options={
                                this.state.sub_orderType
                                  ? this.state.deliveryTypeOptions
                                  : this.state.deliveryTypeOptionsB2C
                              }
                            />
                          </FormGroup>
                        </Col>

                        {this.state.deliverytype.value == 1 ? (
                          <Col md={3} sm={3}>
                            <FormGroup className="fl_datepicker">
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <ControlLabel>Delivery Within</ControlLabel>
                                <FormControl
                                  style={{ margin: 0 }}
                                  value={`${this.state.datarange.start.format(
                                    "YYYY-MM-DD",
                                  )} - ${this.state.datarange.end.format(
                                    "YYYY-MM-DD",
                                  )}`}
                                  onClick={this.onToggle.bind(this)}
                                  placeholder="Date Range"
                                  type="text"
                                />

                                {this.state.isdatepickeron && (
                                  <DateRangePicker
                                    value={this.state.datarange}
                                    onSelect={this.onSelect}
                                    singleDateRange={true}
                                  />
                                )}
                              </div>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}

                        <Col md={3} sm={3}>
                          <ControlLabel>Payment Option</ControlLabel>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            placeholder="Payment Option"
                            name="paymentoption"
                            value={this.state.paymentoption}
                            isDisabled={this.state.disablePaymentOption}
                            onChange={(value) =>
                              this.handlePaymentOptionChange(value)
                            }
                            options={[
                              { value: "Cash", label: "Cash" },
                              // { value: "Card", label: "Card" },
                              { value: "Cheque", label: "Cheque" },
                              {
                                value: "Bank Transfer",
                                label: "Bank Transfer",
                              },
                              { value: "Hybrid", label: "Hybrid" },
                              { value: "ComBank", label: "ComBank" },
                              {
                                value: "Swap Machine",
                                label: "Swap Machine",
                              },
                              // { value: "InsureMe", label: "InsureMe" },
                            ]}
                          />
                          {this.state.paymentoptionError}
                        </Col>

                        <Col md={3} sm={3}>
                          <FormGroup className="fl_datepicker">
                            <div className="payment_duePicker">
                              <ControlLabel> Payment Due Date</ControlLabel>
                              <Datetime
                                timeFormat={false}
                                dateFormat="YYYY-MM-DD"
                                inputProps={{
                                  placeholder: "Payment Due Date",
                                }}
                                defaultValue={new Date()}
                                closeOnSelect={true}
                                value={this.state.paymentduedate}
                                onChange={this.handlePaymentDueDate}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      {/* )} */}
                      <Row>
                        {this.state.store === 1 || this.state.store === null ? (
                          <Col md={3} sm={3} style={{ position: "relative" }}>
                            <ControlLabel>Health Condition</ControlLabel>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="Health Condition"
                              name="healthcondition"
                              closeMenuOnSelect={false}
                              isMulti
                              value={this.state.healthcondition}
                              onChange={(value) =>
                                this.setState({
                                  healthcondition: value,
                                })
                              }
                              options={this.state.healthconditionItems}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.dynamicfinalpercentage != 0 ? (
                          <Col md={3} sm={3}>
                            <FormGroup>
                              {
                                <p
                                  style={{
                                    marginTop: "32px",
                                    fontSize: "14px",
                                  }}
                                >
                                  {" "}
                                  Added Discount :{" "}
                                  {this.state.dynamicfinalpercentage} %
                                </p>
                              }
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.store === 1 || this.state.store === null ? (
                          <Col md={6} sm={6} style={{ padding: "23px 14px" }}>
                            <FormGroup>
                              <Checkbox
                                number="45"
                                checked={this.state.quotenotification}
                                onChange={this.checkpatient}
                                label="Request Quote Notification"
                              ></Checkbox>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                      </Row>
                      {this.state.store === 1 || this.state.store === null ? (
                        <Row>
                          <Col
                            md={12}
                            sm={12}
                            style={{ marginLeft: "1px", width: "91%" }}
                          >
                            <Checkbox
                              number="56"
                              checked={this.state.is_currier}
                              onChange={(e) => this.isCurrier(e)}
                              label="Is Courier ?"
                            ></Checkbox>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                      <Row>
                        {(this.state.store === 1 ||
                          this.state.store === null) && (
                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "yes"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup className="fl_datepicker">
                              <div style={{ bottom: "5px" }}>
                                <ControlLabel>Rider : </ControlLabel>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  placeholder="Rider"
                                  name="rider_id"
                                  value={this.state.rider_id}
                                  onChange={(value) =>
                                    this.setState({
                                      rider_id: value,
                                    })
                                  }
                                  options={this.state.rider_data}
                                />
                                {/* {this.state.rider_idError} */}
                              </div>
                            </FormGroup>
                          </Col>
                        )}
                        {this.state.store === 1 || this.state.store === null ? (
                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "no"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup className="fl_datepicker">
                              <div style={{ bottom: "5px" }}>
                                <ControlLabel>Courier Partner : </ControlLabel>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  placeholder="Courier Partner"
                                  name="currier_id"
                                  value={this.state.currier_id}
                                  onChange={(value) =>
                                    this.setState({
                                      currier_id: value,
                                    })
                                  }
                                  options={this.currier_details}
                                />
                              </div>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.store === 1 || this.state.store === null ? (
                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "no"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup>
                              <ControlLabel>Tracking Id</ControlLabel>
                              <FormControl
                                type="text"
                                name="tracking_id"
                                value={this.state.tracking_id}
                                onChange={this.onChange}
                                placeholder="Enter tracking id"
                              ></FormControl>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.store === 1 || this.state.store === null ? (
                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "no"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup>
                              <ControlLabel>Tracking Url</ControlLabel>
                              <FormControl
                                type="text"
                                name="tracking_url"
                                value={this.state.tracking_url}
                                onChange={this.onChange}
                                placeholder="Enter tracking url"
                              ></FormControl>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {this.state.store === 1 || this.state.store === null ? (
                          <Col
                            md={3}
                            sm={3}
                            style={{
                              display:
                                this.state.currier_disabled == "no"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup>
                              <ControlLabel>Tracking Note</ControlLabel>
                              <FormControl
                                type="text"
                                name="tracking_note"
                                value={this.state.tracking_note}
                                onChange={this.onChange}
                                placeholder="Enter tracking note"
                              ></FormControl>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                      </Row>
                      {(this.state.store === 1 ||
                        this.state.store === null) && (
                        <>
                          <Row>
                            <Col sm={12}>
                              <FormGroup>
                                <ControlLabel>Pharmacist Notes</ControlLabel>
                                <FormControl
                                  type="text"
                                  name="not_get_medicine"
                                  value={this.state.not_get_medicine}
                                  onChange={this.onChange}
                                  placeholder="Enter Pharmacist Notes"
                                ></FormControl>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={12}>
                              <FormGroup>
                                <ControlLabel>Note</ControlLabel>
                                <textarea
                                  className="form-control"
                                  rows="4"
                                  cols="5"
                                  placeholder="Enter Note"
                                  onChange={(event) => {
                                    this.setState({
                                      ordernote: event.target.value,
                                    });
                                  }}
                                  value={this.state.ordernote || ""}
                                ></textarea>
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                      <Row>
                        <Col sm={8}>
                          <br></br>
                          <Button
                            disabled={
                              !this.state.processing ||
                              // this.state.isWrongQuantity ||
                              this.state.insuremeOrderButtonDisabled
                            }
                            onClick={async () => {
                              this.isPendingOrder = false;
                              await this.onSubmit();
                            }}
                            className="btn-color"
                            fill
                          >
                            Update
                          </Button>
                          &nbsp;
                          {(this.state.store == 1 ||
                            this.state.store === null) && (
                            <Button
                              disabled={
                                !this.state.processing ||
                                // this.state.isWrongQuantity ||
                                this.state.insuremeOrderButtonDisabled
                              }
                              onClick={this.onSendQuote.bind(this)}
                              className="btn-color"
                              fill
                            >
                              Send Quote
                            </Button>
                          )}
                          &nbsp;
                          {!this.state.sub_orderType == true && (
                            <Button
                              className="btn-fill btn btn-default"
                              onClick={() => this.OpenPrintOption()}
                            >
                              Print Invoice&nbsp;&nbsp;
                              <i className="fas fa-file-invoice"></i>
                            </Button>
                          )}
                          &nbsp;&nbsp;
                          {this.state.store !== null &&
                            this.state.store !== 1 &&
                            this.state.orderStatusLabel !== "Completed" && (
                              <Button
                                className="btn btn-fill fl_text_green"
                                onClick={() =>
                                  this.confirmUpdateStatusComplete()
                                }
                              >
                                Complete{" "}
                                <i className="fas fa-arrow-alt-circle-right"></i>
                              </Button>
                            )}
                          {this.state.isInsureme && (
                            <>
                              <Button
                                onClick={() => this.insuremeRequestClaim()}
                                className="btn-color"
                                fill
                              >
                                InsureMe Claim Value Verification
                              </Button>
                            </>
                          )}
                          {/* <Button 
                          disabled={
                            !this.state.processing || this.state.isWrongQuantity
                          }
                          style={{marginLeft:"px"}}
                          onClick={()=>this.onPendingOrder()}
                          className="btn-color"
                          fill
                        >
                          Item Pending
                        </Button> */}
                          &nbsp;
                          {this.state.source.value === "2" &&
                            (this.state.status === 1 ||
                              this.state.status === 2 ||
                              this.state.status === 10 ||
                              this.state.status === 11) && (
                              <Button
                                disabled={!this.state.processing}
                                // onClick={this.odocFunction.bind(this)}
                                className="btn-color"
                                fill
                              >
                                Update oPharma
                              </Button>
                            )}
                        </Col>

                        <Col sm={4} className="text-right">
                          <br></br>
                          {this.state.store === 1 ||
                          this.state.store === null ? (
                            this.state.sub_orderType ? (
                              this.state.orderStatusLabel == "Draft" ? (
                                this.viewProcceingButton()
                              ) : // <>
                              //   {this.viewSubmitButton()}
                              // </>
                              this.state.orderStatusLabel == "Processing" ? (
                                <>
                                  {this.viewItemPendingButton()}
                                  {this.viewPackedButton()}
                                </>
                              ) : this.state.orderStatusLabel ==
                                "Item Pending" ? (
                                this.viewPackedButton()
                              ) : this.state.orderStatusLabel == "Submitted" ? (
                                this.viewProcceingButton()
                              ) : this.state.orderStatusLabel == "Ready" ? (
                                this.viewPackedButton()
                              ) : (
                                ""
                              )
                            ) : this.state.orderStatusLabel == "Submitted" ? (
                              <>
                                {this.viewContactedButton()}
                                {this.viewProcceingButton()}
                              </>
                            ) : this.state.orderStatusLabel == "Contacted" ? (
                              <>
                                {this.viewItemPendingButton()}
                                {this.viewProcceingButton()}
                              </>
                            ) : this.state.orderStatusLabel == "Processing" ? (
                              this.viewPackedButton()
                            ) : this.state.orderStatusLabel ==
                              "Item Pending" ? (
                              this.viewProcceingButton()
                            ) : this.state.orderStatusLabel == "Ready" ? (
                              this.viewPackedButton()
                            ) : (
                              ""
                            )
                          ) : (
                            this.viewReadyButton()
                          )}
                        </Col>
                      </Row>
                      {this.state.insuremeBannerText !== null && (
                        <Row>
                          <Col sm={12}>
                            <br />

                            {this.state.insuremeBannerText}
                          </Col>
                        </Row>
                      )}
                    </div>
                    {(this.state.store === 1 || this.state.store === null) && (
                      <div
                        className="order_address_container"
                        style={{
                          padding: "0 20px",
                        }}
                      >
                        <Row
                          style={{
                            padding: "0 20px",
                          }}
                        >
                          <Col sm={12} md={12} style={{ paddingTop: "29px" }}>
                            <CommentSection
                              ref={(ref) =>
                                (this.commentSectionComponent = ref)
                              }
                              title="Order Comments"
                              comments={this.state.comments}
                              onAddComment={this.handleAddComment}
                              onDeleteComment={this.handleDeleteComment}
                              userOptions={this.state.UserListData}
                              UserListData={this.state.UserListData}
                              onMentionChange={(users) =>
                                this.setState({ mentionedUsers: users })
                              }
                              hasCommentId={this.state.hasCommentId}
                            />
                          </Col>
                        </Row>
                      </div>
                    )}
                    <Row
                      style={{
                        padding: "0 20px",
                      }}
                    >
                      <Col md={12} className="collapeablecomp_orderhistory">
                        <Collapsible
                          trigger="Historical Orders"
                          transitionTime={200}
                          onOpen={() => {
                            this.lastorderdata(leadId);
                          }}
                        >
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Name</th>
                                {/* <th>OPharma Referance</th> */}
                                <th>Order Date</th>
                                <th>Total Cost</th>
                                <th className="text-right">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {this.state.lastsubscription.map(
                                    (lastd, key) => (
                                      <tr key={key}>
                                        <td>{lastd.lead["name"]}</td>
                                        {/* <td>{lastd.opharma_reference}</td> */}
                                        <td>{lastd.order_date}</td>
                                        <td>
                                          {(lastd.total_cost - 0).toFixed(2)}
                                        </td>
                                        <td className="text-right">
                                          {" "}
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={view}
                                          >
                                            <Button
                                              simple
                                              bsStyle="info"
                                              onClick={this.lastorderdetail.bind(
                                                this,
                                                lastd.id,
                                              )}
                                              bsSize="sm"
                                            >
                                              <i className="fa fa-user" />
                                            </Button>
                                          </OverlayTrigger>
                                        </td>
                                      </tr>
                                    ),
                                  )}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                        </Collapsible>
                      </Col>
                    </Row>
                    {this.state.temporaryInvoices.length > 0 && (
                      <Col md={12} className="collapeablecomp_orderhistory">
                        <Collapsible
                          trigger="Temporary Invoices"
                          transitionTime={200}
                          onOpen={async () => {
                            await this.handleOrderByIdData();
                          }}
                        >
                          <br />
                          {/* <Col md={12}> */}
                          {this.state.temporaryInvoices &&
                            this.state.temporaryInvoices.map((data, index) => (
                              // <Row>
                              <Col
                                xs={4}
                                md={4}
                                lg={4}
                                style={{ marginBottom: "10px" }}
                              >
                                <a href={data.invoice_url} target="_blank">
                                  <Button
                                    className="btn-color"
                                    fill
                                    style={{ width: "206px" }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        position: "relative",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: 14,
                                          fontWeight: 500,
                                        }}
                                        key={index}
                                      >
                                        {`temp-invoice-${
                                          data.invoice_url.match(
                                            /temporary_order_(\d+_\d+)\.pdf/,
                                          )[1]
                                        }`}
                                      </span>

                                      <img
                                        style={{
                                          padding: "2px 2px 2px 10px",
                                          background: "transparent",
                                          width: "30px",
                                          alignSelf: "center",
                                          color: "black",
                                        }}
                                        src={Pdf}
                                        alt="remove"
                                      />
                                    </div>
                                  </Button>
                                </a>
                              </Col>
                            ))}
                        </Collapsible>
                      </Col>
                    )}
                  </Col>
                  {this.state.subscriber != 0 ? (
                    <Col
                      sm={4}
                      className="fl_sticky_side orderStatic-container"
                    >
                      <div className="dropdown-AddOrder">
                        <Row>
                          <Col md={12}>
                            <h3
                              style={{
                                margin: "0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                                marginBottom: "20px",
                              }}
                            >
                              Customer Info
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="table-responsive ">
                              <table className="table">
                                <tbody>
                                  {/* <React.Fragment> */}
                                  <tr>
                                    <td className="text-left">
                                      {"Name" || <Skeleton />}
                                    </td>
                                    <td className="text-right">
                                      {this.state.username != null
                                        ? this.state.username || <Skeleton />
                                        : "-" || <Skeleton />}
                                    </td>
                                  </tr>
                                  {/*this.state.userphone != null && (
                                      <tr>
                                        <td className="text-left">
                                          Phone Number
                                        </td>
                                        <td className="text-right">
                                          {this.state.userphone != null
                                            ? this.state.userphone
                                            : "-"}
                                        </td>
                                      </tr>
                                          )*/}
                                  <tr>
                                    <td className="text-left">
                                      {"Mobile Number" || <Skeleton />}
                                    </td>
                                    <td className="text-right">
                                      {this.state.usermobile != null
                                        ? this.state.usermobile || <Skeleton />
                                        : "-" || <Skeleton />}
                                    </td>
                                  </tr>
                                  {this.state.useremail && (
                                    <tr>
                                      <td className="text-left">
                                        {"Email Adress" || <Skeleton />}
                                      </td>
                                      <td className="text-right">
                                        {this.state.useremail != null
                                          ? this.state.useremail
                                          : "-"}
                                      </td>
                                    </tr>
                                  )}
                                  {/*this.state.occupation && (
                                      <tr>
                                        <td className="text-left">
                                          Occupation
                                        </td>
                                        <td
                                          className="text-right"
                                          style={{ padding: "1px" }}
                                        >
                                          {this.state.occupation
                                            ? this.state.occupation
                                            : "-"}
                                        </td>
                                      </tr>
                                         )*/}
                                  <tr>
                                    <td className="text-left">
                                      {"Remaining Credits" || <Skeleton />}
                                    </td>
                                    <td className="text-right">
                                      {this.state.remainingCredit != null
                                        ? (
                                            this.state.remainingCredit - 0
                                          ).toFixed(2) || <Skeleton />
                                        : "0" || <Skeleton />}
                                    </td>
                                  </tr>
                                  {/*<tr>
                                  <td className="text-left">Package Name</td>
                                  <td
                                    className="text-right"
                                    style={{ padding: "1px" }}
                                  >
                                    {this.state.catalougepackagename != null
                                      ? this.state.catalougepackagename
                                      : "-"}
                                  </td>
                                    </tr>*/}
                                  <tr>
                                    <td className="text-left">
                                      {"Company name" || <Skeleton />}
                                    </td>
                                    <td className="text-right">
                                      {this.state.companyname != null
                                        ? this.state.companyname || <Skeleton />
                                        : "-" || <Skeleton />}
                                    </td>
                                  </tr>
                                  {this.state.isClaimableOrder ? (
                                    <tr>
                                      <td className="text-left">
                                        {"Claim Points" || <Skeleton />}
                                      </td>
                                      <td className="text-right">
                                        {this.state.avalable_flash_point != null
                                          ? (
                                              this.state.avalable_flash_point -
                                              0
                                            ).toFixed(2) || <Skeleton />
                                          : "0" || <Skeleton />}
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      {!!this.state.ClaimPolicyDetails ||
                      this.state.ClaimPolicyDetails !== "" ? (
                        <div className="dropdown-ClaimInfo">
                          <div className="collapeablecomp_familyDetails">
                            <Collapsible
                              trigger="Claim Policy Info"
                              transitionTime={200}
                              open={true}
                            >
                              <Row>
                                <Col md={12}>
                                  {!!this.state.ClaimPolicyDetails ||
                                  this.state.ClaimPolicyDetails !== "" ? (
                                    <>
                                      {/* <h4>Policy Details</h4> */}
                                      <b>
                                        <div
                                          style={{
                                            padding: "5px",
                                            fontWeight: "bold",
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              this.state.ClaimPolicyDetails,
                                          }}
                                        ></div>
                                      </b>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Col>
                              </Row>
                            </Collapsible>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {this.state.familyDetails.length > 0 && (
                        <div className="dropdown-ClaimInfo">
                          <div className="collapeablecomp_familyDetails">
                            <Collapsible
                              trigger="Claim Family Info"
                              transitionTime={200}
                              onOpen={() => {
                                this.getFamilyDetails();
                              }}
                            >
                              <Row>
                                <Col md={12}>
                                  {/* {this.state.familyDetails.length > 0 && (
                            <h4 style={{ padding: "0px 0px 0px 10px" }}>
                              Family Details
                            </h4>
                          )} */}

                                  {this.state.familyDetails.length > 0 &&
                                    this.state.familyDetails &&
                                    this.state.familyDetails.map((item) => (
                                      <>
                                        <div style={{ padding: "10px" }}>
                                          <div
                                            style={{
                                              border: "2px solid",
                                              borderRadius: "8px",
                                              padding: "10px",
                                            }}
                                          >
                                            <p style={{ fontWeight: "bold" }}>
                                              Name: {item.name}
                                            </p>
                                            <p style={{ fontWeight: "bold" }}>
                                              Relation: {item.relation}
                                            </p>
                                            {!this.state.isInsureme && (
                                              <p style={{ fontWeight: "bold" }}>
                                                Mobile No: {item.phone}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </>
                                    ))}
                                </Col>
                              </Row>
                            </Collapsible>
                          </div>
                        </div>
                      )}

                      <div className="dropdown2-AddOrder">
                        <Row>
                          <Col md={12}>
                            <h3
                              style={{
                                margin: "20px 0",
                                letterSpacing: "0.5px",
                                fontSize: "24px",
                              }}
                            >
                              Basket Info
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="table-responsive ">
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <td
                                      style={{ padding: "1px", width: "60%" }}
                                    >
                                      Basket Value
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {this.state.sub_orderType === 4
                                          ? 0
                                          : this.state.basketvalue}
                                      </p>
                                    </td>
                                  </tr>
                                  {this.state.credit_being_use != "0" ? (
                                    <tr>
                                      <td style={{ padding: "1px" }}>
                                        Credit being used
                                      </td>
                                      <td style={{ padding: "1px" }}>
                                        <p className="basketValue_parent">
                                          {this.state.credit_being_use > 0
                                            ? "-"
                                            : ""}{" "}
                                          {(
                                            this.state.credit_being_use - 0
                                          ).toFixed(2)}
                                        </p>
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Flash Credit
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {this.state.used_credit_point > 0
                                          ? "-"
                                          : ""}{" "}
                                        {(
                                          this.state.used_credit_point - 0
                                        ).toFixed(2)}
                                      </p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Discounted Amount
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {this.state.discountamount > 0
                                          ? "-" + this.state.discountamount
                                          : this.state.discountamount}
                                        {/* {this.state.discountamount} */}
                                      </p>
                                    </td>
                                  </tr>
                                  {Number(this.state.getUnavalibleCost) > 0 &&
                                    this.state.sub_orderType && (
                                      <tr>
                                        <td style={{ padding: "1px" }}>
                                          Pending Item value
                                        </td>
                                        <td style={{ padding: "1px" }}>
                                          <p className="basketValue_parent">
                                            (
                                            {(
                                              Number(
                                                this.state.getUnavalibleCost,
                                              ) || 0
                                            ).toFixed(2)}
                                            )
                                          </p>
                                        </td>
                                      </tr>
                                    )}

                                  {this.state.catPackageDiscountAmount != 0 &&
                                    this.state.is_flash_point == 0 &&
                                    !this.state.isClaimableOrder && (
                                      <tr>
                                        <td style={{ padding: "1px" }}>
                                          {`${this.state.catalougepackagename} Package Discount Amount (${this.state.catPackageDiscount}%)`}
                                        </td>
                                        <td style={{ padding: "1px" }}>
                                          <p className="basketValue_parent">
                                            {"-" +
                                              this.state
                                                .catPackageDiscountAmount}
                                            {/* {this.state.catPackageDiscountAmount} */}
                                          </p>
                                        </td>
                                      </tr>
                                    )}
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      {this.state.coupon_use_text}
                                      {this.state.coupon_title
                                        ? `(${this.state.coupon_title})`
                                        : ""}
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {Number(
                                          this.state.coupon_discountamount,
                                        ) > 0
                                          ? this.state.coupon_discountamount
                                          : 0}
                                      </p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      {!this.state.isInsureme &&
                                      this.claimableTotal !== 0
                                        ? " Claimed Delivery / Packaging Charge"
                                        : this.state.isInsureme &&
                                            this.claimableTotal !== 0
                                          ? "InsureMe Delivery / Packaging Charge"
                                          : " Delivery / Packaging Charge"}
                                      {this.state.deliverytype.value == 2 ? (
                                        <span>(Express Delivery)</span>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <FormControl
                                        name="deliverycharge"
                                        className="basketValue_input fl_deliverycharge"
                                        // disabled={
                                        //   this.state.package_delivery_discount
                                        // }
                                        value={this.state.deliverycharge}
                                        onChange={(event) =>
                                          this.handleDeliveryChange(event)
                                        }
                                        type="number"
                                      />
                                    </td>
                                  </tr>
                                  {this.claimableTotal != 0 ? (
                                    <tr>
                                      <td style={{ padding: "1px" }}>
                                        {this.state.isInsureme
                                          ? "InsureMe Claim Value"
                                          : "Claimed Value"}
                                      </td>
                                      <td style={{ padding: "1px" }}>
                                        <p className="basketValue_parent">
                                          {this.handleClaimedValueOnChange()}
                                        </p>
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                  {/* {Object.keys(this.state.creditNoteData).length >
                                  0 ? (
                                  <tr>
                                    <td
                                      style={{ //important
                                        padding: "1px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Less{" "}
                                      <a
                                        onClick={() => {
                                          this.props.history.push(
                                            `/admin/credit_note/${this.state.creditNoteData.cn_id}`
                                          );
                                        }}
                                      >
                                        Credit note
                                      </a>
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basketValue_parent">
                                        {(this.state.creditNoteData.total_amount
                                          ? -this.state.creditNoteData
                                            .total_amount
                                          : 0
                                        ).toFixed(2)}
                                      </p>
                                    </td>
                                  </tr>
                                ) : (
                                  ""
                                )}{" "} */}
                                  {this.state.creditNoteData &&
                                  this.state.creditNoteData.status ===
                                    "APPROVED" ? (
                                    <tr>
                                      <td style={{ padding: "1px" }}>
                                        Credit Note
                                        {this.state.catPackageDiscountAmount !=
                                        0
                                          ? ` (with discount ${this.state.catPackageDiscount}%)`
                                          : ""}
                                        <a
                                          Note
                                          onClick={this.viewCreditNote.bind(
                                            this,
                                          )}
                                          style={{
                                            cursor: "pointer",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          View
                                        </a>
                                      </td>
                                      <td style={{ padding: "1px" }}>
                                        <p className="basketValue_parent">
                                          -{creditNoteValue}
                                        </p>
                                      </td>
                                    </tr>
                                  ) : null}
                                  <tr>
                                    <td style={{ padding: "1px" }}>
                                      Total Cost
                                    </td>
                                    <td style={{ padding: "1px" }}>
                                      <p className="basket_totalcost">
                                        {this.state.sub_orderType === 4
                                          ? 0
                                          : this.claimableTotal !== 0 &&
                                              !this.state.isInsureme
                                            ? Number(this.state.totalcost) -
                                                Number(this.claimableTotal) -
                                                Number(
                                                  this.state.deliverycharge,
                                                ) -
                                                creditNoteValue >
                                              0
                                              ? Number(this.state.totalcost) -
                                                Number(this.claimableTotal) -
                                                Number(
                                                  this.state.deliverycharge,
                                                ) -
                                                creditNoteValue
                                              : (0)
                                                  .toFixed(2)
                                                  .replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ",",
                                                  )
                                            : Number(this.state.totalcost) -
                                                  (this.state.sub_orderType
                                                    ? Number(
                                                        this.state
                                                          .getUnavalibleCost,
                                                      )
                                                    : 0) -
                                                  Number(
                                                    this.state.credit_being_use,
                                                  ) -
                                                  Number(
                                                    this.state
                                                      .catPackageDiscountAmount,
                                                  ) -
                                                  Number(this.claimableTotal) -
                                                  creditNoteValue >
                                                0
                                              ? Number(this.state.totalcost) -
                                                (this.state.sub_orderType
                                                  ? Number(
                                                      this.state
                                                        .getUnavalibleCost,
                                                    )
                                                  : 0) -
                                                Number(
                                                  this.state.credit_being_use,
                                                ) -
                                                Number(
                                                  this.state
                                                    .catPackageDiscountAmount,
                                                ) -
                                                Number(this.claimableTotal) -
                                                creditNoteValue
                                              : (0)
                                                  .toFixed(2)
                                                  .replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ",",
                                                  )}
                                      </p>

                                      {/* <FormControl
                                      name="totalcost"
                                      className="fl_total_cost_inpt fl_basketinfoupdated"
                                      disabled="disabled"
                                      value={
                                        this.state.loading ? (
                                          <LoadingSpinner />
                                        ) : (
                                          this.state.totalcost
                                        )
                                      }
                                      onChange={(event) => {
                                        this.setState({
                                          totalcost: event.target.value,
                                        });
                                        event.target.value === ""
                                          ? this.setState({
                                              totalcostError: (
                                                <small className="text-danger">
                                                  Total Cost is required.
                                                </small>
                                              ),
                                            })
                                          : this.setState({
                                              totalcostError: null,
                                            });
                                      }}
                                      placeholder="0.00"
                                      type="number"
                                    />  */}
                                      {this.state.totalcostError}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              }
            />
          </Grid>
          {this.state.isLoading ? <ScreenLoader /> : ""}

          <Modal
            show={this.state.showModal}
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title>Medication Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p key={subscriptiondetail.id}>
                {" "}
                TotalCost : {(subscriptiondetail.total_cost - 0).toFixed(2)}
              </p>

              <p>
                Delivery Type :{" "}
                {subscriptiondetail.delivery_type == "1" ? "Flash" : "oPharma"}
              </p>
              {subscriptiondetail.delivery_charge != null ? (
                <p>
                  Delivery Charge :{" "}
                  {(subscriptiondetail.delivery_charge - 0).toFixed(2)}
                </p>
              ) : (
                ""
              )}
              {subscriptiondetail.organization_discount > 0 ? (
                <p>
                  Discount :{" "}
                  {(subscriptiondetail.organization_discount - 0).toFixed(2)}
                </p>
              ) : (
                ""
              )}

              <Table>
                <thead>
                  <tr>
                    <th>Medication</th>
                    <th>Unit Price</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.quanitydata.map((data) => (
                    <tr key={data.medication_id}>
                      <td>{data.medication_title}</td>
                      <td>{(data.unit_price - 0).toFixed(2)}</td>
                      <td>{data.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.discountmodal}
            onHide={() => this.setState({ discountmodal: false })}
          >
            <Modal.Header>
              <Modal.Title>Dynamic Discount</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup>
                <ControlLabel>Discount Percentage</ControlLabel>
                <FormControl
                  type="number"
                  value={this.state.discountpercentage}
                  onChange={this.onChange}
                  name="discountpercentage"
                  placeholder="0%"
                ></FormControl>
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.submitdynamicdiscount.bind(this)} fill>
                Submit
              </Button>
              &nbsp;
              <Button onClick={this.closedynamicdiscount.bind(this)} fill>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          {/* <Modal
          show={this.state.isCreditNoteModalOpen}
          onHide={() => this.setState({ isCreditNoteModalOpen: false })}
          bsSize="large"
          allowFullScreen
          id="increaseWidth"
          style={{ width: "100% !important" }}
        >
          <Modal.Header style={{ display: "flex" }}>
            <Modal.Title style={{ marginTop: "5px" }}>Credit Note</Modal.Title>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <ControlLabel
              style={{
                marginTop: "8px",
                fontSize: "20px",
                fontWeight: "normal",
              }}
            >
              Reference
            </ControlLabel>
            &nbsp;&nbsp;
            <FormGroup>
              <FormControl
                type="text"
                name="referenceNote"
                value={this.state.referenceNote || ""}
                onChange={this.creditNoteOnChange}
                placeholder="Enter Reference"
              ></FormControl>
            </FormGroup>
            <Col
              md={3}
              sm={4}
              lg={3}
              xs={12}
              className="fl_status_dropdown"
              style={{
                paddingTop: "4px",
                flexBasis: "content",
                marginLeft: "50%",
              }}
            >
              <select
                name="creditNoteStatus"
                className="form-control"
                value={this.state.creditNoteStatus}
                onChange={(event) => {
                  const value = event.target.value;
                  this.setState({
                    creditNoteStatus: value,
                    creditNoteStatusError: null,
                  });
                }}
              >
                <option value="0">Select Credit Note Status</option>
                <option value="Credit Note Approved">
                  Credit Note Approved
                </option>
              </select>
            </Col>
            {this.state.creditNoteStatusError}
          </Modal.Header>
          <Modal.Body style={{ overflowY: "scroll", height: "70vh" }}>
            <Table>
              <thead>
                <tr>
                  <th style={{ paddingLeft: 0 }}>
                    <ControlLabel>Item Code</ControlLabel>
                  </th>
                  <th>
                    <ControlLabel>Item Name </ControlLabel>
                  </th>
                  <th>
                    <ControlLabel>Quantity</ControlLabel>
                  </th>
                  <th>
                    <ControlLabel>Unit Price</ControlLabel>
                  </th>
                  <th>
                    <ControlLabel>Amount LKR </ControlLabel>
                  </th>
                  <th>
                    {" "}
                    <ControlLabel>Actions</ControlLabel>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.inputList.length > 0
                  ? this.state.inputList.map((x, i) => (
                      <tr>
                        <td>{x.medi_itemcode}</td>
                        <td>{x.medi_title}</td>
                        <td>
                          <FormControl
                            style={{ width: "100px", textAlign: "center" }}
                            className="no-padding qty_imput"
                            name="quantity"
                            min={1}
                            max={x.quantity}
                            value={x.quantity}
                            onChange={(e) =>
                              this.handleInputCreditNoteChange(e, i, "quantity")
                            }
                            placeholder="0"
                            type="number"
                          />{" "}
                          {x.quantity_type === 1 ? x.quantity_per_box : ""}
                        </td>
                        <td>{x.unitprice}</td>
                        <td>{x.subtotal}</td>
                        <td>
                          <a
                            href="javascript:void(0)"
                            onClick={(e) =>
                              this.handleRemoveClick(i, x.orderItemNumber)
                            }
                          >
                            X
                          </a>
                        </td>
                      </tr>
                    ))
                  : ""}
              </tbody>
              <br />
              <br />
            </Table>
            <Col md={5} style={{ left: "58%" }}>
              <div className="table-responsive">
                <table className="table">
                  <tbody>
                    <tr>
                      <td>Total</td>
                      <td>{this.state.basketvalue}</td>
                    </tr>
                    <tr>
                      <td>
                        Less Credit To &nbsp;
                        <span>
                          <a href="">
                            Invoice INV {this.props.match.params.id}
                          </a>
                        </span>
                        <br />
                        Created At &nbsp;&nbsp;{this.state.created_At}
                      </td>
                      <td>{this.state.basketvalue}</td>
                      {}
                    </tr>
                    <tr></tr>
                    <tr style={{ padding: "1px" }}></tr>
                    <tr>
                      <td style={{ fontWeight: "bold", fontSize: "large" }}>
                        Remaining Credits
                      </td>
                      <td>
                        {this.state.subtotal > 0 ? "-" : ""}{" "}
                        {(this.state.subtotal - 0).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} md={12} xs={12} className="text-right">
              <Button
                bsStyle="success"
                fill
                onClick={() => this.sendCreditNotevalue()}
              >
                Submit
              </Button>
              <Button
                bsStyle="danger"
                fill
                onClick={() => {
                  this.setState({ isCreditNoteModalOpen: false, referenceNote: "" });
                  window.location.reload();
                }}
              >
                Cancel
              </Button>
            </Col>
          </Modal.Footer>
        </Modal> */}
          {this.state.isCreditNoteModalOpen ? (
            <CreditNoteModal
              creditNote={this.state.isCreditNoteModalOpen}
              setCreditNote={(creditNote) =>
                this.setState({ isCreditNoteModalOpen: creditNote })
              }
              pkgDiscount={this.state.catPackageDiscount}
              creditNoteData={this.state.creditNoteData}
              inputList={this.state.inputList}
              orderId={Number(this.props.match.params.id)}
              setAlert={(alert) => this.setState({ alert: alert })}
              setLoading={(isLoading) =>
                this.setState({ isLoading: isLoading })
              }
            />
          ) : null}
          <Modal
            show={this.state.prescriptionmodal}
            onHide={() => this.setState({ prescriptionmodal: true })}
          >
            <Modal.Header>
              <Modal.Title>Prescription Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup>
                {/* <Row>
                        <Col md={8} className="mt-3">
                            <Col md={3}><img  style={{height:'30px',width:'30px'}}  src={this.state.priscriptionurl} /></Col>
                            <Col md={4}><ControlLabel>Prescription 1 </ControlLabel></Col>
                            <Col md={2}><a className="btn " href={this.state.priscriptionurl} target="_blank" >View</a></Col>
                        </Col>
                        </Row> */}
                {/* {this.state.priscriptionurl} */}
                <Row>
                  <Col md={8} className="mt-3">
                    {this.state.priscriptionurl.map((pre, key) => (
                      <Col md={2} key={key}>
                        <a
                          className="fa fa-file"
                          style={{
                            "font-size": "45px",
                            color: "black",
                          }}
                          href={pre.prescription_url}
                          target="_blank"
                        ></a>
                      </Col>
                    ))}
                  </Col>
                </Row>
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.closeprescriptionmodal.bind(this)} fill>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.marginmodal}
            onHide={() => this.setState({ marginmodal: false })}
          >
            <Modal.Header>
              <Modal.Title>Dynamic Margin</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup className="order_source_data">
                <ControlLabel>Select Margin Type</ControlLabel>
                &nbsp;
                <Radio
                  style={{ display: "inline-block" }}
                  number="8"
                  option="1"
                  name="margintype"
                  onChange={this.onChange}
                  checked={this.state.margintype === "1"}
                  label="Margin Percentage"
                />
                &nbsp;
                <Radio
                  style={{ display: "inline-block" }}
                  number="9"
                  option="2"
                  name="margintype"
                  onChange={this.onChange}
                  checked={this.state.margintype === "2"}
                  label="Margin in cash"
                />
              </FormGroup>
              {this.state.margintype == 1 ? (
                <FormGroup>
                  <ControlLabel>Margin Percentage</ControlLabel>
                  <FormControl
                    type="number"
                    onChange={this.onChange}
                    value={this.state.marginpercentage}
                    name="marginpercentage"
                    placeholder="0%"
                  ></FormControl>
                </FormGroup>
              ) : (
                ""
              )}
              {this.state.margintype == 2 ? (
                <FormGroup>
                  <ControlLabel>Margin Amount</ControlLabel>
                  <FormControl
                    type="number"
                    onChange={this.onChange}
                    value={this.state.marginamount}
                    name="marginamount"
                    placeholder="0.00"
                  ></FormControl>
                </FormGroup>
              ) : (
                ""
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={this.submitdynamicmargin.bind(this)}
                bsStyle="success"
                fill
              >
                {" "}
                Submit
              </Button>{" "}
              &nbsp;
              <Button
                onClick={this.closedynamicmargin.bind(this)}
                bsStyle="info"
                fill
              >
                {" "}
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.marginmodal}
            onHide={() => this.setState({ marginmodal: false })}
          >
            <Modal.Header>
              <Modal.Title>Dynamic Margin</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup className="order_source_data">
                <ControlLabel>Select Margin Type</ControlLabel>
                &nbsp;
                <Radio
                  style={{ display: "inline-block" }}
                  number="8"
                  option="1"
                  name="margintype"
                  onChange={this.onChange}
                  checked={this.state.margintype === "1"}
                  label="Margin Percentage"
                />
                &nbsp;
                <Radio
                  style={{ display: "inline-block" }}
                  number="9"
                  option="2"
                  name="margintype"
                  onChange={this.onChange}
                  checked={this.state.margintype === "2"}
                  label="Margin in cash"
                />
              </FormGroup>
              {this.state.margintype == 1 ? (
                <FormGroup>
                  <ControlLabel>Margin Percentage</ControlLabel>
                  <FormControl
                    type="number"
                    onChange={this.onChange}
                    value={this.state.marginpercentage}
                    name="marginpercentage"
                    placeholder="0%"
                  ></FormControl>
                </FormGroup>
              ) : (
                ""
              )}
              {this.state.margintype == 2 ? (
                <FormGroup>
                  <ControlLabel>Margin Amount</ControlLabel>
                  <FormControl
                    type="number"
                    onChange={this.onChange}
                    value={this.state.marginamount}
                    name="marginamount"
                    placeholder="0.00"
                  ></FormControl>
                </FormGroup>
              ) : (
                ""
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={this.submitdynamicmargin.bind(this)}
                bsStyle="success"
                fill
              >
                {" "}
                Submit
              </Button>{" "}
              &nbsp;
              <Button
                onClick={this.closedynamicmargin.bind(this)}
                bsStyle="info"
                fill
              >
                {" "}
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.isClaimConfirmationModalOpen}
            onHide={() =>
              this.setState({ isClaimConfirmationModalOpen: false })
            }
          >
            <Modal.Header>
              <Modal.Title>Un Claimed Medicines</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "calc(100vh - 170px)",
                overflow: "auto",
              }}
            >
              <Table responsive>
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Medicine</th>
                    <th> Quantity</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {this.state.unClaimableMedicineList.map((x) => {
                    return (
                      <tr>
                        <td>{x.medi_itemcode}</td>
                        <td>{x.medi_title}</td>
                        <td>{x.quantity}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle="info"
                fill
                onClick={() =>
                  this.setState({ isClaimConfirmationModalOpen: false })
                }
              >
                Close
              </Button>
              <Button
                bsStyle="success"
                fill
                onClick={() => this.unCheckValidationComplete()}
              >
                OK
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.isOpenItemPendingModal}
            onHide={() => this.setState({ isOpenItemPendingModal: true })}
          >
            <Modal.Header>
              <Modal.Title>Waiting for supplier</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup>
                <ControlLabel>Possible date</ControlLabel>
                {/* <FormControl
                      type="text"
                      value={this.state.ordercancelreason}
                      onChange={this.oncancelchnage}
                      name="ordercancelreason"
                      placeholder="Cancel Reason"
                    ></FormControl> */}

                {/* <Datetime
                        timeFormat={false}
                        dateFormat="YYYY-MM-DD"
                        inputProps={{ placeholder: "Expected Delivery Date" }}
                        closeOnSelect={true}
                        value={this.state.expectedDate}
                        onChange={this.handleDateChange1}
                      /> */}
                <FormGroup className="fl_datepicker">
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <FormControl
                      style={{ margin: 0 }}
                      value={`${this.state.itemPendingDaterange.start.format(
                        "YYYY-MM-DD",
                      )} - ${this.state.itemPendingDaterange.end.format(
                        "YYYY-MM-DD",
                      )}`}
                      onClick={() => this.onToggleItemPending()}
                      placeholder="Date Range"
                      type="text"
                    />

                    {this.state.isItemPendingDatePickerOn && (
                      <DateRangePicker
                        value={this.state.itemPendingDaterange}
                        onSelect={this.onSelectnew}
                        singleDateRange={true}
                      />
                    )}
                  </div>
                </FormGroup>

                {/* {this.state.ordercancelreasonError} */}
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => this.submitItemPendingModal()}
                bsStyle="success"
                fill
              >
                Submit
              </Button>
              &nbsp;
              <Button
                onClick={() =>
                  this.setState({
                    isOpenItemPendingModal: false,
                    delivery_from_dates: "",
                    delivery_to_dates: "",
                  })
                }
                bsStyle="info"
                fill
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.isOpenRiderModal}
            onHide={() => this.setState({ isOpenRiderModal: true })}
            bsSize="lg"
          >
            <Modal.Header>
              <Modal.Title>Rider Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.insuremeBannerText !== null && (
                <Row>
                  <Col sm={12}>{this.state.insuremeBannerText}</Col>
                </Row>
              )}
              <FormGroup>
                <Checkbox
                  number="999"
                  checked={this.state.isCurrier}
                  onChange={(e) => this.handleIsCurrierCheckbox(e)}
                  label="Is Courier ?"
                ></Checkbox>
                {!this.state.isCurrier ? (
                  <div>
                    <ControlLabel>Select Rider</ControlLabel>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      placeholder="Rider"
                      //style={{ width:"10%" }}
                      name="rider_info"
                      value={this.state.selectedRider}
                      onChange={(value) =>
                        this.setState({
                          selectedRider: value,
                          selectedRiderError: null,
                        })
                      }
                      options={this.state.rider_data}
                    />
                    {this.state.selectedRiderError}
                  </div>
                ) : (
                  <div
                    style={{
                      display: this.state.isCurrier ? "block" : "none",
                    }}
                  >
                    <ControlLabel>Courier Partner : </ControlLabel>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      placeholder="Courier Partner"
                      //style={{ width:"10%" }}
                      name="currier_id"
                      value={this.state.selectedCurrier}
                      onChange={(value) =>
                        this.setState({
                          selectedCurrier: value,
                          selectedCurrierError: null,
                        })
                      }
                      options={this.state.currierData}
                    />
                    {this.state.selectedCurrierError}
                  </div>
                )}
                <Row
                  md={12}
                  style={{
                    display: this.state.isCurrier ? "block" : "none",
                  }}
                >
                  <Col md={4}>
                    <FormGroup style={{ margin: 0, marginTop: 10 }}>
                      <ControlLabel>Tracking Id</ControlLabel>
                      <FormControl
                        type="text"
                        name="currierTrackingId"
                        value={this.state.currierTrackingId}
                        onChange={this.onChangeCourrierTrackingDetails}
                        placeholder="Enter tracking id"
                      ></FormControl>
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup style={{ margin: 0, marginTop: 10 }}>
                      <ControlLabel>Tracking Url</ControlLabel>
                      <FormControl
                        type="text"
                        name="currierTrackingUrl"
                        value={this.state.currierTrackingUrl}
                        onChange={this.onChangeCourrierTrackingDetails}
                        placeholder="Enter tracking url"
                      ></FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup style={{ margin: 0, marginTop: 10 }}>
                      <ControlLabel>Tracking Note</ControlLabel>
                      <FormControl
                        type="text"
                        name="currierTrackingNote"
                        value={this.state.currierTrackingNote}
                        onChange={this.onChangeCourrierTrackingDetails}
                        placeholder="Enter tracking note"
                      ></FormControl>
                    </FormGroup>
                  </Col>
                </Row>
              </FormGroup>

              {/* {this.state.htmlContent} */}
              <React.Fragment>
                <p
                  className="custom-listing-style"
                  onClick={() =>
                    this.setState({
                      viewMedDetails: !this.state.viewMedDetails,
                    })
                  }
                >
                  Order #{this.props.match.params.id}{" "}
                  <b
                    className={
                      !!this.state.viewMedDetails
                        ? "caret caret-down"
                        : "caret rotate-180"
                    }
                  ></b>
                </p>
                <Collapse
                  isOpened={this.state.viewMedDetails}
                  // open={false}
                  // trigger={`Order #${this.props.match.params.id}`}
                  // transitionTime={200}
                  // className="custom-listing-style"
                >
                  <div class="quality_div" responsive>
                    <div class="half_div_1">
                      {this.state.priscriptionurl.map((pre, key) => {
                        return (
                          <a
                            key={key}
                            style={{
                              display: "inline-block",
                            }}
                            href={pre.prescription_url.prescription_file}
                            target="_blank"
                          >
                            <img
                              key={key}
                              className="zoom"
                              width="200px"
                              src={pre.prescription_url.prescription_file}
                            />
                          </a>
                        );
                      })}

                      <label class="quality_heading">Prescription Text</label>

                      <p style={{ fontSize: "12px" }}>
                        {this.state.prescription_text != "" &&
                          this.state.prescription_note}
                      </p>
                      <label class="quality_heading">Prescription Note</label>

                      <p style={{ fontSize: "12px" }}>
                        {this.state.prescription_note != null &&
                          this.state.prescription_note}
                      </p>
                    </div>
                    <div class="half_div_2">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th style={{ width: "80%" }}>medication Title</th>
                            <th style={{ width: "20%" }}>quantity</th>
                          </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                          {this.state.inputList
                            .filter(
                              (x) =>
                                x.isPartialOrderItem &&
                                x.description != null &&
                                x.description != "",
                            )
                            .map((x) => {
                              return (
                                <tr>
                                  <td>
                                    {`${x.medi_itemcode}(
                                  ${x.medi_title})`}
                                  </td>
                                  <td>{x.quantity}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </Table>
                    </div>

                    <FormGroup>
                      <Checkbox
                        number={49 + 100}
                        checked={this.state.isChecked}
                        onChange={(e) =>
                          this.setState({
                            isChecked: e.target.checked,
                            submitButtonDisable: e.target.checked,
                          })
                        }
                        label="Items checked against order & quantity packed"
                      ></Checkbox>
                    </FormGroup>
                  </div>
                </Collapse>
              </React.Fragment>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => this.submitUpdatePackedStatusModal()}
                bsStyle="success"
                fill
                disabled={!this.state.submitButtonDisable}
              >
                {this.state.submitButtonText}
              </Button>
              &nbsp;
              <Button
                onClick={() => this.setState({ isOpenRiderModal: false })}
                bsStyle="info"
                fill
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.showOutOfStock}
            onHide={() => this.setState({ showOutOfStock: false })}
          >
            <Modal.Header>
              <Modal.Title>Medicine Out of Stock</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "calc(100vh - 170px)",
                overflow: "auto",
              }}
            >
              <Table responsive>
                <thead>
                  <tr>
                    <th>Order Id</th>
                    <th>Code</th>
                    <th>Medicine</th>
                    <th>Order Quantity</th>
                    <th>Available Quantity</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {this.state.inputList
                    .filter(
                      (item) =>
                        parseFloat(item.quantity) >
                          parseFloat(item.availableQuantity) &&
                        item.isPartialOrderItem === true,
                    )
                    .map((x, index) => {
                      return (
                        <tr key={index}>
                          <td>{this.props.match.params.id}</td>
                          <td>{x.medi_itemcode}</td>
                          <td>{x.medi_title}</td>
                          <td>{x.quantity}</td>
                          <td>{x.availableQuantity}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle="info"
                fill
                onClick={() => this.setState({ showOutOfStock: false })}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.showAllocatedValue}
            onHide={() => this.setState({ showAllocatedValue: false })}
            bsSize="lg"
          >
            <Modal.Header>
              <Modal.Title>Show Allocated Orders</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflowY: "scroll", height: "70vh" }}>
              <Table>
                <thead>
                  <th>Order Id</th>
                  <th>Quantity</th>
                  <th>Created_at</th>
                </thead>
                <tbody>
                  {this.state.allocatedData.length == 0 ? (
                    <td colspan="10" style={{ textAlign: "center" }}>
                      <h5>No Data Found</h5>{" "}
                    </td>
                  ) : (
                    this.state.allocatedData.map((item) => (
                      <tr>
                        <td>{item.order_id}</td>
                        <td>{item.quantity}</td>
                        <td>{item.created_at}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => this.setState({ showAllocatedValue: false })}
                bsStyle="info"
                fill
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.openOutOfStockModal}
            onHide={() => this.setState({ openOutOfStockModal: false })}
          >
            <Modal.Header>
              <Modal.Title>Medicine Out of Stock</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "calc(100vh - 170px)",
                overflow: "auto",
              }}
            >
              <Table responsive>
                <thead>
                  <tr>
                    <th>Order Id</th>
                    <th>Code</th>
                    <th>Medicine</th>
                    <th>Order Quantity</th>
                    <th>Available Quantity</th>
                    {/* {this.state.store === null || this.state.store === 1 ? (
                      // <th>Allocated Quantity</th>
                    ) : null} */}
                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {this.state.outOfStockMedicineDetails.map(
                    (outOfStockMedicine) => {
                      const medicineData =
                        outOfStockMedicine.medicineData || {};
                      const fallbackAvailableQuantity =
                        outOfStockMedicine.availableQuantity != null
                          ? outOfStockMedicine.availableQuantity
                          : 0;
                      let totalAvailableQuantity = Number(
                        medicineData.total_quantity != null
                          ? medicineData.total_quantity
                          : fallbackAvailableQuantity,
                      );
                      //-
                      //Number(outOfStockMedicine.medicineData.total_allocated);
                      return (
                        <tr>
                          <td>{this.props.match.params.id}</td>
                          <td>
                            {medicineData.item_code ||
                              outOfStockMedicine.medi_itemcode ||
                              "-"}
                          </td>
                          <td>
                            {medicineData.title ||
                              outOfStockMedicine.medi_title ||
                              "-"}
                          </td>
                          <td>{outOfStockMedicine.quantity}</td>
                          <td>
                            {totalAvailableQuantity > 0
                              ? totalAvailableQuantity
                              : 0}
                          </td>
                          {/* {this.state.store === null ||
                          this.state.store === 1 ? (
                            <td>
                              {Number(
                                outOfStockMedicine.medicineData.total_allocated
                              )}
                            </td>
                          ) : null} */}
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle="info"
                fill
                onClick={() => this.setState({ openOutOfStockModal: false })}
              >
                Close
              </Button>
              <Button
                bsStyle="success"
                fill
                onClick={async () => await this.onSubmit()}
              >
                Update Order
              </Button>
            </Modal.Footer>
          </Modal>

          {/* <h3>Shipping Details</h3> */}
          {/* <Col md={6}>
                      <FormGroup>
                      <ControlLabel>Name</ControlLabel>
                      <FormControl name="name" value={this.state.name} onChange={event => {
                        this.setState({ name: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              nameError: (
                                <small className="text-danger">
                                  Name is required.
                                </small>
                              )
                            })
                          : this.setState({ nameError: null });
                      }} placeholder="Enter Name" type="text" />
                      {this.state.nameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Mobile No</ControlLabel>
                      <FormControl name="mobileno" value={this.state.mobileno} onChange={event => {
                        this.setState({ mobileno: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              mobilenoError: (
                                <small className="text-danger">
                                  Mobile No is required.
                                </small>
                              )
                            })
                          : this.setState({ mobilenoError: null });
                      }} placeholder="Enter Mobile No" type="number" />
                      {this.state.mobilenoError}
                    </FormGroup>
                    
                    <FormGroup>
                      <ControlLabel>Phone No</ControlLabel>
                      <FormControl name="phoneno" value={this.state.phoneno} onChange={event => {
                        this.setState({ phoneno: event.target.value });
                        // event.target.value === ""
                        //   ? this.setState({
                        //       phonenoError: (
                        //         <small className="text-danger">
                        //           Phone No is required.
                        //         </small>
                        //       )
                        //     })
                        //   : this.setState({ phonenoError: null });
                      }} placeholder="Enter Phone No" type="number" />
                      {this.state.phonenoError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Status</ControlLabel>
                      <select name="status" onChange={event => {
                        this.setState({ status: event.target.value });
                        event.target.value === "0"
                          ? this.setState({
                              statusError: (
                                <small className="text-danger">
                                  Status is required.
                                </small>
                              )
                            })
                          : this.setState({ statusError: null });
                      }} value={this.state.status} className="form-control">
                        <option value="0">Select Status</option>                     
                          <option value="1">Submitted</option>
                          <option value="2">Processing</option>
                          <option value="3">Dispatched</option>
                          <option value="4">Delivered</option>
                          <option value="5">Cancelled</option>
                          <option value="6">Attempted</option>
                          <option value="7">Unreachable</option>
                        </select>
                        {this.state.statusError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Email</ControlLabel>
                      <FormControl name="email" value={this.state.email} onChange={event => {
                        this.setState({ email: event.target.value });
                        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                              emailRex.test(event.target.value) === false
                                ? this.setState({
                                    emailError: (
                                      <small className="text-danger">
                                        Email format should be{" "}
                                        <i>abc@doe.com</i>.
                                      </small>
                                    )
                                  })
                                : this.setState({ emailError: null });
                      }} placeholder="Enter Email" type="email" />
                      {this.state.emailError}
                    </FormGroup>
                      </Col> */}

          {/*                      
                      <Col md={3} sm={3} lg={3} xs={12}>   
                    <FormGroup >
                      <ControlLabel className="fl-w-100">Basket Value </ControlLabel>
                      <FormControl name="basketvalue" className="fl_basket_inpt" disabled="disabled" value={this.state.basketvalue} onChange={this.onChange} placeholder="0.00" type="number" />
                    </FormGroup>
                    </Col>
                    <Col md={3} sm={3} lg={3} xs={12} className="">   
                     <FormGroup  >
                      <ControlLabel className="fl-w-100">Discounted Amount</ControlLabel>
                      <FormControl name="discountamount" type="text" disabled="disabled" onChange={this.onChange} value={this.state.discountamount  }></FormControl>
                    </FormGroup>
                    </Col>
                    <Col md={3} sm={3} lg={3} xs={12}>   
                    <FormGroup >
                    <ControlLabel className="fl-w-100">Delivery Charge </ControlLabel>
                      <FormControl name="deliverycharge" className="fl_delivery_charge_inpt" value={this.state.deliverycharge} onChange={this.onChange} placeholder="0.00" type="number" />
                      {this.state.deliverychargeError}
                    </FormGroup>
                    </Col>
                    <Col md={3} sm={3} lg={3} xs={12}>   
                    <FormGroup>
                      <ControlLabel className="fl-w-100">Total Cost </ControlLabel>
                      
                      <FormControl name="totalcost" className="fl_total_cost_inpt" disabled="disabled" value={this.state.loading ? <LoadingSpinner /> :this.state.totalcost} onChange={event => {
                        this.setState({ totalcost: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              totalcostError: (
                                <small className="text-danger">
                                  Total Cost is required.
                                </small>
                              )
                            })
                          : this.setState({ totalcostError: null });
                      }} placeholder="0.00" type="number" >
                        </FormControl>
                      
                      {this.state.totalcostError}
                    
                    </FormGroup>
                    </Col>
                     */}
        </div>
        <div>
          <OutOfStockModal
            show={this.state.showOutOfStockPop}
            onHide={() => this.setState({ showOutOfStockPop: false })}
            medicationListing={this.state.medicationListing}
          />
        </div>

        {this.state.isCreateAddressModalOpen && (
          <CreateAddressModal
            show={this.state.isCreateAddressModalOpen}
            onHide={() => this.setState({ isCreateAddressModalOpen: false })}
            handleChange={this.handleAddressChange}
            onSubmitAddress={this.onSubmitAddressModal}
            handleInputLocationChange={this.handleInputLocationChange}
            onChange={this.onChange}
            {...this.state}
          />
        )}

        {this.state.isUploadDocumentModalOpen && (
          <DocumentUploadModal
            show={this.state.isUploadDocumentModalOpen}
            onHide={() =>
              this.setState({
                isUploadDocumentModalOpen: false,
                // selectedDocument: [],
                // selectedDocumentType: "",
                documentError: null,
                documentTypeError: null,
              })
            }
            handleDocumentTypeOnChange={this.handleDocumentFileTypeChange}
            uploadDocument={this.uploadDocument}
            handleDocumentFileChange={this.handleDocumentFileChange}
            handleAddDocument={this.handleAddDocument}
            handleRemoveAttachments={this.handleRemoveAttachments}
            {...this.state}
          />
        )}
      </>
    );
  }
}

export default editOrder;
